/*eslint-disable block-scoped-var, id-length, no-control-regex, no-magic-numbers, no-mixed-operators, no-prototype-builtins, no-redeclare, no-shadow, no-var, sort-vars, default-case, jsdoc/require-param*/
import $protobuf from "protobufjs/minimal.js";

// Common aliases
const $Reader = $protobuf.Reader, $Writer = $protobuf.Writer, $util = $protobuf.util;

// Exported root namespace
const $root = $protobuf.roots["default"] || ($protobuf.roots["default"] = {});

export const cqg = $root.cqg = (() => {

    /**
     * Namespace cqg.
     * @exports cqg
     * @namespace
     */
    const cqg = {};

    cqg.ServerMsg = (function() {

        /**
         * Properties of a ServerMsg.
         * @typedef {Object} cqg.ServerMsg.$Properties
         * @property {Array.<cqg.InformationReport.$Properties>|null} [informationReports] ServerMsg informationReports
         * @property {Array.<cqg.OrderStatus.$Properties>|null} [orderStatuses] ServerMsg orderStatuses
         * @property {Array.<cqg.PositionStatus.$Properties>|null} [positionStatuses] ServerMsg positionStatuses
         * @property {Array.<cqg.RealTimeMarketData.$Properties>|null} [realTimeMarketData] ServerMsg realTimeMarketData
         * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding
         */

        /**
         * Properties of a ServerMsg.
         * @memberof cqg
         * @interface IServerMsg
         * @augments cqg.ServerMsg.$Properties
         * @deprecated Use cqg.ServerMsg.$Properties instead.
         */

        /**
         * Shape of a ServerMsg.
         * @typedef {cqg.ServerMsg.$Properties} cqg.ServerMsg.$Shape
         */

        /**
         * Constructs a new ServerMsg.
         * @memberof cqg
         * @classdesc Represents a ServerMsg.
         * @constructor
         * @param {cqg.ServerMsg.$Properties=} [properties] Properties to set
         * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding
         */
        function ServerMsg(properties) {
            this.informationReports = [];
            this.orderStatuses = [];
            this.positionStatuses = [];
            this.realTimeMarketData = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null && keys[i] !== "__proto__")
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ServerMsg informationReports.
         * @member {Array.<cqg.InformationReport.$Properties>} informationReports
         * @memberof cqg.ServerMsg
         * @instance
         */
        ServerMsg.prototype.informationReports = $util.emptyArray;

        /**
         * ServerMsg orderStatuses.
         * @member {Array.<cqg.OrderStatus.$Properties>} orderStatuses
         * @memberof cqg.ServerMsg
         * @instance
         */
        ServerMsg.prototype.orderStatuses = $util.emptyArray;

        /**
         * ServerMsg positionStatuses.
         * @member {Array.<cqg.PositionStatus.$Properties>} positionStatuses
         * @memberof cqg.ServerMsg
         * @instance
         */
        ServerMsg.prototype.positionStatuses = $util.emptyArray;

        /**
         * ServerMsg realTimeMarketData.
         * @member {Array.<cqg.RealTimeMarketData.$Properties>} realTimeMarketData
         * @memberof cqg.ServerMsg
         * @instance
         */
        ServerMsg.prototype.realTimeMarketData = $util.emptyArray;

        /**
         * Creates a new ServerMsg instance using the specified properties.
         * @function create
         * @memberof cqg.ServerMsg
         * @static
         * @param {cqg.ServerMsg.$Properties=} [properties] Properties to set
         * @returns {cqg.ServerMsg} ServerMsg instance
         * @type {{
         *   (properties: cqg.ServerMsg.$Shape): cqg.ServerMsg & cqg.ServerMsg.$Shape;
         *   (properties?: cqg.ServerMsg.$Properties): cqg.ServerMsg;
         * }}
         */
        ServerMsg.create = function create(properties) {
            return new ServerMsg(properties);
        };

        /**
         * Encodes the specified ServerMsg message. Does not implicitly {@link cqg.ServerMsg.verify|verify} messages.
         * @function encode
         * @memberof cqg.ServerMsg
         * @static
         * @param {cqg.ServerMsg.$Properties} message ServerMsg message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ServerMsg.encode = function encode(message, writer, _depth) {
            if (!writer)
                writer = $Writer.create();
            if (_depth === undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw Error("max depth exceeded");
            if (message.informationReports != null && message.informationReports.length)
                for (let i = 0; i < message.informationReports.length; ++i)
                    $root.cqg.InformationReport.encode(message.informationReports[i], writer.uint32(/* id 1, wireType 2 =*/10).fork(), _depth + 1).ldelim();
            if (message.orderStatuses != null && message.orderStatuses.length)
                for (let i = 0; i < message.orderStatuses.length; ++i)
                    $root.cqg.OrderStatus.encode(message.orderStatuses[i], writer.uint32(/* id 5, wireType 2 =*/42).fork(), _depth + 1).ldelim();
            if (message.positionStatuses != null && message.positionStatuses.length)
                for (let i = 0; i < message.positionStatuses.length; ++i)
                    $root.cqg.PositionStatus.encode(message.positionStatuses[i], writer.uint32(/* id 6, wireType 2 =*/50).fork(), _depth + 1).ldelim();
            if (message.realTimeMarketData != null && message.realTimeMarketData.length)
                for (let i = 0; i < message.realTimeMarketData.length; ++i)
                    $root.cqg.RealTimeMarketData.encode(message.realTimeMarketData[i], writer.uint32(/* id 9, wireType 2 =*/74).fork(), _depth + 1).ldelim();
            if (message.$unknowns != null && Object.hasOwnProperty.call(message, "$unknowns"))
                for (let i = 0; i < message.$unknowns.length; ++i)
                    writer.raw(message.$unknowns[i]);
            return writer;
        };

        /**
         * Encodes the specified ServerMsg message, length delimited. Does not implicitly {@link cqg.ServerMsg.verify|verify} messages.
         * @function encodeDelimited
         * @memberof cqg.ServerMsg
         * @static
         * @param {cqg.ServerMsg.$Properties} message ServerMsg message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ServerMsg.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer && writer.len ? writer.fork() : writer).ldelim();
        };

        /**
         * Decodes a ServerMsg message from the specified reader or buffer.
         * @function decode
         * @memberof cqg.ServerMsg
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {cqg.ServerMsg & cqg.ServerMsg.$Shape} ServerMsg
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ServerMsg.decode = function decode(reader, length, _end, _depth, _target) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            if (_depth === undefined)
                _depth = 0;
            if (_depth > $Reader.recursionLimit)
                throw Error("max depth exceeded");
            let end = length === undefined ? reader.len : reader.pos + length, message = _target || new $root.cqg.ServerMsg();
            while (reader.pos < end) {
                let start = reader.pos;
                let tag = reader.tag();
                if (tag === _end) {
                    _end = undefined;
                    break;
                }
                let wireType = tag & 7;
                switch (tag >>>= 3) {
                case 1: {
                        if (wireType !== 2)
                            break;
                        if (!(message.informationReports && message.informationReports.length))
                            message.informationReports = [];
                        message.informationReports.push($root.cqg.InformationReport.decode(reader, reader.uint32(), undefined, _depth + 1));
                        continue;
                    }
                case 5: {
                        if (wireType !== 2)
                            break;
                        if (!(message.orderStatuses && message.orderStatuses.length))
                            message.orderStatuses = [];
                        message.orderStatuses.push($root.cqg.OrderStatus.decode(reader, reader.uint32(), undefined, _depth + 1));
                        continue;
                    }
                case 6: {
                        if (wireType !== 2)
                            break;
                        if (!(message.positionStatuses && message.positionStatuses.length))
                            message.positionStatuses = [];
                        message.positionStatuses.push($root.cqg.PositionStatus.decode(reader, reader.uint32(), undefined, _depth + 1));
                        continue;
                    }
                case 9: {
                        if (wireType !== 2)
                            break;
                        if (!(message.realTimeMarketData && message.realTimeMarketData.length))
                            message.realTimeMarketData = [];
                        message.realTimeMarketData.push($root.cqg.RealTimeMarketData.decode(reader, reader.uint32(), undefined, _depth + 1));
                        continue;
                    }
                }
                reader.skipType(wireType, _depth, tag);
                if (!reader.discardUnknown) {
                    $util.makeProp(message, "$unknowns", false);
                    (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
                }
            }
            if (_end !== undefined)
                throw Error("missing end group");
            return message;
        };

        /**
         * Decodes a ServerMsg message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof cqg.ServerMsg
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {cqg.ServerMsg & cqg.ServerMsg.$Shape} ServerMsg
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ServerMsg.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a ServerMsg message.
         * @function verify
         * @memberof cqg.ServerMsg
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ServerMsg.verify = function verify(message, _depth) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (_depth === undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                return "max depth exceeded";
            if (message.informationReports != null && message.hasOwnProperty("informationReports")) {
                if (!Array.isArray(message.informationReports))
                    return "informationReports: array expected";
                for (let i = 0; i < message.informationReports.length; ++i) {
                    let error = $root.cqg.InformationReport.verify(message.informationReports[i], _depth + 1);
                    if (error)
                        return "informationReports." + error;
                }
            }
            if (message.orderStatuses != null && message.hasOwnProperty("orderStatuses")) {
                if (!Array.isArray(message.orderStatuses))
                    return "orderStatuses: array expected";
                for (let i = 0; i < message.orderStatuses.length; ++i) {
                    let error = $root.cqg.OrderStatus.verify(message.orderStatuses[i], _depth + 1);
                    if (error)
                        return "orderStatuses." + error;
                }
            }
            if (message.positionStatuses != null && message.hasOwnProperty("positionStatuses")) {
                if (!Array.isArray(message.positionStatuses))
                    return "positionStatuses: array expected";
                for (let i = 0; i < message.positionStatuses.length; ++i) {
                    let error = $root.cqg.PositionStatus.verify(message.positionStatuses[i], _depth + 1);
                    if (error)
                        return "positionStatuses." + error;
                }
            }
            if (message.realTimeMarketData != null && message.hasOwnProperty("realTimeMarketData")) {
                if (!Array.isArray(message.realTimeMarketData))
                    return "realTimeMarketData: array expected";
                for (let i = 0; i < message.realTimeMarketData.length; ++i) {
                    let error = $root.cqg.RealTimeMarketData.verify(message.realTimeMarketData[i], _depth + 1);
                    if (error)
                        return "realTimeMarketData." + error;
                }
            }
            return null;
        };

        /**
         * Creates a ServerMsg message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof cqg.ServerMsg
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {cqg.ServerMsg} ServerMsg
         */
        ServerMsg.fromObject = function fromObject(object, _depth) {
            if (object instanceof $root.cqg.ServerMsg)
                return object;
            if (!$util.isObject(object))
                throw TypeError(".cqg.ServerMsg: object expected");
            if (_depth === undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw Error("max depth exceeded");
            let message = new $root.cqg.ServerMsg();
            if (object.informationReports) {
                if (!Array.isArray(object.informationReports))
                    throw TypeError(".cqg.ServerMsg.informationReports: array expected");
                message.informationReports = Array(object.informationReports.length);
                for (let i = 0; i < object.informationReports.length; ++i) {
                    if (!$util.isObject(object.informationReports[i]))
                        throw TypeError(".cqg.ServerMsg.informationReports: object expected");
                    message.informationReports[i] = $root.cqg.InformationReport.fromObject(object.informationReports[i], _depth + 1);
                }
            }
            if (object.orderStatuses) {
                if (!Array.isArray(object.orderStatuses))
                    throw TypeError(".cqg.ServerMsg.orderStatuses: array expected");
                message.orderStatuses = Array(object.orderStatuses.length);
                for (let i = 0; i < object.orderStatuses.length; ++i) {
                    if (!$util.isObject(object.orderStatuses[i]))
                        throw TypeError(".cqg.ServerMsg.orderStatuses: object expected");
                    message.orderStatuses[i] = $root.cqg.OrderStatus.fromObject(object.orderStatuses[i], _depth + 1);
                }
            }
            if (object.positionStatuses) {
                if (!Array.isArray(object.positionStatuses))
                    throw TypeError(".cqg.ServerMsg.positionStatuses: array expected");
                message.positionStatuses = Array(object.positionStatuses.length);
                for (let i = 0; i < object.positionStatuses.length; ++i) {
                    if (!$util.isObject(object.positionStatuses[i]))
                        throw TypeError(".cqg.ServerMsg.positionStatuses: object expected");
                    message.positionStatuses[i] = $root.cqg.PositionStatus.fromObject(object.positionStatuses[i], _depth + 1);
                }
            }
            if (object.realTimeMarketData) {
                if (!Array.isArray(object.realTimeMarketData))
                    throw TypeError(".cqg.ServerMsg.realTimeMarketData: array expected");
                message.realTimeMarketData = Array(object.realTimeMarketData.length);
                for (let i = 0; i < object.realTimeMarketData.length; ++i) {
                    if (!$util.isObject(object.realTimeMarketData[i]))
                        throw TypeError(".cqg.ServerMsg.realTimeMarketData: object expected");
                    message.realTimeMarketData[i] = $root.cqg.RealTimeMarketData.fromObject(object.realTimeMarketData[i], _depth + 1);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a ServerMsg message. Also converts values to other types if specified.
         * @function toObject
         * @memberof cqg.ServerMsg
         * @static
         * @param {cqg.ServerMsg} message ServerMsg
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ServerMsg.toObject = function toObject(message, options, _depth) {
            if (!options)
                options = {};
            if (_depth === undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw Error("max depth exceeded");
            let object = {};
            if (options.arrays || options.defaults) {
                object.informationReports = [];
                object.orderStatuses = [];
                object.positionStatuses = [];
                object.realTimeMarketData = [];
            }
            if (message.informationReports && message.informationReports.length) {
                object.informationReports = Array(message.informationReports.length);
                for (let j = 0; j < message.informationReports.length; ++j)
                    object.informationReports[j] = $root.cqg.InformationReport.toObject(message.informationReports[j], options, _depth + 1);
            }
            if (message.orderStatuses && message.orderStatuses.length) {
                object.orderStatuses = Array(message.orderStatuses.length);
                for (let j = 0; j < message.orderStatuses.length; ++j)
                    object.orderStatuses[j] = $root.cqg.OrderStatus.toObject(message.orderStatuses[j], options, _depth + 1);
            }
            if (message.positionStatuses && message.positionStatuses.length) {
                object.positionStatuses = Array(message.positionStatuses.length);
                for (let j = 0; j < message.positionStatuses.length; ++j)
                    object.positionStatuses[j] = $root.cqg.PositionStatus.toObject(message.positionStatuses[j], options, _depth + 1);
            }
            if (message.realTimeMarketData && message.realTimeMarketData.length) {
                object.realTimeMarketData = Array(message.realTimeMarketData.length);
                for (let j = 0; j < message.realTimeMarketData.length; ++j)
                    object.realTimeMarketData[j] = $root.cqg.RealTimeMarketData.toObject(message.realTimeMarketData[j], options, _depth + 1);
            }
            return object;
        };

        /**
         * Converts this ServerMsg to JSON.
         * @function toJSON
         * @memberof cqg.ServerMsg
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ServerMsg.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the type url for ServerMsg
         * @function getTypeUrl
         * @memberof cqg.ServerMsg
         * @static
         * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
         * @returns {string} The type url
         */
        ServerMsg.getTypeUrl = function getTypeUrl(prefix) {
            if (prefix === undefined)
                prefix = "type.googleapis.com";
            return prefix + "/cqg.ServerMsg";
        };

        return ServerMsg;
    })();

    cqg.InformationReport = (function() {

        /**
         * Properties of an InformationReport.
         * @typedef {Object} cqg.InformationReport.$Properties
         * @property {number|null} [id] InformationReport id
         * @property {number|null} [statusCode] InformationReport statusCode
         * @property {string|null} [textMessage] InformationReport textMessage
         * @property {cqg.SymbolResolutionReport.$Properties|null} [symbolResolutionReport] InformationReport symbolResolutionReport
         * @property {cqg.HistoricalOrdersReport.$Properties|null} [historicalOrdersReport] InformationReport historicalOrdersReport
         * @property {cqg.ContractMetadataReport.$Properties|null} [contractMetadataReport] InformationReport contractMetadataReport
         * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding
         */

        /**
         * Properties of an InformationReport.
         * @memberof cqg
         * @interface IInformationReport
         * @augments cqg.InformationReport.$Properties
         * @deprecated Use cqg.InformationReport.$Properties instead.
         */

        /**
         * Shape of an InformationReport.
         * @typedef {cqg.InformationReport.$Properties} cqg.InformationReport.$Shape
         */

        /**
         * Constructs a new InformationReport.
         * @memberof cqg
         * @classdesc Represents an InformationReport.
         * @constructor
         * @param {cqg.InformationReport.$Properties=} [properties] Properties to set
         * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding
         */
        function InformationReport(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null && keys[i] !== "__proto__")
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * InformationReport id.
         * @member {number} id
         * @memberof cqg.InformationReport
         * @instance
         */
        InformationReport.prototype.id = 0;

        /**
         * InformationReport statusCode.
         * @member {number} statusCode
         * @memberof cqg.InformationReport
         * @instance
         */
        InformationReport.prototype.statusCode = 0;

        /**
         * InformationReport textMessage.
         * @member {string} textMessage
         * @memberof cqg.InformationReport
         * @instance
         */
        InformationReport.prototype.textMessage = "";

        /**
         * InformationReport symbolResolutionReport.
         * @member {cqg.SymbolResolutionReport.$Properties|null|undefined} symbolResolutionReport
         * @memberof cqg.InformationReport
         * @instance
         */
        InformationReport.prototype.symbolResolutionReport = null;

        /**
         * InformationReport historicalOrdersReport.
         * @member {cqg.HistoricalOrdersReport.$Properties|null|undefined} historicalOrdersReport
         * @memberof cqg.InformationReport
         * @instance
         */
        InformationReport.prototype.historicalOrdersReport = null;

        /**
         * InformationReport contractMetadataReport.
         * @member {cqg.ContractMetadataReport.$Properties|null|undefined} contractMetadataReport
         * @memberof cqg.InformationReport
         * @instance
         */
        InformationReport.prototype.contractMetadataReport = null;

        /**
         * Creates a new InformationReport instance using the specified properties.
         * @function create
         * @memberof cqg.InformationReport
         * @static
         * @param {cqg.InformationReport.$Properties=} [properties] Properties to set
         * @returns {cqg.InformationReport} InformationReport instance
         * @type {{
         *   (properties: cqg.InformationReport.$Shape): cqg.InformationReport & cqg.InformationReport.$Shape;
         *   (properties?: cqg.InformationReport.$Properties): cqg.InformationReport;
         * }}
         */
        InformationReport.create = function create(properties) {
            return new InformationReport(properties);
        };

        /**
         * Encodes the specified InformationReport message. Does not implicitly {@link cqg.InformationReport.verify|verify} messages.
         * @function encode
         * @memberof cqg.InformationReport
         * @static
         * @param {cqg.InformationReport.$Properties} message InformationReport message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        InformationReport.encode = function encode(message, writer, _depth) {
            if (!writer)
                writer = $Writer.create();
            if (_depth === undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw Error("max depth exceeded");
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.id);
            if (message.statusCode != null && Object.hasOwnProperty.call(message, "statusCode"))
                writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.statusCode);
            if (message.textMessage != null && Object.hasOwnProperty.call(message, "textMessage"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.textMessage);
            if (message.symbolResolutionReport != null && Object.hasOwnProperty.call(message, "symbolResolutionReport"))
                $root.cqg.SymbolResolutionReport.encode(message.symbolResolutionReport, writer.uint32(/* id 6, wireType 2 =*/50).fork(), _depth + 1).ldelim();
            if (message.historicalOrdersReport != null && Object.hasOwnProperty.call(message, "historicalOrdersReport"))
                $root.cqg.HistoricalOrdersReport.encode(message.historicalOrdersReport, writer.uint32(/* id 15, wireType 2 =*/122).fork(), _depth + 1).ldelim();
            if (message.contractMetadataReport != null && Object.hasOwnProperty.call(message, "contractMetadataReport"))
                $root.cqg.ContractMetadataReport.encode(message.contractMetadataReport, writer.uint32(/* id 27, wireType 2 =*/218).fork(), _depth + 1).ldelim();
            if (message.$unknowns != null && Object.hasOwnProperty.call(message, "$unknowns"))
                for (let i = 0; i < message.$unknowns.length; ++i)
                    writer.raw(message.$unknowns[i]);
            return writer;
        };

        /**
         * Encodes the specified InformationReport message, length delimited. Does not implicitly {@link cqg.InformationReport.verify|verify} messages.
         * @function encodeDelimited
         * @memberof cqg.InformationReport
         * @static
         * @param {cqg.InformationReport.$Properties} message InformationReport message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        InformationReport.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer && writer.len ? writer.fork() : writer).ldelim();
        };

        /**
         * Decodes an InformationReport message from the specified reader or buffer.
         * @function decode
         * @memberof cqg.InformationReport
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {cqg.InformationReport & cqg.InformationReport.$Shape} InformationReport
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        InformationReport.decode = function decode(reader, length, _end, _depth, _target) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            if (_depth === undefined)
                _depth = 0;
            if (_depth > $Reader.recursionLimit)
                throw Error("max depth exceeded");
            let end = length === undefined ? reader.len : reader.pos + length, message = _target || new $root.cqg.InformationReport(), value;
            while (reader.pos < end) {
                let start = reader.pos;
                let tag = reader.tag();
                if (tag === _end) {
                    _end = undefined;
                    break;
                }
                let wireType = tag & 7;
                switch (tag >>>= 3) {
                case 1: {
                        if (wireType !== 0)
                            break;
                        if (value = reader.uint32())
                            message.id = value;
                        else
                            delete message.id;
                        continue;
                    }
                case 3: {
                        if (wireType !== 0)
                            break;
                        if (value = reader.uint32())
                            message.statusCode = value;
                        else
                            delete message.statusCode;
                        continue;
                    }
                case 4: {
                        if (wireType !== 2)
                            break;
                        if ((value = reader.string()).length)
                            message.textMessage = value;
                        else
                            delete message.textMessage;
                        continue;
                    }
                case 6: {
                        if (wireType !== 2)
                            break;
                        message.symbolResolutionReport = $root.cqg.SymbolResolutionReport.decode(reader, reader.uint32(), undefined, _depth + 1, message.symbolResolutionReport);
                        continue;
                    }
                case 15: {
                        if (wireType !== 2)
                            break;
                        message.historicalOrdersReport = $root.cqg.HistoricalOrdersReport.decode(reader, reader.uint32(), undefined, _depth + 1, message.historicalOrdersReport);
                        continue;
                    }
                case 27: {
                        if (wireType !== 2)
                            break;
                        message.contractMetadataReport = $root.cqg.ContractMetadataReport.decode(reader, reader.uint32(), undefined, _depth + 1, message.contractMetadataReport);
                        continue;
                    }
                }
                reader.skipType(wireType, _depth, tag);
                if (!reader.discardUnknown) {
                    $util.makeProp(message, "$unknowns", false);
                    (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
                }
            }
            if (_end !== undefined)
                throw Error("missing end group");
            return message;
        };

        /**
         * Decodes an InformationReport message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof cqg.InformationReport
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {cqg.InformationReport & cqg.InformationReport.$Shape} InformationReport
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        InformationReport.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an InformationReport message.
         * @function verify
         * @memberof cqg.InformationReport
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        InformationReport.verify = function verify(message, _depth) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (_depth === undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                return "max depth exceeded";
            if (message.id != null && message.hasOwnProperty("id"))
                if (!$util.isInteger(message.id))
                    return "id: integer expected";
            if (message.statusCode != null && message.hasOwnProperty("statusCode"))
                if (!$util.isInteger(message.statusCode))
                    return "statusCode: integer expected";
            if (message.textMessage != null && message.hasOwnProperty("textMessage"))
                if (!$util.isString(message.textMessage))
                    return "textMessage: string expected";
            if (message.symbolResolutionReport != null && message.hasOwnProperty("symbolResolutionReport")) {
                let error = $root.cqg.SymbolResolutionReport.verify(message.symbolResolutionReport, _depth + 1);
                if (error)
                    return "symbolResolutionReport." + error;
            }
            if (message.historicalOrdersReport != null && message.hasOwnProperty("historicalOrdersReport")) {
                let error = $root.cqg.HistoricalOrdersReport.verify(message.historicalOrdersReport, _depth + 1);
                if (error)
                    return "historicalOrdersReport." + error;
            }
            if (message.contractMetadataReport != null && message.hasOwnProperty("contractMetadataReport")) {
                let error = $root.cqg.ContractMetadataReport.verify(message.contractMetadataReport, _depth + 1);
                if (error)
                    return "contractMetadataReport." + error;
            }
            return null;
        };

        /**
         * Creates an InformationReport message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof cqg.InformationReport
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {cqg.InformationReport} InformationReport
         */
        InformationReport.fromObject = function fromObject(object, _depth) {
            if (object instanceof $root.cqg.InformationReport)
                return object;
            if (!$util.isObject(object))
                throw TypeError(".cqg.InformationReport: object expected");
            if (_depth === undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw Error("max depth exceeded");
            let message = new $root.cqg.InformationReport();
            if (object.id != null)
                if (Number(object.id) !== 0)
                    message.id = object.id >>> 0;
            if (object.statusCode != null)
                if (Number(object.statusCode) !== 0)
                    message.statusCode = object.statusCode >>> 0;
            if (object.textMessage != null)
                if (typeof object.textMessage !== "string" || object.textMessage.length)
                    message.textMessage = String(object.textMessage);
            if (object.symbolResolutionReport != null) {
                if (!$util.isObject(object.symbolResolutionReport))
                    throw TypeError(".cqg.InformationReport.symbolResolutionReport: object expected");
                message.symbolResolutionReport = $root.cqg.SymbolResolutionReport.fromObject(object.symbolResolutionReport, _depth + 1);
            }
            if (object.historicalOrdersReport != null) {
                if (!$util.isObject(object.historicalOrdersReport))
                    throw TypeError(".cqg.InformationReport.historicalOrdersReport: object expected");
                message.historicalOrdersReport = $root.cqg.HistoricalOrdersReport.fromObject(object.historicalOrdersReport, _depth + 1);
            }
            if (object.contractMetadataReport != null) {
                if (!$util.isObject(object.contractMetadataReport))
                    throw TypeError(".cqg.InformationReport.contractMetadataReport: object expected");
                message.contractMetadataReport = $root.cqg.ContractMetadataReport.fromObject(object.contractMetadataReport, _depth + 1);
            }
            return message;
        };

        /**
         * Creates a plain object from an InformationReport message. Also converts values to other types if specified.
         * @function toObject
         * @memberof cqg.InformationReport
         * @static
         * @param {cqg.InformationReport} message InformationReport
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        InformationReport.toObject = function toObject(message, options, _depth) {
            if (!options)
                options = {};
            if (_depth === undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw Error("max depth exceeded");
            let object = {};
            if (options.defaults) {
                object.id = 0;
                object.statusCode = 0;
                object.textMessage = "";
                object.symbolResolutionReport = null;
                object.historicalOrdersReport = null;
                object.contractMetadataReport = null;
            }
            if (message.id != null && message.hasOwnProperty("id"))
                object.id = message.id;
            if (message.statusCode != null && message.hasOwnProperty("statusCode"))
                object.statusCode = message.statusCode;
            if (message.textMessage != null && message.hasOwnProperty("textMessage"))
                object.textMessage = message.textMessage;
            if (message.symbolResolutionReport != null && message.hasOwnProperty("symbolResolutionReport"))
                object.symbolResolutionReport = $root.cqg.SymbolResolutionReport.toObject(message.symbolResolutionReport, options, _depth + 1);
            if (message.historicalOrdersReport != null && message.hasOwnProperty("historicalOrdersReport"))
                object.historicalOrdersReport = $root.cqg.HistoricalOrdersReport.toObject(message.historicalOrdersReport, options, _depth + 1);
            if (message.contractMetadataReport != null && message.hasOwnProperty("contractMetadataReport"))
                object.contractMetadataReport = $root.cqg.ContractMetadataReport.toObject(message.contractMetadataReport, options, _depth + 1);
            return object;
        };

        /**
         * Converts this InformationReport to JSON.
         * @function toJSON
         * @memberof cqg.InformationReport
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        InformationReport.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the type url for InformationReport
         * @function getTypeUrl
         * @memberof cqg.InformationReport
         * @static
         * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
         * @returns {string} The type url
         */
        InformationReport.getTypeUrl = function getTypeUrl(prefix) {
            if (prefix === undefined)
                prefix = "type.googleapis.com";
            return prefix + "/cqg.InformationReport";
        };

        return InformationReport;
    })();

    cqg.SymbolResolutionReport = (function() {

        /**
         * Properties of a SymbolResolutionReport.
         * @typedef {Object} cqg.SymbolResolutionReport.$Properties
         * @property {cqg.ContractMetadata.$Properties|null} [contractMetadata] SymbolResolutionReport contractMetadata
         * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding
         */

        /**
         * Properties of a SymbolResolutionReport.
         * @memberof cqg
         * @interface ISymbolResolutionReport
         * @augments cqg.SymbolResolutionReport.$Properties
         * @deprecated Use cqg.SymbolResolutionReport.$Properties instead.
         */

        /**
         * Shape of a SymbolResolutionReport.
         * @typedef {cqg.SymbolResolutionReport.$Properties} cqg.SymbolResolutionReport.$Shape
         */

        /**
         * Constructs a new SymbolResolutionReport.
         * @memberof cqg
         * @classdesc Represents a SymbolResolutionReport.
         * @constructor
         * @param {cqg.SymbolResolutionReport.$Properties=} [properties] Properties to set
         * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding
         */
        function SymbolResolutionReport(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null && keys[i] !== "__proto__")
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * SymbolResolutionReport contractMetadata.
         * @member {cqg.ContractMetadata.$Properties|null|undefined} contractMetadata
         * @memberof cqg.SymbolResolutionReport
         * @instance
         */
        SymbolResolutionReport.prototype.contractMetadata = null;

        /**
         * Creates a new SymbolResolutionReport instance using the specified properties.
         * @function create
         * @memberof cqg.SymbolResolutionReport
         * @static
         * @param {cqg.SymbolResolutionReport.$Properties=} [properties] Properties to set
         * @returns {cqg.SymbolResolutionReport} SymbolResolutionReport instance
         * @type {{
         *   (properties: cqg.SymbolResolutionReport.$Shape): cqg.SymbolResolutionReport & cqg.SymbolResolutionReport.$Shape;
         *   (properties?: cqg.SymbolResolutionReport.$Properties): cqg.SymbolResolutionReport;
         * }}
         */
        SymbolResolutionReport.create = function create(properties) {
            return new SymbolResolutionReport(properties);
        };

        /**
         * Encodes the specified SymbolResolutionReport message. Does not implicitly {@link cqg.SymbolResolutionReport.verify|verify} messages.
         * @function encode
         * @memberof cqg.SymbolResolutionReport
         * @static
         * @param {cqg.SymbolResolutionReport.$Properties} message SymbolResolutionReport message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SymbolResolutionReport.encode = function encode(message, writer, _depth) {
            if (!writer)
                writer = $Writer.create();
            if (_depth === undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw Error("max depth exceeded");
            if (message.contractMetadata != null && Object.hasOwnProperty.call(message, "contractMetadata"))
                $root.cqg.ContractMetadata.encode(message.contractMetadata, writer.uint32(/* id 1, wireType 2 =*/10).fork(), _depth + 1).ldelim();
            if (message.$unknowns != null && Object.hasOwnProperty.call(message, "$unknowns"))
                for (let i = 0; i < message.$unknowns.length; ++i)
                    writer.raw(message.$unknowns[i]);
            return writer;
        };

        /**
         * Encodes the specified SymbolResolutionReport message, length delimited. Does not implicitly {@link cqg.SymbolResolutionReport.verify|verify} messages.
         * @function encodeDelimited
         * @memberof cqg.SymbolResolutionReport
         * @static
         * @param {cqg.SymbolResolutionReport.$Properties} message SymbolResolutionReport message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SymbolResolutionReport.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer && writer.len ? writer.fork() : writer).ldelim();
        };

        /**
         * Decodes a SymbolResolutionReport message from the specified reader or buffer.
         * @function decode
         * @memberof cqg.SymbolResolutionReport
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {cqg.SymbolResolutionReport & cqg.SymbolResolutionReport.$Shape} SymbolResolutionReport
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SymbolResolutionReport.decode = function decode(reader, length, _end, _depth, _target) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            if (_depth === undefined)
                _depth = 0;
            if (_depth > $Reader.recursionLimit)
                throw Error("max depth exceeded");
            let end = length === undefined ? reader.len : reader.pos + length, message = _target || new $root.cqg.SymbolResolutionReport(), value;
            while (reader.pos < end) {
                let start = reader.pos;
                let tag = reader.tag();
                if (tag === _end) {
                    _end = undefined;
                    break;
                }
                let wireType = tag & 7;
                switch (tag >>>= 3) {
                case 1: {
                        if (wireType !== 2)
                            break;
                        message.contractMetadata = $root.cqg.ContractMetadata.decode(reader, reader.uint32(), undefined, _depth + 1, message.contractMetadata);
                        continue;
                    }
                }
                reader.skipType(wireType, _depth, tag);
                if (!reader.discardUnknown) {
                    $util.makeProp(message, "$unknowns", false);
                    (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
                }
            }
            if (_end !== undefined)
                throw Error("missing end group");
            return message;
        };

        /**
         * Decodes a SymbolResolutionReport message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof cqg.SymbolResolutionReport
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {cqg.SymbolResolutionReport & cqg.SymbolResolutionReport.$Shape} SymbolResolutionReport
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SymbolResolutionReport.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a SymbolResolutionReport message.
         * @function verify
         * @memberof cqg.SymbolResolutionReport
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        SymbolResolutionReport.verify = function verify(message, _depth) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (_depth === undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                return "max depth exceeded";
            if (message.contractMetadata != null && message.hasOwnProperty("contractMetadata")) {
                let error = $root.cqg.ContractMetadata.verify(message.contractMetadata, _depth + 1);
                if (error)
                    return "contractMetadata." + error;
            }
            return null;
        };

        /**
         * Creates a SymbolResolutionReport message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof cqg.SymbolResolutionReport
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {cqg.SymbolResolutionReport} SymbolResolutionReport
         */
        SymbolResolutionReport.fromObject = function fromObject(object, _depth) {
            if (object instanceof $root.cqg.SymbolResolutionReport)
                return object;
            if (!$util.isObject(object))
                throw TypeError(".cqg.SymbolResolutionReport: object expected");
            if (_depth === undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw Error("max depth exceeded");
            let message = new $root.cqg.SymbolResolutionReport();
            if (object.contractMetadata != null) {
                if (!$util.isObject(object.contractMetadata))
                    throw TypeError(".cqg.SymbolResolutionReport.contractMetadata: object expected");
                message.contractMetadata = $root.cqg.ContractMetadata.fromObject(object.contractMetadata, _depth + 1);
            }
            return message;
        };

        /**
         * Creates a plain object from a SymbolResolutionReport message. Also converts values to other types if specified.
         * @function toObject
         * @memberof cqg.SymbolResolutionReport
         * @static
         * @param {cqg.SymbolResolutionReport} message SymbolResolutionReport
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        SymbolResolutionReport.toObject = function toObject(message, options, _depth) {
            if (!options)
                options = {};
            if (_depth === undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw Error("max depth exceeded");
            let object = {};
            if (options.defaults)
                object.contractMetadata = null;
            if (message.contractMetadata != null && message.hasOwnProperty("contractMetadata"))
                object.contractMetadata = $root.cqg.ContractMetadata.toObject(message.contractMetadata, options, _depth + 1);
            return object;
        };

        /**
         * Converts this SymbolResolutionReport to JSON.
         * @function toJSON
         * @memberof cqg.SymbolResolutionReport
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        SymbolResolutionReport.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the type url for SymbolResolutionReport
         * @function getTypeUrl
         * @memberof cqg.SymbolResolutionReport
         * @static
         * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
         * @returns {string} The type url
         */
        SymbolResolutionReport.getTypeUrl = function getTypeUrl(prefix) {
            if (prefix === undefined)
                prefix = "type.googleapis.com";
            return prefix + "/cqg.SymbolResolutionReport";
        };

        return SymbolResolutionReport;
    })();

    cqg.ContractMetadataReport = (function() {

        /**
         * Properties of a ContractMetadataReport.
         * @typedef {Object} cqg.ContractMetadataReport.$Properties
         * @property {cqg.ContractMetadata.$Properties|null} [contractMetadata] ContractMetadataReport contractMetadata
         * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding
         */

        /**
         * Properties of a ContractMetadataReport.
         * @memberof cqg
         * @interface IContractMetadataReport
         * @augments cqg.ContractMetadataReport.$Properties
         * @deprecated Use cqg.ContractMetadataReport.$Properties instead.
         */

        /**
         * Shape of a ContractMetadataReport.
         * @typedef {cqg.ContractMetadataReport.$Properties} cqg.ContractMetadataReport.$Shape
         */

        /**
         * Constructs a new ContractMetadataReport.
         * @memberof cqg
         * @classdesc Represents a ContractMetadataReport.
         * @constructor
         * @param {cqg.ContractMetadataReport.$Properties=} [properties] Properties to set
         * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding
         */
        function ContractMetadataReport(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null && keys[i] !== "__proto__")
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ContractMetadataReport contractMetadata.
         * @member {cqg.ContractMetadata.$Properties|null|undefined} contractMetadata
         * @memberof cqg.ContractMetadataReport
         * @instance
         */
        ContractMetadataReport.prototype.contractMetadata = null;

        /**
         * Creates a new ContractMetadataReport instance using the specified properties.
         * @function create
         * @memberof cqg.ContractMetadataReport
         * @static
         * @param {cqg.ContractMetadataReport.$Properties=} [properties] Properties to set
         * @returns {cqg.ContractMetadataReport} ContractMetadataReport instance
         * @type {{
         *   (properties: cqg.ContractMetadataReport.$Shape): cqg.ContractMetadataReport & cqg.ContractMetadataReport.$Shape;
         *   (properties?: cqg.ContractMetadataReport.$Properties): cqg.ContractMetadataReport;
         * }}
         */
        ContractMetadataReport.create = function create(properties) {
            return new ContractMetadataReport(properties);
        };

        /**
         * Encodes the specified ContractMetadataReport message. Does not implicitly {@link cqg.ContractMetadataReport.verify|verify} messages.
         * @function encode
         * @memberof cqg.ContractMetadataReport
         * @static
         * @param {cqg.ContractMetadataReport.$Properties} message ContractMetadataReport message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ContractMetadataReport.encode = function encode(message, writer, _depth) {
            if (!writer)
                writer = $Writer.create();
            if (_depth === undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw Error("max depth exceeded");
            if (message.contractMetadata != null && Object.hasOwnProperty.call(message, "contractMetadata"))
                $root.cqg.ContractMetadata.encode(message.contractMetadata, writer.uint32(/* id 1, wireType 2 =*/10).fork(), _depth + 1).ldelim();
            if (message.$unknowns != null && Object.hasOwnProperty.call(message, "$unknowns"))
                for (let i = 0; i < message.$unknowns.length; ++i)
                    writer.raw(message.$unknowns[i]);
            return writer;
        };

        /**
         * Encodes the specified ContractMetadataReport message, length delimited. Does not implicitly {@link cqg.ContractMetadataReport.verify|verify} messages.
         * @function encodeDelimited
         * @memberof cqg.ContractMetadataReport
         * @static
         * @param {cqg.ContractMetadataReport.$Properties} message ContractMetadataReport message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ContractMetadataReport.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer && writer.len ? writer.fork() : writer).ldelim();
        };

        /**
         * Decodes a ContractMetadataReport message from the specified reader or buffer.
         * @function decode
         * @memberof cqg.ContractMetadataReport
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {cqg.ContractMetadataReport & cqg.ContractMetadataReport.$Shape} ContractMetadataReport
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ContractMetadataReport.decode = function decode(reader, length, _end, _depth, _target) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            if (_depth === undefined)
                _depth = 0;
            if (_depth > $Reader.recursionLimit)
                throw Error("max depth exceeded");
            let end = length === undefined ? reader.len : reader.pos + length, message = _target || new $root.cqg.ContractMetadataReport(), value;
            while (reader.pos < end) {
                let start = reader.pos;
                let tag = reader.tag();
                if (tag === _end) {
                    _end = undefined;
                    break;
                }
                let wireType = tag & 7;
                switch (tag >>>= 3) {
                case 1: {
                        if (wireType !== 2)
                            break;
                        message.contractMetadata = $root.cqg.ContractMetadata.decode(reader, reader.uint32(), undefined, _depth + 1, message.contractMetadata);
                        continue;
                    }
                }
                reader.skipType(wireType, _depth, tag);
                if (!reader.discardUnknown) {
                    $util.makeProp(message, "$unknowns", false);
                    (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
                }
            }
            if (_end !== undefined)
                throw Error("missing end group");
            return message;
        };

        /**
         * Decodes a ContractMetadataReport message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof cqg.ContractMetadataReport
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {cqg.ContractMetadataReport & cqg.ContractMetadataReport.$Shape} ContractMetadataReport
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ContractMetadataReport.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a ContractMetadataReport message.
         * @function verify
         * @memberof cqg.ContractMetadataReport
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ContractMetadataReport.verify = function verify(message, _depth) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (_depth === undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                return "max depth exceeded";
            if (message.contractMetadata != null && message.hasOwnProperty("contractMetadata")) {
                let error = $root.cqg.ContractMetadata.verify(message.contractMetadata, _depth + 1);
                if (error)
                    return "contractMetadata." + error;
            }
            return null;
        };

        /**
         * Creates a ContractMetadataReport message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof cqg.ContractMetadataReport
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {cqg.ContractMetadataReport} ContractMetadataReport
         */
        ContractMetadataReport.fromObject = function fromObject(object, _depth) {
            if (object instanceof $root.cqg.ContractMetadataReport)
                return object;
            if (!$util.isObject(object))
                throw TypeError(".cqg.ContractMetadataReport: object expected");
            if (_depth === undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw Error("max depth exceeded");
            let message = new $root.cqg.ContractMetadataReport();
            if (object.contractMetadata != null) {
                if (!$util.isObject(object.contractMetadata))
                    throw TypeError(".cqg.ContractMetadataReport.contractMetadata: object expected");
                message.contractMetadata = $root.cqg.ContractMetadata.fromObject(object.contractMetadata, _depth + 1);
            }
            return message;
        };

        /**
         * Creates a plain object from a ContractMetadataReport message. Also converts values to other types if specified.
         * @function toObject
         * @memberof cqg.ContractMetadataReport
         * @static
         * @param {cqg.ContractMetadataReport} message ContractMetadataReport
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ContractMetadataReport.toObject = function toObject(message, options, _depth) {
            if (!options)
                options = {};
            if (_depth === undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw Error("max depth exceeded");
            let object = {};
            if (options.defaults)
                object.contractMetadata = null;
            if (message.contractMetadata != null && message.hasOwnProperty("contractMetadata"))
                object.contractMetadata = $root.cqg.ContractMetadata.toObject(message.contractMetadata, options, _depth + 1);
            return object;
        };

        /**
         * Converts this ContractMetadataReport to JSON.
         * @function toJSON
         * @memberof cqg.ContractMetadataReport
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ContractMetadataReport.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the type url for ContractMetadataReport
         * @function getTypeUrl
         * @memberof cqg.ContractMetadataReport
         * @static
         * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
         * @returns {string} The type url
         */
        ContractMetadataReport.getTypeUrl = function getTypeUrl(prefix) {
            if (prefix === undefined)
                prefix = "type.googleapis.com";
            return prefix + "/cqg.ContractMetadataReport";
        };

        return ContractMetadataReport;
    })();

    cqg.HistoricalOrdersReport = (function() {

        /**
         * Properties of a HistoricalOrdersReport.
         * @typedef {Object} cqg.HistoricalOrdersReport.$Properties
         * @property {Array.<cqg.OrderStatus.$Properties>|null} [orderStatuses] HistoricalOrdersReport orderStatuses
         * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding
         */

        /**
         * Properties of a HistoricalOrdersReport.
         * @memberof cqg
         * @interface IHistoricalOrdersReport
         * @augments cqg.HistoricalOrdersReport.$Properties
         * @deprecated Use cqg.HistoricalOrdersReport.$Properties instead.
         */

        /**
         * Shape of a HistoricalOrdersReport.
         * @typedef {cqg.HistoricalOrdersReport.$Properties} cqg.HistoricalOrdersReport.$Shape
         */

        /**
         * Constructs a new HistoricalOrdersReport.
         * @memberof cqg
         * @classdesc Represents a HistoricalOrdersReport.
         * @constructor
         * @param {cqg.HistoricalOrdersReport.$Properties=} [properties] Properties to set
         * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding
         */
        function HistoricalOrdersReport(properties) {
            this.orderStatuses = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null && keys[i] !== "__proto__")
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * HistoricalOrdersReport orderStatuses.
         * @member {Array.<cqg.OrderStatus.$Properties>} orderStatuses
         * @memberof cqg.HistoricalOrdersReport
         * @instance
         */
        HistoricalOrdersReport.prototype.orderStatuses = $util.emptyArray;

        /**
         * Creates a new HistoricalOrdersReport instance using the specified properties.
         * @function create
         * @memberof cqg.HistoricalOrdersReport
         * @static
         * @param {cqg.HistoricalOrdersReport.$Properties=} [properties] Properties to set
         * @returns {cqg.HistoricalOrdersReport} HistoricalOrdersReport instance
         * @type {{
         *   (properties: cqg.HistoricalOrdersReport.$Shape): cqg.HistoricalOrdersReport & cqg.HistoricalOrdersReport.$Shape;
         *   (properties?: cqg.HistoricalOrdersReport.$Properties): cqg.HistoricalOrdersReport;
         * }}
         */
        HistoricalOrdersReport.create = function create(properties) {
            return new HistoricalOrdersReport(properties);
        };

        /**
         * Encodes the specified HistoricalOrdersReport message. Does not implicitly {@link cqg.HistoricalOrdersReport.verify|verify} messages.
         * @function encode
         * @memberof cqg.HistoricalOrdersReport
         * @static
         * @param {cqg.HistoricalOrdersReport.$Properties} message HistoricalOrdersReport message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        HistoricalOrdersReport.encode = function encode(message, writer, _depth) {
            if (!writer)
                writer = $Writer.create();
            if (_depth === undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw Error("max depth exceeded");
            if (message.orderStatuses != null && message.orderStatuses.length)
                for (let i = 0; i < message.orderStatuses.length; ++i)
                    $root.cqg.OrderStatus.encode(message.orderStatuses[i], writer.uint32(/* id 1, wireType 2 =*/10).fork(), _depth + 1).ldelim();
            if (message.$unknowns != null && Object.hasOwnProperty.call(message, "$unknowns"))
                for (let i = 0; i < message.$unknowns.length; ++i)
                    writer.raw(message.$unknowns[i]);
            return writer;
        };

        /**
         * Encodes the specified HistoricalOrdersReport message, length delimited. Does not implicitly {@link cqg.HistoricalOrdersReport.verify|verify} messages.
         * @function encodeDelimited
         * @memberof cqg.HistoricalOrdersReport
         * @static
         * @param {cqg.HistoricalOrdersReport.$Properties} message HistoricalOrdersReport message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        HistoricalOrdersReport.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer && writer.len ? writer.fork() : writer).ldelim();
        };

        /**
         * Decodes a HistoricalOrdersReport message from the specified reader or buffer.
         * @function decode
         * @memberof cqg.HistoricalOrdersReport
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {cqg.HistoricalOrdersReport & cqg.HistoricalOrdersReport.$Shape} HistoricalOrdersReport
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        HistoricalOrdersReport.decode = function decode(reader, length, _end, _depth, _target) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            if (_depth === undefined)
                _depth = 0;
            if (_depth > $Reader.recursionLimit)
                throw Error("max depth exceeded");
            let end = length === undefined ? reader.len : reader.pos + length, message = _target || new $root.cqg.HistoricalOrdersReport();
            while (reader.pos < end) {
                let start = reader.pos;
                let tag = reader.tag();
                if (tag === _end) {
                    _end = undefined;
                    break;
                }
                let wireType = tag & 7;
                switch (tag >>>= 3) {
                case 1: {
                        if (wireType !== 2)
                            break;
                        if (!(message.orderStatuses && message.orderStatuses.length))
                            message.orderStatuses = [];
                        message.orderStatuses.push($root.cqg.OrderStatus.decode(reader, reader.uint32(), undefined, _depth + 1));
                        continue;
                    }
                }
                reader.skipType(wireType, _depth, tag);
                if (!reader.discardUnknown) {
                    $util.makeProp(message, "$unknowns", false);
                    (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
                }
            }
            if (_end !== undefined)
                throw Error("missing end group");
            return message;
        };

        /**
         * Decodes a HistoricalOrdersReport message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof cqg.HistoricalOrdersReport
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {cqg.HistoricalOrdersReport & cqg.HistoricalOrdersReport.$Shape} HistoricalOrdersReport
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        HistoricalOrdersReport.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a HistoricalOrdersReport message.
         * @function verify
         * @memberof cqg.HistoricalOrdersReport
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        HistoricalOrdersReport.verify = function verify(message, _depth) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (_depth === undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                return "max depth exceeded";
            if (message.orderStatuses != null && message.hasOwnProperty("orderStatuses")) {
                if (!Array.isArray(message.orderStatuses))
                    return "orderStatuses: array expected";
                for (let i = 0; i < message.orderStatuses.length; ++i) {
                    let error = $root.cqg.OrderStatus.verify(message.orderStatuses[i], _depth + 1);
                    if (error)
                        return "orderStatuses." + error;
                }
            }
            return null;
        };

        /**
         * Creates a HistoricalOrdersReport message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof cqg.HistoricalOrdersReport
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {cqg.HistoricalOrdersReport} HistoricalOrdersReport
         */
        HistoricalOrdersReport.fromObject = function fromObject(object, _depth) {
            if (object instanceof $root.cqg.HistoricalOrdersReport)
                return object;
            if (!$util.isObject(object))
                throw TypeError(".cqg.HistoricalOrdersReport: object expected");
            if (_depth === undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw Error("max depth exceeded");
            let message = new $root.cqg.HistoricalOrdersReport();
            if (object.orderStatuses) {
                if (!Array.isArray(object.orderStatuses))
                    throw TypeError(".cqg.HistoricalOrdersReport.orderStatuses: array expected");
                message.orderStatuses = Array(object.orderStatuses.length);
                for (let i = 0; i < object.orderStatuses.length; ++i) {
                    if (!$util.isObject(object.orderStatuses[i]))
                        throw TypeError(".cqg.HistoricalOrdersReport.orderStatuses: object expected");
                    message.orderStatuses[i] = $root.cqg.OrderStatus.fromObject(object.orderStatuses[i], _depth + 1);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a HistoricalOrdersReport message. Also converts values to other types if specified.
         * @function toObject
         * @memberof cqg.HistoricalOrdersReport
         * @static
         * @param {cqg.HistoricalOrdersReport} message HistoricalOrdersReport
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        HistoricalOrdersReport.toObject = function toObject(message, options, _depth) {
            if (!options)
                options = {};
            if (_depth === undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw Error("max depth exceeded");
            let object = {};
            if (options.arrays || options.defaults)
                object.orderStatuses = [];
            if (message.orderStatuses && message.orderStatuses.length) {
                object.orderStatuses = Array(message.orderStatuses.length);
                for (let j = 0; j < message.orderStatuses.length; ++j)
                    object.orderStatuses[j] = $root.cqg.OrderStatus.toObject(message.orderStatuses[j], options, _depth + 1);
            }
            return object;
        };

        /**
         * Converts this HistoricalOrdersReport to JSON.
         * @function toJSON
         * @memberof cqg.HistoricalOrdersReport
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        HistoricalOrdersReport.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the type url for HistoricalOrdersReport
         * @function getTypeUrl
         * @memberof cqg.HistoricalOrdersReport
         * @static
         * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
         * @returns {string} The type url
         */
        HistoricalOrdersReport.getTypeUrl = function getTypeUrl(prefix) {
            if (prefix === undefined)
                prefix = "type.googleapis.com";
            return prefix + "/cqg.HistoricalOrdersReport";
        };

        return HistoricalOrdersReport;
    })();

    cqg.OrderStatus = (function() {

        /**
         * Properties of an OrderStatus.
         * @typedef {Object} cqg.OrderStatus.$Properties
         * @property {number|null} [status] OrderStatus status
         * @property {string|null} [orderId] OrderStatus orderId
         * @property {cqg.Order.$Properties|null} [order] OrderStatus order
         * @property {Array.<cqg.TransactionStatus.$Properties>|null} [transactionStatuses] OrderStatus transactionStatuses
         * @property {Array.<cqg.ContractMetadata.$Properties>|null} [contractMetadata] OrderStatus contractMetadata
         * @property {number|null} [accountId] OrderStatus accountId
         * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding
         */

        /**
         * Properties of an OrderStatus.
         * @memberof cqg
         * @interface IOrderStatus
         * @augments cqg.OrderStatus.$Properties
         * @deprecated Use cqg.OrderStatus.$Properties instead.
         */

        /**
         * Shape of an OrderStatus.
         * @typedef {cqg.OrderStatus.$Properties} cqg.OrderStatus.$Shape
         */

        /**
         * Constructs a new OrderStatus.
         * @memberof cqg
         * @classdesc Represents an OrderStatus.
         * @constructor
         * @param {cqg.OrderStatus.$Properties=} [properties] Properties to set
         * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding
         */
        function OrderStatus(properties) {
            this.transactionStatuses = [];
            this.contractMetadata = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null && keys[i] !== "__proto__")
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * OrderStatus status.
         * @member {number} status
         * @memberof cqg.OrderStatus
         * @instance
         */
        OrderStatus.prototype.status = 0;

        /**
         * OrderStatus orderId.
         * @member {string} orderId
         * @memberof cqg.OrderStatus
         * @instance
         */
        OrderStatus.prototype.orderId = "";

        /**
         * OrderStatus order.
         * @member {cqg.Order.$Properties|null|undefined} order
         * @memberof cqg.OrderStatus
         * @instance
         */
        OrderStatus.prototype.order = null;

        /**
         * OrderStatus transactionStatuses.
         * @member {Array.<cqg.TransactionStatus.$Properties>} transactionStatuses
         * @memberof cqg.OrderStatus
         * @instance
         */
        OrderStatus.prototype.transactionStatuses = $util.emptyArray;

        /**
         * OrderStatus contractMetadata.
         * @member {Array.<cqg.ContractMetadata.$Properties>} contractMetadata
         * @memberof cqg.OrderStatus
         * @instance
         */
        OrderStatus.prototype.contractMetadata = $util.emptyArray;

        /**
         * OrderStatus accountId.
         * @member {number} accountId
         * @memberof cqg.OrderStatus
         * @instance
         */
        OrderStatus.prototype.accountId = 0;

        /**
         * Creates a new OrderStatus instance using the specified properties.
         * @function create
         * @memberof cqg.OrderStatus
         * @static
         * @param {cqg.OrderStatus.$Properties=} [properties] Properties to set
         * @returns {cqg.OrderStatus} OrderStatus instance
         * @type {{
         *   (properties: cqg.OrderStatus.$Shape): cqg.OrderStatus & cqg.OrderStatus.$Shape;
         *   (properties?: cqg.OrderStatus.$Properties): cqg.OrderStatus;
         * }}
         */
        OrderStatus.create = function create(properties) {
            return new OrderStatus(properties);
        };

        /**
         * Encodes the specified OrderStatus message. Does not implicitly {@link cqg.OrderStatus.verify|verify} messages.
         * @function encode
         * @memberof cqg.OrderStatus
         * @static
         * @param {cqg.OrderStatus.$Properties} message OrderStatus message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        OrderStatus.encode = function encode(message, writer, _depth) {
            if (!writer)
                writer = $Writer.create();
            if (_depth === undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw Error("max depth exceeded");
            if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.status);
            if (message.orderId != null && Object.hasOwnProperty.call(message, "orderId"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.orderId);
            if (message.order != null && Object.hasOwnProperty.call(message, "order"))
                $root.cqg.Order.encode(message.order, writer.uint32(/* id 14, wireType 2 =*/114).fork(), _depth + 1).ldelim();
            if (message.transactionStatuses != null && message.transactionStatuses.length)
                for (let i = 0; i < message.transactionStatuses.length; ++i)
                    $root.cqg.TransactionStatus.encode(message.transactionStatuses[i], writer.uint32(/* id 15, wireType 2 =*/122).fork(), _depth + 1).ldelim();
            if (message.contractMetadata != null && message.contractMetadata.length)
                for (let i = 0; i < message.contractMetadata.length; ++i)
                    $root.cqg.ContractMetadata.encode(message.contractMetadata[i], writer.uint32(/* id 19, wireType 2 =*/154).fork(), _depth + 1).ldelim();
            if (message.accountId != null && Object.hasOwnProperty.call(message, "accountId"))
                writer.uint32(/* id 20, wireType 0 =*/160).sint32(message.accountId);
            if (message.$unknowns != null && Object.hasOwnProperty.call(message, "$unknowns"))
                for (let i = 0; i < message.$unknowns.length; ++i)
                    writer.raw(message.$unknowns[i]);
            return writer;
        };

        /**
         * Encodes the specified OrderStatus message, length delimited. Does not implicitly {@link cqg.OrderStatus.verify|verify} messages.
         * @function encodeDelimited
         * @memberof cqg.OrderStatus
         * @static
         * @param {cqg.OrderStatus.$Properties} message OrderStatus message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        OrderStatus.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer && writer.len ? writer.fork() : writer).ldelim();
        };

        /**
         * Decodes an OrderStatus message from the specified reader or buffer.
         * @function decode
         * @memberof cqg.OrderStatus
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {cqg.OrderStatus & cqg.OrderStatus.$Shape} OrderStatus
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        OrderStatus.decode = function decode(reader, length, _end, _depth, _target) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            if (_depth === undefined)
                _depth = 0;
            if (_depth > $Reader.recursionLimit)
                throw Error("max depth exceeded");
            let end = length === undefined ? reader.len : reader.pos + length, message = _target || new $root.cqg.OrderStatus(), value;
            while (reader.pos < end) {
                let start = reader.pos;
                let tag = reader.tag();
                if (tag === _end) {
                    _end = undefined;
                    break;
                }
                let wireType = tag & 7;
                switch (tag >>>= 3) {
                case 3: {
                        if (wireType !== 0)
                            break;
                        if (value = reader.uint32())
                            message.status = value;
                        else
                            delete message.status;
                        continue;
                    }
                case 4: {
                        if (wireType !== 2)
                            break;
                        if ((value = reader.string()).length)
                            message.orderId = value;
                        else
                            delete message.orderId;
                        continue;
                    }
                case 14: {
                        if (wireType !== 2)
                            break;
                        message.order = $root.cqg.Order.decode(reader, reader.uint32(), undefined, _depth + 1, message.order);
                        continue;
                    }
                case 15: {
                        if (wireType !== 2)
                            break;
                        if (!(message.transactionStatuses && message.transactionStatuses.length))
                            message.transactionStatuses = [];
                        message.transactionStatuses.push($root.cqg.TransactionStatus.decode(reader, reader.uint32(), undefined, _depth + 1));
                        continue;
                    }
                case 19: {
                        if (wireType !== 2)
                            break;
                        if (!(message.contractMetadata && message.contractMetadata.length))
                            message.contractMetadata = [];
                        message.contractMetadata.push($root.cqg.ContractMetadata.decode(reader, reader.uint32(), undefined, _depth + 1));
                        continue;
                    }
                case 20: {
                        if (wireType !== 0)
                            break;
                        if (value = reader.sint32())
                            message.accountId = value;
                        else
                            delete message.accountId;
                        continue;
                    }
                }
                reader.skipType(wireType, _depth, tag);
                if (!reader.discardUnknown) {
                    $util.makeProp(message, "$unknowns", false);
                    (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
                }
            }
            if (_end !== undefined)
                throw Error("missing end group");
            return message;
        };

        /**
         * Decodes an OrderStatus message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof cqg.OrderStatus
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {cqg.OrderStatus & cqg.OrderStatus.$Shape} OrderStatus
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        OrderStatus.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an OrderStatus message.
         * @function verify
         * @memberof cqg.OrderStatus
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        OrderStatus.verify = function verify(message, _depth) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (_depth === undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                return "max depth exceeded";
            if (message.status != null && message.hasOwnProperty("status"))
                if (!$util.isInteger(message.status))
                    return "status: integer expected";
            if (message.orderId != null && message.hasOwnProperty("orderId"))
                if (!$util.isString(message.orderId))
                    return "orderId: string expected";
            if (message.order != null && message.hasOwnProperty("order")) {
                let error = $root.cqg.Order.verify(message.order, _depth + 1);
                if (error)
                    return "order." + error;
            }
            if (message.transactionStatuses != null && message.hasOwnProperty("transactionStatuses")) {
                if (!Array.isArray(message.transactionStatuses))
                    return "transactionStatuses: array expected";
                for (let i = 0; i < message.transactionStatuses.length; ++i) {
                    let error = $root.cqg.TransactionStatus.verify(message.transactionStatuses[i], _depth + 1);
                    if (error)
                        return "transactionStatuses." + error;
                }
            }
            if (message.contractMetadata != null && message.hasOwnProperty("contractMetadata")) {
                if (!Array.isArray(message.contractMetadata))
                    return "contractMetadata: array expected";
                for (let i = 0; i < message.contractMetadata.length; ++i) {
                    let error = $root.cqg.ContractMetadata.verify(message.contractMetadata[i], _depth + 1);
                    if (error)
                        return "contractMetadata." + error;
                }
            }
            if (message.accountId != null && message.hasOwnProperty("accountId"))
                if (!$util.isInteger(message.accountId))
                    return "accountId: integer expected";
            return null;
        };

        /**
         * Creates an OrderStatus message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof cqg.OrderStatus
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {cqg.OrderStatus} OrderStatus
         */
        OrderStatus.fromObject = function fromObject(object, _depth) {
            if (object instanceof $root.cqg.OrderStatus)
                return object;
            if (!$util.isObject(object))
                throw TypeError(".cqg.OrderStatus: object expected");
            if (_depth === undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw Error("max depth exceeded");
            let message = new $root.cqg.OrderStatus();
            if (object.status != null)
                if (Number(object.status) !== 0)
                    message.status = object.status >>> 0;
            if (object.orderId != null)
                if (typeof object.orderId !== "string" || object.orderId.length)
                    message.orderId = String(object.orderId);
            if (object.order != null) {
                if (!$util.isObject(object.order))
                    throw TypeError(".cqg.OrderStatus.order: object expected");
                message.order = $root.cqg.Order.fromObject(object.order, _depth + 1);
            }
            if (object.transactionStatuses) {
                if (!Array.isArray(object.transactionStatuses))
                    throw TypeError(".cqg.OrderStatus.transactionStatuses: array expected");
                message.transactionStatuses = Array(object.transactionStatuses.length);
                for (let i = 0; i < object.transactionStatuses.length; ++i) {
                    if (!$util.isObject(object.transactionStatuses[i]))
                        throw TypeError(".cqg.OrderStatus.transactionStatuses: object expected");
                    message.transactionStatuses[i] = $root.cqg.TransactionStatus.fromObject(object.transactionStatuses[i], _depth + 1);
                }
            }
            if (object.contractMetadata) {
                if (!Array.isArray(object.contractMetadata))
                    throw TypeError(".cqg.OrderStatus.contractMetadata: array expected");
                message.contractMetadata = Array(object.contractMetadata.length);
                for (let i = 0; i < object.contractMetadata.length; ++i) {
                    if (!$util.isObject(object.contractMetadata[i]))
                        throw TypeError(".cqg.OrderStatus.contractMetadata: object expected");
                    message.contractMetadata[i] = $root.cqg.ContractMetadata.fromObject(object.contractMetadata[i], _depth + 1);
                }
            }
            if (object.accountId != null)
                if (Number(object.accountId) !== 0)
                    message.accountId = object.accountId | 0;
            return message;
        };

        /**
         * Creates a plain object from an OrderStatus message. Also converts values to other types if specified.
         * @function toObject
         * @memberof cqg.OrderStatus
         * @static
         * @param {cqg.OrderStatus} message OrderStatus
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        OrderStatus.toObject = function toObject(message, options, _depth) {
            if (!options)
                options = {};
            if (_depth === undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw Error("max depth exceeded");
            let object = {};
            if (options.arrays || options.defaults) {
                object.transactionStatuses = [];
                object.contractMetadata = [];
            }
            if (options.defaults) {
                object.status = 0;
                object.orderId = "";
                object.order = null;
                object.accountId = 0;
            }
            if (message.status != null && message.hasOwnProperty("status"))
                object.status = message.status;
            if (message.orderId != null && message.hasOwnProperty("orderId"))
                object.orderId = message.orderId;
            if (message.order != null && message.hasOwnProperty("order"))
                object.order = $root.cqg.Order.toObject(message.order, options, _depth + 1);
            if (message.transactionStatuses && message.transactionStatuses.length) {
                object.transactionStatuses = Array(message.transactionStatuses.length);
                for (let j = 0; j < message.transactionStatuses.length; ++j)
                    object.transactionStatuses[j] = $root.cqg.TransactionStatus.toObject(message.transactionStatuses[j], options, _depth + 1);
            }
            if (message.contractMetadata && message.contractMetadata.length) {
                object.contractMetadata = Array(message.contractMetadata.length);
                for (let j = 0; j < message.contractMetadata.length; ++j)
                    object.contractMetadata[j] = $root.cqg.ContractMetadata.toObject(message.contractMetadata[j], options, _depth + 1);
            }
            if (message.accountId != null && message.hasOwnProperty("accountId"))
                object.accountId = message.accountId;
            return object;
        };

        /**
         * Converts this OrderStatus to JSON.
         * @function toJSON
         * @memberof cqg.OrderStatus
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        OrderStatus.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the type url for OrderStatus
         * @function getTypeUrl
         * @memberof cqg.OrderStatus
         * @static
         * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
         * @returns {string} The type url
         */
        OrderStatus.getTypeUrl = function getTypeUrl(prefix) {
            if (prefix === undefined)
                prefix = "type.googleapis.com";
            return prefix + "/cqg.OrderStatus";
        };

        return OrderStatus;
    })();

    cqg.Order = (function() {

        /**
         * Properties of an Order.
         * @typedef {Object} cqg.Order.$Properties
         * @property {number|null} [contractId] Order contractId
         * @property {number|null} [side] Order side
         * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding
         */

        /**
         * Properties of an Order.
         * @memberof cqg
         * @interface IOrder
         * @augments cqg.Order.$Properties
         * @deprecated Use cqg.Order.$Properties instead.
         */

        /**
         * Shape of an Order.
         * @typedef {cqg.Order.$Properties} cqg.Order.$Shape
         */

        /**
         * Constructs a new Order.
         * @memberof cqg
         * @classdesc Represents an Order.
         * @constructor
         * @param {cqg.Order.$Properties=} [properties] Properties to set
         * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding
         */
        function Order(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null && keys[i] !== "__proto__")
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Order contractId.
         * @member {number} contractId
         * @memberof cqg.Order
         * @instance
         */
        Order.prototype.contractId = 0;

        /**
         * Order side.
         * @member {number} side
         * @memberof cqg.Order
         * @instance
         */
        Order.prototype.side = 0;

        /**
         * Creates a new Order instance using the specified properties.
         * @function create
         * @memberof cqg.Order
         * @static
         * @param {cqg.Order.$Properties=} [properties] Properties to set
         * @returns {cqg.Order} Order instance
         * @type {{
         *   (properties: cqg.Order.$Shape): cqg.Order & cqg.Order.$Shape;
         *   (properties?: cqg.Order.$Properties): cqg.Order;
         * }}
         */
        Order.create = function create(properties) {
            return new Order(properties);
        };

        /**
         * Encodes the specified Order message. Does not implicitly {@link cqg.Order.verify|verify} messages.
         * @function encode
         * @memberof cqg.Order
         * @static
         * @param {cqg.Order.$Properties} message Order message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Order.encode = function encode(message, writer, _depth) {
            if (!writer)
                writer = $Writer.create();
            if (_depth === undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw Error("max depth exceeded");
            if (message.contractId != null && Object.hasOwnProperty.call(message, "contractId"))
                writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.contractId);
            if (message.side != null && Object.hasOwnProperty.call(message, "side"))
                writer.uint32(/* id 9, wireType 0 =*/72).uint32(message.side);
            if (message.$unknowns != null && Object.hasOwnProperty.call(message, "$unknowns"))
                for (let i = 0; i < message.$unknowns.length; ++i)
                    writer.raw(message.$unknowns[i]);
            return writer;
        };

        /**
         * Encodes the specified Order message, length delimited. Does not implicitly {@link cqg.Order.verify|verify} messages.
         * @function encodeDelimited
         * @memberof cqg.Order
         * @static
         * @param {cqg.Order.$Properties} message Order message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Order.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer && writer.len ? writer.fork() : writer).ldelim();
        };

        /**
         * Decodes an Order message from the specified reader or buffer.
         * @function decode
         * @memberof cqg.Order
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {cqg.Order & cqg.Order.$Shape} Order
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Order.decode = function decode(reader, length, _end, _depth, _target) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            if (_depth === undefined)
                _depth = 0;
            if (_depth > $Reader.recursionLimit)
                throw Error("max depth exceeded");
            let end = length === undefined ? reader.len : reader.pos + length, message = _target || new $root.cqg.Order(), value;
            while (reader.pos < end) {
                let start = reader.pos;
                let tag = reader.tag();
                if (tag === _end) {
                    _end = undefined;
                    break;
                }
                let wireType = tag & 7;
                switch (tag >>>= 3) {
                case 3: {
                        if (wireType !== 0)
                            break;
                        if (value = reader.uint32())
                            message.contractId = value;
                        else
                            delete message.contractId;
                        continue;
                    }
                case 9: {
                        if (wireType !== 0)
                            break;
                        if (value = reader.uint32())
                            message.side = value;
                        else
                            delete message.side;
                        continue;
                    }
                }
                reader.skipType(wireType, _depth, tag);
                if (!reader.discardUnknown) {
                    $util.makeProp(message, "$unknowns", false);
                    (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
                }
            }
            if (_end !== undefined)
                throw Error("missing end group");
            return message;
        };

        /**
         * Decodes an Order message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof cqg.Order
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {cqg.Order & cqg.Order.$Shape} Order
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Order.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an Order message.
         * @function verify
         * @memberof cqg.Order
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        Order.verify = function verify(message, _depth) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (_depth === undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                return "max depth exceeded";
            if (message.contractId != null && message.hasOwnProperty("contractId"))
                if (!$util.isInteger(message.contractId))
                    return "contractId: integer expected";
            if (message.side != null && message.hasOwnProperty("side"))
                if (!$util.isInteger(message.side))
                    return "side: integer expected";
            return null;
        };

        /**
         * Creates an Order message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof cqg.Order
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {cqg.Order} Order
         */
        Order.fromObject = function fromObject(object, _depth) {
            if (object instanceof $root.cqg.Order)
                return object;
            if (!$util.isObject(object))
                throw TypeError(".cqg.Order: object expected");
            if (_depth === undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw Error("max depth exceeded");
            let message = new $root.cqg.Order();
            if (object.contractId != null)
                if (Number(object.contractId) !== 0)
                    message.contractId = object.contractId >>> 0;
            if (object.side != null)
                if (Number(object.side) !== 0)
                    message.side = object.side >>> 0;
            return message;
        };

        /**
         * Creates a plain object from an Order message. Also converts values to other types if specified.
         * @function toObject
         * @memberof cqg.Order
         * @static
         * @param {cqg.Order} message Order
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Order.toObject = function toObject(message, options, _depth) {
            if (!options)
                options = {};
            if (_depth === undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw Error("max depth exceeded");
            let object = {};
            if (options.defaults) {
                object.contractId = 0;
                object.side = 0;
            }
            if (message.contractId != null && message.hasOwnProperty("contractId"))
                object.contractId = message.contractId;
            if (message.side != null && message.hasOwnProperty("side"))
                object.side = message.side;
            return object;
        };

        /**
         * Converts this Order to JSON.
         * @function toJSON
         * @memberof cqg.Order
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Order.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the type url for Order
         * @function getTypeUrl
         * @memberof cqg.Order
         * @static
         * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
         * @returns {string} The type url
         */
        Order.getTypeUrl = function getTypeUrl(prefix) {
            if (prefix === undefined)
                prefix = "type.googleapis.com";
            return prefix + "/cqg.Order";
        };

        return Order;
    })();

    cqg.TransactionStatus = (function() {

        /**
         * Properties of a TransactionStatus.
         * @typedef {Object} cqg.TransactionStatus.$Properties
         * @property {number|null} [status] TransactionStatus status
         * @property {number|null} [transId] TransactionStatus transId
         * @property {cqg.Decimal.$Properties|null} [fillQty] TransactionStatus fillQty
         * @property {number|null} [correctFillPrice] TransactionStatus correctFillPrice
         * @property {cqg.Timestamp.$Properties|null} [transUtcTimestamp] TransactionStatus transUtcTimestamp
         * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding
         */

        /**
         * Properties of a TransactionStatus.
         * @memberof cqg
         * @interface ITransactionStatus
         * @augments cqg.TransactionStatus.$Properties
         * @deprecated Use cqg.TransactionStatus.$Properties instead.
         */

        /**
         * Shape of a TransactionStatus.
         * @typedef {cqg.TransactionStatus.$Properties} cqg.TransactionStatus.$Shape
         */

        /**
         * Constructs a new TransactionStatus.
         * @memberof cqg
         * @classdesc Represents a TransactionStatus.
         * @constructor
         * @param {cqg.TransactionStatus.$Properties=} [properties] Properties to set
         * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding
         */
        function TransactionStatus(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null && keys[i] !== "__proto__")
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * TransactionStatus status.
         * @member {number} status
         * @memberof cqg.TransactionStatus
         * @instance
         */
        TransactionStatus.prototype.status = 0;

        /**
         * TransactionStatus transId.
         * @member {number} transId
         * @memberof cqg.TransactionStatus
         * @instance
         */
        TransactionStatus.prototype.transId = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * TransactionStatus fillQty.
         * @member {cqg.Decimal.$Properties|null|undefined} fillQty
         * @memberof cqg.TransactionStatus
         * @instance
         */
        TransactionStatus.prototype.fillQty = null;

        /**
         * TransactionStatus correctFillPrice.
         * @member {number} correctFillPrice
         * @memberof cqg.TransactionStatus
         * @instance
         */
        TransactionStatus.prototype.correctFillPrice = 0;

        /**
         * TransactionStatus transUtcTimestamp.
         * @member {cqg.Timestamp.$Properties|null|undefined} transUtcTimestamp
         * @memberof cqg.TransactionStatus
         * @instance
         */
        TransactionStatus.prototype.transUtcTimestamp = null;

        /**
         * Creates a new TransactionStatus instance using the specified properties.
         * @function create
         * @memberof cqg.TransactionStatus
         * @static
         * @param {cqg.TransactionStatus.$Properties=} [properties] Properties to set
         * @returns {cqg.TransactionStatus} TransactionStatus instance
         * @type {{
         *   (properties: cqg.TransactionStatus.$Shape): cqg.TransactionStatus & cqg.TransactionStatus.$Shape;
         *   (properties?: cqg.TransactionStatus.$Properties): cqg.TransactionStatus;
         * }}
         */
        TransactionStatus.create = function create(properties) {
            return new TransactionStatus(properties);
        };

        /**
         * Encodes the specified TransactionStatus message. Does not implicitly {@link cqg.TransactionStatus.verify|verify} messages.
         * @function encode
         * @memberof cqg.TransactionStatus
         * @static
         * @param {cqg.TransactionStatus.$Properties} message TransactionStatus message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        TransactionStatus.encode = function encode(message, writer, _depth) {
            if (!writer)
                writer = $Writer.create();
            if (_depth === undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw Error("max depth exceeded");
            if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.status);
            if (message.transId != null && Object.hasOwnProperty.call(message, "transId"))
                writer.uint32(/* id 2, wireType 0 =*/16).uint64(message.transId);
            if (message.transUtcTimestamp != null && Object.hasOwnProperty.call(message, "transUtcTimestamp"))
                $root.cqg.Timestamp.encode(message.transUtcTimestamp, writer.uint32(/* id 40, wireType 2 =*/322).fork(), _depth + 1).ldelim();
            if (message.fillQty != null && Object.hasOwnProperty.call(message, "fillQty"))
                $root.cqg.Decimal.encode(message.fillQty, writer.uint32(/* id 52, wireType 2 =*/418).fork(), _depth + 1).ldelim();
            if (message.correctFillPrice != null && Object.hasOwnProperty.call(message, "correctFillPrice"))
                writer.uint32(/* id 70, wireType 1 =*/561).double(message.correctFillPrice);
            if (message.$unknowns != null && Object.hasOwnProperty.call(message, "$unknowns"))
                for (let i = 0; i < message.$unknowns.length; ++i)
                    writer.raw(message.$unknowns[i]);
            return writer;
        };

        /**
         * Encodes the specified TransactionStatus message, length delimited. Does not implicitly {@link cqg.TransactionStatus.verify|verify} messages.
         * @function encodeDelimited
         * @memberof cqg.TransactionStatus
         * @static
         * @param {cqg.TransactionStatus.$Properties} message TransactionStatus message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        TransactionStatus.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer && writer.len ? writer.fork() : writer).ldelim();
        };

        /**
         * Decodes a TransactionStatus message from the specified reader or buffer.
         * @function decode
         * @memberof cqg.TransactionStatus
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {cqg.TransactionStatus & cqg.TransactionStatus.$Shape} TransactionStatus
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        TransactionStatus.decode = function decode(reader, length, _end, _depth, _target) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            if (_depth === undefined)
                _depth = 0;
            if (_depth > $Reader.recursionLimit)
                throw Error("max depth exceeded");
            let end = length === undefined ? reader.len : reader.pos + length, message = _target || new $root.cqg.TransactionStatus(), value;
            while (reader.pos < end) {
                let start = reader.pos;
                let tag = reader.tag();
                if (tag === _end) {
                    _end = undefined;
                    break;
                }
                let wireType = tag & 7;
                switch (tag >>>= 3) {
                case 1: {
                        if (wireType !== 0)
                            break;
                        if (value = reader.uint32())
                            message.status = value;
                        else
                            delete message.status;
                        continue;
                    }
                case 2: {
                        if (wireType !== 0)
                            break;
                        if (typeof (value = reader.uint64()) === "object" ? value.low || value.high : value !== 0)
                            message.transId = value;
                        else
                            delete message.transId;
                        continue;
                    }
                case 52: {
                        if (wireType !== 2)
                            break;
                        message.fillQty = $root.cqg.Decimal.decode(reader, reader.uint32(), undefined, _depth + 1, message.fillQty);
                        continue;
                    }
                case 70: {
                        if (wireType !== 1)
                            break;
                        if ((value = reader.double()) !== 0)
                            message.correctFillPrice = value;
                        else
                            delete message.correctFillPrice;
                        continue;
                    }
                case 40: {
                        if (wireType !== 2)
                            break;
                        message.transUtcTimestamp = $root.cqg.Timestamp.decode(reader, reader.uint32(), undefined, _depth + 1, message.transUtcTimestamp);
                        continue;
                    }
                }
                reader.skipType(wireType, _depth, tag);
                if (!reader.discardUnknown) {
                    $util.makeProp(message, "$unknowns", false);
                    (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
                }
            }
            if (_end !== undefined)
                throw Error("missing end group");
            return message;
        };

        /**
         * Decodes a TransactionStatus message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof cqg.TransactionStatus
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {cqg.TransactionStatus & cqg.TransactionStatus.$Shape} TransactionStatus
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        TransactionStatus.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a TransactionStatus message.
         * @function verify
         * @memberof cqg.TransactionStatus
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        TransactionStatus.verify = function verify(message, _depth) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (_depth === undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                return "max depth exceeded";
            if (message.status != null && message.hasOwnProperty("status"))
                if (!$util.isInteger(message.status))
                    return "status: integer expected";
            if (message.transId != null && message.hasOwnProperty("transId"))
                if (!$util.isInteger(message.transId) && !(message.transId && $util.isInteger(message.transId.low) && $util.isInteger(message.transId.high)))
                    return "transId: integer|Long expected";
            if (message.fillQty != null && message.hasOwnProperty("fillQty")) {
                let error = $root.cqg.Decimal.verify(message.fillQty, _depth + 1);
                if (error)
                    return "fillQty." + error;
            }
            if (message.correctFillPrice != null && message.hasOwnProperty("correctFillPrice"))
                if (typeof message.correctFillPrice !== "number")
                    return "correctFillPrice: number expected";
            if (message.transUtcTimestamp != null && message.hasOwnProperty("transUtcTimestamp")) {
                let error = $root.cqg.Timestamp.verify(message.transUtcTimestamp, _depth + 1);
                if (error)
                    return "transUtcTimestamp." + error;
            }
            return null;
        };

        /**
         * Creates a TransactionStatus message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof cqg.TransactionStatus
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {cqg.TransactionStatus} TransactionStatus
         */
        TransactionStatus.fromObject = function fromObject(object, _depth) {
            if (object instanceof $root.cqg.TransactionStatus)
                return object;
            if (!$util.isObject(object))
                throw TypeError(".cqg.TransactionStatus: object expected");
            if (_depth === undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw Error("max depth exceeded");
            let message = new $root.cqg.TransactionStatus();
            if (object.status != null)
                if (Number(object.status) !== 0)
                    message.status = object.status >>> 0;
            if (object.transId != null)
                if (typeof object.transId === "object" ? object.transId.low || object.transId.high : Number(object.transId) !== 0)
                    if ($util.Long)
                        message.transId = $util.Long.fromValue(object.transId, true);
                    else if (typeof object.transId === "string")
                        message.transId = parseInt(object.transId, 10);
                    else if (typeof object.transId === "number")
                        message.transId = object.transId;
                    else if (typeof object.transId === "object")
                        message.transId = new $util.LongBits(object.transId.low >>> 0, object.transId.high >>> 0).toNumber(true);
            if (object.fillQty != null) {
                if (!$util.isObject(object.fillQty))
                    throw TypeError(".cqg.TransactionStatus.fillQty: object expected");
                message.fillQty = $root.cqg.Decimal.fromObject(object.fillQty, _depth + 1);
            }
            if (object.correctFillPrice != null)
                if (Number(object.correctFillPrice) !== 0)
                    message.correctFillPrice = Number(object.correctFillPrice);
            if (object.transUtcTimestamp != null) {
                if (!$util.isObject(object.transUtcTimestamp))
                    throw TypeError(".cqg.TransactionStatus.transUtcTimestamp: object expected");
                message.transUtcTimestamp = $root.cqg.Timestamp.fromObject(object.transUtcTimestamp, _depth + 1);
            }
            return message;
        };

        /**
         * Creates a plain object from a TransactionStatus message. Also converts values to other types if specified.
         * @function toObject
         * @memberof cqg.TransactionStatus
         * @static
         * @param {cqg.TransactionStatus} message TransactionStatus
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        TransactionStatus.toObject = function toObject(message, options, _depth) {
            if (!options)
                options = {};
            if (_depth === undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw Error("max depth exceeded");
            let object = {};
            if (options.defaults) {
                object.status = 0;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, true);
                    object.transId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : typeof BigInt !== "undefined" && options.longs === BigInt ? long.toBigInt() : long;
                } else
                    object.transId = options.longs === String ? "0" : typeof BigInt !== "undefined" && options.longs === BigInt ? BigInt("0") : 0;
                object.transUtcTimestamp = null;
                object.fillQty = null;
                object.correctFillPrice = 0;
            }
            if (message.status != null && message.hasOwnProperty("status"))
                object.status = message.status;
            if (message.transId != null && message.hasOwnProperty("transId"))
                if (typeof BigInt !== "undefined" && options.longs === BigInt)
                    object.transId = typeof message.transId === "number" ? BigInt(message.transId) : $util.Long.fromBits(message.transId.low >>> 0, message.transId.high >>> 0, true).toBigInt();
                else if (typeof message.transId === "number")
                    object.transId = options.longs === String ? String(message.transId) : message.transId;
                else
                    object.transId = options.longs === String ? $util.Long.prototype.toString.call(message.transId) : options.longs === Number ? new $util.LongBits(message.transId.low >>> 0, message.transId.high >>> 0).toNumber(true) : message.transId;
            if (message.transUtcTimestamp != null && message.hasOwnProperty("transUtcTimestamp"))
                object.transUtcTimestamp = $root.cqg.Timestamp.toObject(message.transUtcTimestamp, options, _depth + 1);
            if (message.fillQty != null && message.hasOwnProperty("fillQty"))
                object.fillQty = $root.cqg.Decimal.toObject(message.fillQty, options, _depth + 1);
            if (message.correctFillPrice != null && message.hasOwnProperty("correctFillPrice"))
                object.correctFillPrice = options.json && !isFinite(message.correctFillPrice) ? String(message.correctFillPrice) : message.correctFillPrice;
            return object;
        };

        /**
         * Converts this TransactionStatus to JSON.
         * @function toJSON
         * @memberof cqg.TransactionStatus
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        TransactionStatus.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the type url for TransactionStatus
         * @function getTypeUrl
         * @memberof cqg.TransactionStatus
         * @static
         * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
         * @returns {string} The type url
         */
        TransactionStatus.getTypeUrl = function getTypeUrl(prefix) {
            if (prefix === undefined)
                prefix = "type.googleapis.com";
            return prefix + "/cqg.TransactionStatus";
        };

        return TransactionStatus;
    })();

    cqg.PositionStatus = (function() {

        /**
         * Properties of a PositionStatus.
         * @typedef {Object} cqg.PositionStatus.$Properties
         * @property {boolean|null} [isSnapshot] PositionStatus isSnapshot
         * @property {number|null} [accountId] PositionStatus accountId
         * @property {number|null} [contractId] PositionStatus contractId
         * @property {Array.<cqg.OpenPosition.$Properties>|null} [openPositions] PositionStatus openPositions
         * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding
         */

        /**
         * Properties of a PositionStatus.
         * @memberof cqg
         * @interface IPositionStatus
         * @augments cqg.PositionStatus.$Properties
         * @deprecated Use cqg.PositionStatus.$Properties instead.
         */

        /**
         * Shape of a PositionStatus.
         * @typedef {cqg.PositionStatus.$Properties} cqg.PositionStatus.$Shape
         */

        /**
         * Constructs a new PositionStatus.
         * @memberof cqg
         * @classdesc Represents a PositionStatus.
         * @constructor
         * @param {cqg.PositionStatus.$Properties=} [properties] Properties to set
         * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding
         */
        function PositionStatus(properties) {
            this.openPositions = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null && keys[i] !== "__proto__")
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * PositionStatus isSnapshot.
         * @member {boolean} isSnapshot
         * @memberof cqg.PositionStatus
         * @instance
         */
        PositionStatus.prototype.isSnapshot = false;

        /**
         * PositionStatus accountId.
         * @member {number} accountId
         * @memberof cqg.PositionStatus
         * @instance
         */
        PositionStatus.prototype.accountId = 0;

        /**
         * PositionStatus contractId.
         * @member {number} contractId
         * @memberof cqg.PositionStatus
         * @instance
         */
        PositionStatus.prototype.contractId = 0;

        /**
         * PositionStatus openPositions.
         * @member {Array.<cqg.OpenPosition.$Properties>} openPositions
         * @memberof cqg.PositionStatus
         * @instance
         */
        PositionStatus.prototype.openPositions = $util.emptyArray;

        /**
         * Creates a new PositionStatus instance using the specified properties.
         * @function create
         * @memberof cqg.PositionStatus
         * @static
         * @param {cqg.PositionStatus.$Properties=} [properties] Properties to set
         * @returns {cqg.PositionStatus} PositionStatus instance
         * @type {{
         *   (properties: cqg.PositionStatus.$Shape): cqg.PositionStatus & cqg.PositionStatus.$Shape;
         *   (properties?: cqg.PositionStatus.$Properties): cqg.PositionStatus;
         * }}
         */
        PositionStatus.create = function create(properties) {
            return new PositionStatus(properties);
        };

        /**
         * Encodes the specified PositionStatus message. Does not implicitly {@link cqg.PositionStatus.verify|verify} messages.
         * @function encode
         * @memberof cqg.PositionStatus
         * @static
         * @param {cqg.PositionStatus.$Properties} message PositionStatus message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        PositionStatus.encode = function encode(message, writer, _depth) {
            if (!writer)
                writer = $Writer.create();
            if (_depth === undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw Error("max depth exceeded");
            if (message.isSnapshot != null && Object.hasOwnProperty.call(message, "isSnapshot"))
                writer.uint32(/* id 2, wireType 0 =*/16).bool(message.isSnapshot);
            if (message.accountId != null && Object.hasOwnProperty.call(message, "accountId"))
                writer.uint32(/* id 3, wireType 0 =*/24).sint32(message.accountId);
            if (message.contractId != null && Object.hasOwnProperty.call(message, "contractId"))
                writer.uint32(/* id 4, wireType 0 =*/32).uint32(message.contractId);
            if (message.openPositions != null && message.openPositions.length)
                for (let i = 0; i < message.openPositions.length; ++i)
                    $root.cqg.OpenPosition.encode(message.openPositions[i], writer.uint32(/* id 6, wireType 2 =*/50).fork(), _depth + 1).ldelim();
            if (message.$unknowns != null && Object.hasOwnProperty.call(message, "$unknowns"))
                for (let i = 0; i < message.$unknowns.length; ++i)
                    writer.raw(message.$unknowns[i]);
            return writer;
        };

        /**
         * Encodes the specified PositionStatus message, length delimited. Does not implicitly {@link cqg.PositionStatus.verify|verify} messages.
         * @function encodeDelimited
         * @memberof cqg.PositionStatus
         * @static
         * @param {cqg.PositionStatus.$Properties} message PositionStatus message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        PositionStatus.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer && writer.len ? writer.fork() : writer).ldelim();
        };

        /**
         * Decodes a PositionStatus message from the specified reader or buffer.
         * @function decode
         * @memberof cqg.PositionStatus
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {cqg.PositionStatus & cqg.PositionStatus.$Shape} PositionStatus
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        PositionStatus.decode = function decode(reader, length, _end, _depth, _target) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            if (_depth === undefined)
                _depth = 0;
            if (_depth > $Reader.recursionLimit)
                throw Error("max depth exceeded");
            let end = length === undefined ? reader.len : reader.pos + length, message = _target || new $root.cqg.PositionStatus(), value;
            while (reader.pos < end) {
                let start = reader.pos;
                let tag = reader.tag();
                if (tag === _end) {
                    _end = undefined;
                    break;
                }
                let wireType = tag & 7;
                switch (tag >>>= 3) {
                case 2: {
                        if (wireType !== 0)
                            break;
                        if (value = reader.bool())
                            message.isSnapshot = value;
                        else
                            delete message.isSnapshot;
                        continue;
                    }
                case 3: {
                        if (wireType !== 0)
                            break;
                        if (value = reader.sint32())
                            message.accountId = value;
                        else
                            delete message.accountId;
                        continue;
                    }
                case 4: {
                        if (wireType !== 0)
                            break;
                        if (value = reader.uint32())
                            message.contractId = value;
                        else
                            delete message.contractId;
                        continue;
                    }
                case 6: {
                        if (wireType !== 2)
                            break;
                        if (!(message.openPositions && message.openPositions.length))
                            message.openPositions = [];
                        message.openPositions.push($root.cqg.OpenPosition.decode(reader, reader.uint32(), undefined, _depth + 1));
                        continue;
                    }
                }
                reader.skipType(wireType, _depth, tag);
                if (!reader.discardUnknown) {
                    $util.makeProp(message, "$unknowns", false);
                    (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
                }
            }
            if (_end !== undefined)
                throw Error("missing end group");
            return message;
        };

        /**
         * Decodes a PositionStatus message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof cqg.PositionStatus
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {cqg.PositionStatus & cqg.PositionStatus.$Shape} PositionStatus
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        PositionStatus.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a PositionStatus message.
         * @function verify
         * @memberof cqg.PositionStatus
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        PositionStatus.verify = function verify(message, _depth) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (_depth === undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                return "max depth exceeded";
            if (message.isSnapshot != null && message.hasOwnProperty("isSnapshot"))
                if (typeof message.isSnapshot !== "boolean")
                    return "isSnapshot: boolean expected";
            if (message.accountId != null && message.hasOwnProperty("accountId"))
                if (!$util.isInteger(message.accountId))
                    return "accountId: integer expected";
            if (message.contractId != null && message.hasOwnProperty("contractId"))
                if (!$util.isInteger(message.contractId))
                    return "contractId: integer expected";
            if (message.openPositions != null && message.hasOwnProperty("openPositions")) {
                if (!Array.isArray(message.openPositions))
                    return "openPositions: array expected";
                for (let i = 0; i < message.openPositions.length; ++i) {
                    let error = $root.cqg.OpenPosition.verify(message.openPositions[i], _depth + 1);
                    if (error)
                        return "openPositions." + error;
                }
            }
            return null;
        };

        /**
         * Creates a PositionStatus message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof cqg.PositionStatus
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {cqg.PositionStatus} PositionStatus
         */
        PositionStatus.fromObject = function fromObject(object, _depth) {
            if (object instanceof $root.cqg.PositionStatus)
                return object;
            if (!$util.isObject(object))
                throw TypeError(".cqg.PositionStatus: object expected");
            if (_depth === undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw Error("max depth exceeded");
            let message = new $root.cqg.PositionStatus();
            if (object.isSnapshot != null)
                if (object.isSnapshot)
                    message.isSnapshot = Boolean(object.isSnapshot);
            if (object.accountId != null)
                if (Number(object.accountId) !== 0)
                    message.accountId = object.accountId | 0;
            if (object.contractId != null)
                if (Number(object.contractId) !== 0)
                    message.contractId = object.contractId >>> 0;
            if (object.openPositions) {
                if (!Array.isArray(object.openPositions))
                    throw TypeError(".cqg.PositionStatus.openPositions: array expected");
                message.openPositions = Array(object.openPositions.length);
                for (let i = 0; i < object.openPositions.length; ++i) {
                    if (!$util.isObject(object.openPositions[i]))
                        throw TypeError(".cqg.PositionStatus.openPositions: object expected");
                    message.openPositions[i] = $root.cqg.OpenPosition.fromObject(object.openPositions[i], _depth + 1);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a PositionStatus message. Also converts values to other types if specified.
         * @function toObject
         * @memberof cqg.PositionStatus
         * @static
         * @param {cqg.PositionStatus} message PositionStatus
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        PositionStatus.toObject = function toObject(message, options, _depth) {
            if (!options)
                options = {};
            if (_depth === undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw Error("max depth exceeded");
            let object = {};
            if (options.arrays || options.defaults)
                object.openPositions = [];
            if (options.defaults) {
                object.isSnapshot = false;
                object.accountId = 0;
                object.contractId = 0;
            }
            if (message.isSnapshot != null && message.hasOwnProperty("isSnapshot"))
                object.isSnapshot = message.isSnapshot;
            if (message.accountId != null && message.hasOwnProperty("accountId"))
                object.accountId = message.accountId;
            if (message.contractId != null && message.hasOwnProperty("contractId"))
                object.contractId = message.contractId;
            if (message.openPositions && message.openPositions.length) {
                object.openPositions = Array(message.openPositions.length);
                for (let j = 0; j < message.openPositions.length; ++j)
                    object.openPositions[j] = $root.cqg.OpenPosition.toObject(message.openPositions[j], options, _depth + 1);
            }
            return object;
        };

        /**
         * Converts this PositionStatus to JSON.
         * @function toJSON
         * @memberof cqg.PositionStatus
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        PositionStatus.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the type url for PositionStatus
         * @function getTypeUrl
         * @memberof cqg.PositionStatus
         * @static
         * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
         * @returns {string} The type url
         */
        PositionStatus.getTypeUrl = function getTypeUrl(prefix) {
            if (prefix === undefined)
                prefix = "type.googleapis.com";
            return prefix + "/cqg.PositionStatus";
        };

        return PositionStatus;
    })();

    cqg.OpenPosition = (function() {

        /**
         * Properties of an OpenPosition.
         * @typedef {Object} cqg.OpenPosition.$Properties
         * @property {number|null} [id] OpenPosition id
         * @property {cqg.Decimal.$Properties|null} [qty] OpenPosition qty
         * @property {number|null} [priceCorrect] OpenPosition priceCorrect
         * @property {boolean|null} [isShort] OpenPosition isShort
         * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding
         */

        /**
         * Properties of an OpenPosition.
         * @memberof cqg
         * @interface IOpenPosition
         * @augments cqg.OpenPosition.$Properties
         * @deprecated Use cqg.OpenPosition.$Properties instead.
         */

        /**
         * Shape of an OpenPosition.
         * @typedef {cqg.OpenPosition.$Properties} cqg.OpenPosition.$Shape
         */

        /**
         * Constructs a new OpenPosition.
         * @memberof cqg
         * @classdesc Represents an OpenPosition.
         * @constructor
         * @param {cqg.OpenPosition.$Properties=} [properties] Properties to set
         * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding
         */
        function OpenPosition(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null && keys[i] !== "__proto__")
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * OpenPosition id.
         * @member {number} id
         * @memberof cqg.OpenPosition
         * @instance
         */
        OpenPosition.prototype.id = 0;

        /**
         * OpenPosition qty.
         * @member {cqg.Decimal.$Properties|null|undefined} qty
         * @memberof cqg.OpenPosition
         * @instance
         */
        OpenPosition.prototype.qty = null;

        /**
         * OpenPosition priceCorrect.
         * @member {number} priceCorrect
         * @memberof cqg.OpenPosition
         * @instance
         */
        OpenPosition.prototype.priceCorrect = 0;

        /**
         * OpenPosition isShort.
         * @member {boolean} isShort
         * @memberof cqg.OpenPosition
         * @instance
         */
        OpenPosition.prototype.isShort = false;

        /**
         * Creates a new OpenPosition instance using the specified properties.
         * @function create
         * @memberof cqg.OpenPosition
         * @static
         * @param {cqg.OpenPosition.$Properties=} [properties] Properties to set
         * @returns {cqg.OpenPosition} OpenPosition instance
         * @type {{
         *   (properties: cqg.OpenPosition.$Shape): cqg.OpenPosition & cqg.OpenPosition.$Shape;
         *   (properties?: cqg.OpenPosition.$Properties): cqg.OpenPosition;
         * }}
         */
        OpenPosition.create = function create(properties) {
            return new OpenPosition(properties);
        };

        /**
         * Encodes the specified OpenPosition message. Does not implicitly {@link cqg.OpenPosition.verify|verify} messages.
         * @function encode
         * @memberof cqg.OpenPosition
         * @static
         * @param {cqg.OpenPosition.$Properties} message OpenPosition message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        OpenPosition.encode = function encode(message, writer, _depth) {
            if (!writer)
                writer = $Writer.create();
            if (_depth === undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw Error("max depth exceeded");
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                writer.uint32(/* id 1, wireType 0 =*/8).sint32(message.id);
            if (message.priceCorrect != null && Object.hasOwnProperty.call(message, "priceCorrect"))
                writer.uint32(/* id 3, wireType 1 =*/25).double(message.priceCorrect);
            if (message.isShort != null && Object.hasOwnProperty.call(message, "isShort"))
                writer.uint32(/* id 9, wireType 0 =*/72).bool(message.isShort);
            if (message.qty != null && Object.hasOwnProperty.call(message, "qty"))
                $root.cqg.Decimal.encode(message.qty, writer.uint32(/* id 12, wireType 2 =*/98).fork(), _depth + 1).ldelim();
            if (message.$unknowns != null && Object.hasOwnProperty.call(message, "$unknowns"))
                for (let i = 0; i < message.$unknowns.length; ++i)
                    writer.raw(message.$unknowns[i]);
            return writer;
        };

        /**
         * Encodes the specified OpenPosition message, length delimited. Does not implicitly {@link cqg.OpenPosition.verify|verify} messages.
         * @function encodeDelimited
         * @memberof cqg.OpenPosition
         * @static
         * @param {cqg.OpenPosition.$Properties} message OpenPosition message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        OpenPosition.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer && writer.len ? writer.fork() : writer).ldelim();
        };

        /**
         * Decodes an OpenPosition message from the specified reader or buffer.
         * @function decode
         * @memberof cqg.OpenPosition
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {cqg.OpenPosition & cqg.OpenPosition.$Shape} OpenPosition
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        OpenPosition.decode = function decode(reader, length, _end, _depth, _target) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            if (_depth === undefined)
                _depth = 0;
            if (_depth > $Reader.recursionLimit)
                throw Error("max depth exceeded");
            let end = length === undefined ? reader.len : reader.pos + length, message = _target || new $root.cqg.OpenPosition(), value;
            while (reader.pos < end) {
                let start = reader.pos;
                let tag = reader.tag();
                if (tag === _end) {
                    _end = undefined;
                    break;
                }
                let wireType = tag & 7;
                switch (tag >>>= 3) {
                case 1: {
                        if (wireType !== 0)
                            break;
                        if (value = reader.sint32())
                            message.id = value;
                        else
                            delete message.id;
                        continue;
                    }
                case 12: {
                        if (wireType !== 2)
                            break;
                        message.qty = $root.cqg.Decimal.decode(reader, reader.uint32(), undefined, _depth + 1, message.qty);
                        continue;
                    }
                case 3: {
                        if (wireType !== 1)
                            break;
                        if ((value = reader.double()) !== 0)
                            message.priceCorrect = value;
                        else
                            delete message.priceCorrect;
                        continue;
                    }
                case 9: {
                        if (wireType !== 0)
                            break;
                        if (value = reader.bool())
                            message.isShort = value;
                        else
                            delete message.isShort;
                        continue;
                    }
                }
                reader.skipType(wireType, _depth, tag);
                if (!reader.discardUnknown) {
                    $util.makeProp(message, "$unknowns", false);
                    (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
                }
            }
            if (_end !== undefined)
                throw Error("missing end group");
            return message;
        };

        /**
         * Decodes an OpenPosition message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof cqg.OpenPosition
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {cqg.OpenPosition & cqg.OpenPosition.$Shape} OpenPosition
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        OpenPosition.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an OpenPosition message.
         * @function verify
         * @memberof cqg.OpenPosition
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        OpenPosition.verify = function verify(message, _depth) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (_depth === undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                return "max depth exceeded";
            if (message.id != null && message.hasOwnProperty("id"))
                if (!$util.isInteger(message.id))
                    return "id: integer expected";
            if (message.qty != null && message.hasOwnProperty("qty")) {
                let error = $root.cqg.Decimal.verify(message.qty, _depth + 1);
                if (error)
                    return "qty." + error;
            }
            if (message.priceCorrect != null && message.hasOwnProperty("priceCorrect"))
                if (typeof message.priceCorrect !== "number")
                    return "priceCorrect: number expected";
            if (message.isShort != null && message.hasOwnProperty("isShort"))
                if (typeof message.isShort !== "boolean")
                    return "isShort: boolean expected";
            return null;
        };

        /**
         * Creates an OpenPosition message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof cqg.OpenPosition
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {cqg.OpenPosition} OpenPosition
         */
        OpenPosition.fromObject = function fromObject(object, _depth) {
            if (object instanceof $root.cqg.OpenPosition)
                return object;
            if (!$util.isObject(object))
                throw TypeError(".cqg.OpenPosition: object expected");
            if (_depth === undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw Error("max depth exceeded");
            let message = new $root.cqg.OpenPosition();
            if (object.id != null)
                if (Number(object.id) !== 0)
                    message.id = object.id | 0;
            if (object.qty != null) {
                if (!$util.isObject(object.qty))
                    throw TypeError(".cqg.OpenPosition.qty: object expected");
                message.qty = $root.cqg.Decimal.fromObject(object.qty, _depth + 1);
            }
            if (object.priceCorrect != null)
                if (Number(object.priceCorrect) !== 0)
                    message.priceCorrect = Number(object.priceCorrect);
            if (object.isShort != null)
                if (object.isShort)
                    message.isShort = Boolean(object.isShort);
            return message;
        };

        /**
         * Creates a plain object from an OpenPosition message. Also converts values to other types if specified.
         * @function toObject
         * @memberof cqg.OpenPosition
         * @static
         * @param {cqg.OpenPosition} message OpenPosition
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        OpenPosition.toObject = function toObject(message, options, _depth) {
            if (!options)
                options = {};
            if (_depth === undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw Error("max depth exceeded");
            let object = {};
            if (options.defaults) {
                object.id = 0;
                object.priceCorrect = 0;
                object.isShort = false;
                object.qty = null;
            }
            if (message.id != null && message.hasOwnProperty("id"))
                object.id = message.id;
            if (message.priceCorrect != null && message.hasOwnProperty("priceCorrect"))
                object.priceCorrect = options.json && !isFinite(message.priceCorrect) ? String(message.priceCorrect) : message.priceCorrect;
            if (message.isShort != null && message.hasOwnProperty("isShort"))
                object.isShort = message.isShort;
            if (message.qty != null && message.hasOwnProperty("qty"))
                object.qty = $root.cqg.Decimal.toObject(message.qty, options, _depth + 1);
            return object;
        };

        /**
         * Converts this OpenPosition to JSON.
         * @function toJSON
         * @memberof cqg.OpenPosition
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        OpenPosition.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the type url for OpenPosition
         * @function getTypeUrl
         * @memberof cqg.OpenPosition
         * @static
         * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
         * @returns {string} The type url
         */
        OpenPosition.getTypeUrl = function getTypeUrl(prefix) {
            if (prefix === undefined)
                prefix = "type.googleapis.com";
            return prefix + "/cqg.OpenPosition";
        };

        return OpenPosition;
    })();

    cqg.Decimal = (function() {

        /**
         * Properties of a Decimal.
         * @typedef {Object} cqg.Decimal.$Properties
         * @property {number|null} [significand] Decimal significand
         * @property {number|null} [exponent] Decimal exponent
         * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding
         */

        /**
         * Properties of a Decimal.
         * @memberof cqg
         * @interface IDecimal
         * @augments cqg.Decimal.$Properties
         * @deprecated Use cqg.Decimal.$Properties instead.
         */

        /**
         * Shape of a Decimal.
         * @typedef {cqg.Decimal.$Properties} cqg.Decimal.$Shape
         */

        /**
         * Constructs a new Decimal.
         * @memberof cqg
         * @classdesc Represents a Decimal.
         * @constructor
         * @param {cqg.Decimal.$Properties=} [properties] Properties to set
         * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding
         */
        function Decimal(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null && keys[i] !== "__proto__")
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Decimal significand.
         * @member {number} significand
         * @memberof cqg.Decimal
         * @instance
         */
        Decimal.prototype.significand = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * Decimal exponent.
         * @member {number} exponent
         * @memberof cqg.Decimal
         * @instance
         */
        Decimal.prototype.exponent = 0;

        /**
         * Creates a new Decimal instance using the specified properties.
         * @function create
         * @memberof cqg.Decimal
         * @static
         * @param {cqg.Decimal.$Properties=} [properties] Properties to set
         * @returns {cqg.Decimal} Decimal instance
         * @type {{
         *   (properties: cqg.Decimal.$Shape): cqg.Decimal & cqg.Decimal.$Shape;
         *   (properties?: cqg.Decimal.$Properties): cqg.Decimal;
         * }}
         */
        Decimal.create = function create(properties) {
            return new Decimal(properties);
        };

        /**
         * Encodes the specified Decimal message. Does not implicitly {@link cqg.Decimal.verify|verify} messages.
         * @function encode
         * @memberof cqg.Decimal
         * @static
         * @param {cqg.Decimal.$Properties} message Decimal message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Decimal.encode = function encode(message, writer, _depth) {
            if (!writer)
                writer = $Writer.create();
            if (_depth === undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw Error("max depth exceeded");
            if (message.significand != null && Object.hasOwnProperty.call(message, "significand"))
                writer.uint32(/* id 1, wireType 0 =*/8).sint64(message.significand);
            if (message.exponent != null && Object.hasOwnProperty.call(message, "exponent"))
                writer.uint32(/* id 2, wireType 0 =*/16).sint32(message.exponent);
            if (message.$unknowns != null && Object.hasOwnProperty.call(message, "$unknowns"))
                for (let i = 0; i < message.$unknowns.length; ++i)
                    writer.raw(message.$unknowns[i]);
            return writer;
        };

        /**
         * Encodes the specified Decimal message, length delimited. Does not implicitly {@link cqg.Decimal.verify|verify} messages.
         * @function encodeDelimited
         * @memberof cqg.Decimal
         * @static
         * @param {cqg.Decimal.$Properties} message Decimal message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Decimal.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer && writer.len ? writer.fork() : writer).ldelim();
        };

        /**
         * Decodes a Decimal message from the specified reader or buffer.
         * @function decode
         * @memberof cqg.Decimal
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {cqg.Decimal & cqg.Decimal.$Shape} Decimal
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Decimal.decode = function decode(reader, length, _end, _depth, _target) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            if (_depth === undefined)
                _depth = 0;
            if (_depth > $Reader.recursionLimit)
                throw Error("max depth exceeded");
            let end = length === undefined ? reader.len : reader.pos + length, message = _target || new $root.cqg.Decimal(), value;
            while (reader.pos < end) {
                let start = reader.pos;
                let tag = reader.tag();
                if (tag === _end) {
                    _end = undefined;
                    break;
                }
                let wireType = tag & 7;
                switch (tag >>>= 3) {
                case 1: {
                        if (wireType !== 0)
                            break;
                        if (typeof (value = reader.sint64()) === "object" ? value.low || value.high : value !== 0)
                            message.significand = value;
                        else
                            delete message.significand;
                        continue;
                    }
                case 2: {
                        if (wireType !== 0)
                            break;
                        if (value = reader.sint32())
                            message.exponent = value;
                        else
                            delete message.exponent;
                        continue;
                    }
                }
                reader.skipType(wireType, _depth, tag);
                if (!reader.discardUnknown) {
                    $util.makeProp(message, "$unknowns", false);
                    (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
                }
            }
            if (_end !== undefined)
                throw Error("missing end group");
            return message;
        };

        /**
         * Decodes a Decimal message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof cqg.Decimal
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {cqg.Decimal & cqg.Decimal.$Shape} Decimal
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Decimal.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a Decimal message.
         * @function verify
         * @memberof cqg.Decimal
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        Decimal.verify = function verify(message, _depth) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (_depth === undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                return "max depth exceeded";
            if (message.significand != null && message.hasOwnProperty("significand"))
                if (!$util.isInteger(message.significand) && !(message.significand && $util.isInteger(message.significand.low) && $util.isInteger(message.significand.high)))
                    return "significand: integer|Long expected";
            if (message.exponent != null && message.hasOwnProperty("exponent"))
                if (!$util.isInteger(message.exponent))
                    return "exponent: integer expected";
            return null;
        };

        /**
         * Creates a Decimal message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof cqg.Decimal
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {cqg.Decimal} Decimal
         */
        Decimal.fromObject = function fromObject(object, _depth) {
            if (object instanceof $root.cqg.Decimal)
                return object;
            if (!$util.isObject(object))
                throw TypeError(".cqg.Decimal: object expected");
            if (_depth === undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw Error("max depth exceeded");
            let message = new $root.cqg.Decimal();
            if (object.significand != null)
                if (typeof object.significand === "object" ? object.significand.low || object.significand.high : Number(object.significand) !== 0)
                    if ($util.Long)
                        message.significand = $util.Long.fromValue(object.significand, false);
                    else if (typeof object.significand === "string")
                        message.significand = parseInt(object.significand, 10);
                    else if (typeof object.significand === "number")
                        message.significand = object.significand;
                    else if (typeof object.significand === "object")
                        message.significand = new $util.LongBits(object.significand.low >>> 0, object.significand.high >>> 0).toNumber();
            if (object.exponent != null)
                if (Number(object.exponent) !== 0)
                    message.exponent = object.exponent | 0;
            return message;
        };

        /**
         * Creates a plain object from a Decimal message. Also converts values to other types if specified.
         * @function toObject
         * @memberof cqg.Decimal
         * @static
         * @param {cqg.Decimal} message Decimal
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Decimal.toObject = function toObject(message, options, _depth) {
            if (!options)
                options = {};
            if (_depth === undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw Error("max depth exceeded");
            let object = {};
            if (options.defaults) {
                if ($util.Long) {
                    let long = new $util.Long(0, 0, false);
                    object.significand = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : typeof BigInt !== "undefined" && options.longs === BigInt ? long.toBigInt() : long;
                } else
                    object.significand = options.longs === String ? "0" : typeof BigInt !== "undefined" && options.longs === BigInt ? BigInt("0") : 0;
                object.exponent = 0;
            }
            if (message.significand != null && message.hasOwnProperty("significand"))
                if (typeof BigInt !== "undefined" && options.longs === BigInt)
                    object.significand = typeof message.significand === "number" ? BigInt(message.significand) : $util.Long.fromBits(message.significand.low >>> 0, message.significand.high >>> 0, false).toBigInt();
                else if (typeof message.significand === "number")
                    object.significand = options.longs === String ? String(message.significand) : message.significand;
                else
                    object.significand = options.longs === String ? $util.Long.prototype.toString.call(message.significand) : options.longs === Number ? new $util.LongBits(message.significand.low >>> 0, message.significand.high >>> 0).toNumber() : message.significand;
            if (message.exponent != null && message.hasOwnProperty("exponent"))
                object.exponent = message.exponent;
            return object;
        };

        /**
         * Converts this Decimal to JSON.
         * @function toJSON
         * @memberof cqg.Decimal
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Decimal.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the type url for Decimal
         * @function getTypeUrl
         * @memberof cqg.Decimal
         * @static
         * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
         * @returns {string} The type url
         */
        Decimal.getTypeUrl = function getTypeUrl(prefix) {
            if (prefix === undefined)
                prefix = "type.googleapis.com";
            return prefix + "/cqg.Decimal";
        };

        return Decimal;
    })();

    cqg.Timestamp = (function() {

        /**
         * Properties of a Timestamp.
         * @typedef {Object} cqg.Timestamp.$Properties
         * @property {number|null} [seconds] Timestamp seconds
         * @property {number|null} [nanos] Timestamp nanos
         * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding
         */

        /**
         * Properties of a Timestamp.
         * @memberof cqg
         * @interface ITimestamp
         * @augments cqg.Timestamp.$Properties
         * @deprecated Use cqg.Timestamp.$Properties instead.
         */

        /**
         * Shape of a Timestamp.
         * @typedef {cqg.Timestamp.$Properties} cqg.Timestamp.$Shape
         */

        /**
         * Constructs a new Timestamp.
         * @memberof cqg
         * @classdesc Represents a Timestamp.
         * @constructor
         * @param {cqg.Timestamp.$Properties=} [properties] Properties to set
         * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding
         */
        function Timestamp(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null && keys[i] !== "__proto__")
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Timestamp seconds.
         * @member {number} seconds
         * @memberof cqg.Timestamp
         * @instance
         */
        Timestamp.prototype.seconds = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * Timestamp nanos.
         * @member {number} nanos
         * @memberof cqg.Timestamp
         * @instance
         */
        Timestamp.prototype.nanos = 0;

        /**
         * Creates a new Timestamp instance using the specified properties.
         * @function create
         * @memberof cqg.Timestamp
         * @static
         * @param {cqg.Timestamp.$Properties=} [properties] Properties to set
         * @returns {cqg.Timestamp} Timestamp instance
         * @type {{
         *   (properties: cqg.Timestamp.$Shape): cqg.Timestamp & cqg.Timestamp.$Shape;
         *   (properties?: cqg.Timestamp.$Properties): cqg.Timestamp;
         * }}
         */
        Timestamp.create = function create(properties) {
            return new Timestamp(properties);
        };

        /**
         * Encodes the specified Timestamp message. Does not implicitly {@link cqg.Timestamp.verify|verify} messages.
         * @function encode
         * @memberof cqg.Timestamp
         * @static
         * @param {cqg.Timestamp.$Properties} message Timestamp message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Timestamp.encode = function encode(message, writer, _depth) {
            if (!writer)
                writer = $Writer.create();
            if (_depth === undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw Error("max depth exceeded");
            if (message.seconds != null && Object.hasOwnProperty.call(message, "seconds"))
                writer.uint32(/* id 1, wireType 0 =*/8).int64(message.seconds);
            if (message.nanos != null && Object.hasOwnProperty.call(message, "nanos"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.nanos);
            if (message.$unknowns != null && Object.hasOwnProperty.call(message, "$unknowns"))
                for (let i = 0; i < message.$unknowns.length; ++i)
                    writer.raw(message.$unknowns[i]);
            return writer;
        };

        /**
         * Encodes the specified Timestamp message, length delimited. Does not implicitly {@link cqg.Timestamp.verify|verify} messages.
         * @function encodeDelimited
         * @memberof cqg.Timestamp
         * @static
         * @param {cqg.Timestamp.$Properties} message Timestamp message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Timestamp.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer && writer.len ? writer.fork() : writer).ldelim();
        };

        /**
         * Decodes a Timestamp message from the specified reader or buffer.
         * @function decode
         * @memberof cqg.Timestamp
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {cqg.Timestamp & cqg.Timestamp.$Shape} Timestamp
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Timestamp.decode = function decode(reader, length, _end, _depth, _target) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            if (_depth === undefined)
                _depth = 0;
            if (_depth > $Reader.recursionLimit)
                throw Error("max depth exceeded");
            let end = length === undefined ? reader.len : reader.pos + length, message = _target || new $root.cqg.Timestamp(), value;
            while (reader.pos < end) {
                let start = reader.pos;
                let tag = reader.tag();
                if (tag === _end) {
                    _end = undefined;
                    break;
                }
                let wireType = tag & 7;
                switch (tag >>>= 3) {
                case 1: {
                        if (wireType !== 0)
                            break;
                        if (typeof (value = reader.int64()) === "object" ? value.low || value.high : value !== 0)
                            message.seconds = value;
                        else
                            delete message.seconds;
                        continue;
                    }
                case 2: {
                        if (wireType !== 0)
                            break;
                        if (value = reader.int32())
                            message.nanos = value;
                        else
                            delete message.nanos;
                        continue;
                    }
                }
                reader.skipType(wireType, _depth, tag);
                if (!reader.discardUnknown) {
                    $util.makeProp(message, "$unknowns", false);
                    (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
                }
            }
            if (_end !== undefined)
                throw Error("missing end group");
            return message;
        };

        /**
         * Decodes a Timestamp message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof cqg.Timestamp
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {cqg.Timestamp & cqg.Timestamp.$Shape} Timestamp
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Timestamp.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a Timestamp message.
         * @function verify
         * @memberof cqg.Timestamp
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        Timestamp.verify = function verify(message, _depth) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (_depth === undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                return "max depth exceeded";
            if (message.seconds != null && message.hasOwnProperty("seconds"))
                if (!$util.isInteger(message.seconds) && !(message.seconds && $util.isInteger(message.seconds.low) && $util.isInteger(message.seconds.high)))
                    return "seconds: integer|Long expected";
            if (message.nanos != null && message.hasOwnProperty("nanos"))
                if (!$util.isInteger(message.nanos))
                    return "nanos: integer expected";
            return null;
        };

        /**
         * Creates a Timestamp message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof cqg.Timestamp
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {cqg.Timestamp} Timestamp
         */
        Timestamp.fromObject = function fromObject(object, _depth) {
            if (object instanceof $root.cqg.Timestamp)
                return object;
            if (!$util.isObject(object))
                throw TypeError(".cqg.Timestamp: object expected");
            if (_depth === undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw Error("max depth exceeded");
            let message = new $root.cqg.Timestamp();
            if (object.seconds != null)
                if (typeof object.seconds === "object" ? object.seconds.low || object.seconds.high : Number(object.seconds) !== 0)
                    if ($util.Long)
                        message.seconds = $util.Long.fromValue(object.seconds, false);
                    else if (typeof object.seconds === "string")
                        message.seconds = parseInt(object.seconds, 10);
                    else if (typeof object.seconds === "number")
                        message.seconds = object.seconds;
                    else if (typeof object.seconds === "object")
                        message.seconds = new $util.LongBits(object.seconds.low >>> 0, object.seconds.high >>> 0).toNumber();
            if (object.nanos != null)
                if (Number(object.nanos) !== 0)
                    message.nanos = object.nanos | 0;
            return message;
        };

        /**
         * Creates a plain object from a Timestamp message. Also converts values to other types if specified.
         * @function toObject
         * @memberof cqg.Timestamp
         * @static
         * @param {cqg.Timestamp} message Timestamp
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Timestamp.toObject = function toObject(message, options, _depth) {
            if (!options)
                options = {};
            if (_depth === undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw Error("max depth exceeded");
            let object = {};
            if (options.defaults) {
                if ($util.Long) {
                    let long = new $util.Long(0, 0, false);
                    object.seconds = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : typeof BigInt !== "undefined" && options.longs === BigInt ? long.toBigInt() : long;
                } else
                    object.seconds = options.longs === String ? "0" : typeof BigInt !== "undefined" && options.longs === BigInt ? BigInt("0") : 0;
                object.nanos = 0;
            }
            if (message.seconds != null && message.hasOwnProperty("seconds"))
                if (typeof BigInt !== "undefined" && options.longs === BigInt)
                    object.seconds = typeof message.seconds === "number" ? BigInt(message.seconds) : $util.Long.fromBits(message.seconds.low >>> 0, message.seconds.high >>> 0, false).toBigInt();
                else if (typeof message.seconds === "number")
                    object.seconds = options.longs === String ? String(message.seconds) : message.seconds;
                else
                    object.seconds = options.longs === String ? $util.Long.prototype.toString.call(message.seconds) : options.longs === Number ? new $util.LongBits(message.seconds.low >>> 0, message.seconds.high >>> 0).toNumber() : message.seconds;
            if (message.nanos != null && message.hasOwnProperty("nanos"))
                object.nanos = message.nanos;
            return object;
        };

        /**
         * Converts this Timestamp to JSON.
         * @function toJSON
         * @memberof cqg.Timestamp
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Timestamp.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the type url for Timestamp
         * @function getTypeUrl
         * @memberof cqg.Timestamp
         * @static
         * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
         * @returns {string} The type url
         */
        Timestamp.getTypeUrl = function getTypeUrl(prefix) {
            if (prefix === undefined)
                prefix = "type.googleapis.com";
            return prefix + "/cqg.Timestamp";
        };

        return Timestamp;
    })();

    cqg.ContractMetadata = (function() {

        /**
         * Properties of a ContractMetadata.
         * @typedef {Object} cqg.ContractMetadata.$Properties
         * @property {number|null} [contractId] ContractMetadata contractId
         * @property {number|null} [correctPriceScale] ContractMetadata correctPriceScale
         * @property {number|null} [tickSize] ContractMetadata tickSize
         * @property {number|null} [tickValue] ContractMetadata tickValue
         * @property {string|null} [contractSymbol] ContractMetadata contractSymbol
         * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding
         */

        /**
         * Properties of a ContractMetadata.
         * @memberof cqg
         * @interface IContractMetadata
         * @augments cqg.ContractMetadata.$Properties
         * @deprecated Use cqg.ContractMetadata.$Properties instead.
         */

        /**
         * Shape of a ContractMetadata.
         * @typedef {cqg.ContractMetadata.$Properties} cqg.ContractMetadata.$Shape
         */

        /**
         * Constructs a new ContractMetadata.
         * @memberof cqg
         * @classdesc Represents a ContractMetadata.
         * @constructor
         * @param {cqg.ContractMetadata.$Properties=} [properties] Properties to set
         * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding
         */
        function ContractMetadata(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null && keys[i] !== "__proto__")
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ContractMetadata contractId.
         * @member {number} contractId
         * @memberof cqg.ContractMetadata
         * @instance
         */
        ContractMetadata.prototype.contractId = 0;

        /**
         * ContractMetadata correctPriceScale.
         * @member {number} correctPriceScale
         * @memberof cqg.ContractMetadata
         * @instance
         */
        ContractMetadata.prototype.correctPriceScale = 0;

        /**
         * ContractMetadata tickSize.
         * @member {number} tickSize
         * @memberof cqg.ContractMetadata
         * @instance
         */
        ContractMetadata.prototype.tickSize = 0;

        /**
         * ContractMetadata tickValue.
         * @member {number} tickValue
         * @memberof cqg.ContractMetadata
         * @instance
         */
        ContractMetadata.prototype.tickValue = 0;

        /**
         * ContractMetadata contractSymbol.
         * @member {string} contractSymbol
         * @memberof cqg.ContractMetadata
         * @instance
         */
        ContractMetadata.prototype.contractSymbol = "";

        /**
         * Creates a new ContractMetadata instance using the specified properties.
         * @function create
         * @memberof cqg.ContractMetadata
         * @static
         * @param {cqg.ContractMetadata.$Properties=} [properties] Properties to set
         * @returns {cqg.ContractMetadata} ContractMetadata instance
         * @type {{
         *   (properties: cqg.ContractMetadata.$Shape): cqg.ContractMetadata & cqg.ContractMetadata.$Shape;
         *   (properties?: cqg.ContractMetadata.$Properties): cqg.ContractMetadata;
         * }}
         */
        ContractMetadata.create = function create(properties) {
            return new ContractMetadata(properties);
        };

        /**
         * Encodes the specified ContractMetadata message. Does not implicitly {@link cqg.ContractMetadata.verify|verify} messages.
         * @function encode
         * @memberof cqg.ContractMetadata
         * @static
         * @param {cqg.ContractMetadata.$Properties} message ContractMetadata message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ContractMetadata.encode = function encode(message, writer, _depth) {
            if (!writer)
                writer = $Writer.create();
            if (_depth === undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw Error("max depth exceeded");
            if (message.contractId != null && Object.hasOwnProperty.call(message, "contractId"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.contractId);
            if (message.correctPriceScale != null && Object.hasOwnProperty.call(message, "correctPriceScale"))
                writer.uint32(/* id 3, wireType 1 =*/25).double(message.correctPriceScale);
            if (message.tickSize != null && Object.hasOwnProperty.call(message, "tickSize"))
                writer.uint32(/* id 7, wireType 1 =*/57).double(message.tickSize);
            if (message.tickValue != null && Object.hasOwnProperty.call(message, "tickValue"))
                writer.uint32(/* id 9, wireType 1 =*/73).double(message.tickValue);
            if (message.contractSymbol != null && Object.hasOwnProperty.call(message, "contractSymbol"))
                writer.uint32(/* id 70, wireType 2 =*/562).string(message.contractSymbol);
            if (message.$unknowns != null && Object.hasOwnProperty.call(message, "$unknowns"))
                for (let i = 0; i < message.$unknowns.length; ++i)
                    writer.raw(message.$unknowns[i]);
            return writer;
        };

        /**
         * Encodes the specified ContractMetadata message, length delimited. Does not implicitly {@link cqg.ContractMetadata.verify|verify} messages.
         * @function encodeDelimited
         * @memberof cqg.ContractMetadata
         * @static
         * @param {cqg.ContractMetadata.$Properties} message ContractMetadata message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ContractMetadata.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer && writer.len ? writer.fork() : writer).ldelim();
        };

        /**
         * Decodes a ContractMetadata message from the specified reader or buffer.
         * @function decode
         * @memberof cqg.ContractMetadata
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {cqg.ContractMetadata & cqg.ContractMetadata.$Shape} ContractMetadata
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ContractMetadata.decode = function decode(reader, length, _end, _depth, _target) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            if (_depth === undefined)
                _depth = 0;
            if (_depth > $Reader.recursionLimit)
                throw Error("max depth exceeded");
            let end = length === undefined ? reader.len : reader.pos + length, message = _target || new $root.cqg.ContractMetadata(), value;
            while (reader.pos < end) {
                let start = reader.pos;
                let tag = reader.tag();
                if (tag === _end) {
                    _end = undefined;
                    break;
                }
                let wireType = tag & 7;
                switch (tag >>>= 3) {
                case 1: {
                        if (wireType !== 0)
                            break;
                        if (value = reader.uint32())
                            message.contractId = value;
                        else
                            delete message.contractId;
                        continue;
                    }
                case 3: {
                        if (wireType !== 1)
                            break;
                        if ((value = reader.double()) !== 0)
                            message.correctPriceScale = value;
                        else
                            delete message.correctPriceScale;
                        continue;
                    }
                case 7: {
                        if (wireType !== 1)
                            break;
                        if ((value = reader.double()) !== 0)
                            message.tickSize = value;
                        else
                            delete message.tickSize;
                        continue;
                    }
                case 9: {
                        if (wireType !== 1)
                            break;
                        if ((value = reader.double()) !== 0)
                            message.tickValue = value;
                        else
                            delete message.tickValue;
                        continue;
                    }
                case 70: {
                        if (wireType !== 2)
                            break;
                        if ((value = reader.string()).length)
                            message.contractSymbol = value;
                        else
                            delete message.contractSymbol;
                        continue;
                    }
                }
                reader.skipType(wireType, _depth, tag);
                if (!reader.discardUnknown) {
                    $util.makeProp(message, "$unknowns", false);
                    (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
                }
            }
            if (_end !== undefined)
                throw Error("missing end group");
            return message;
        };

        /**
         * Decodes a ContractMetadata message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof cqg.ContractMetadata
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {cqg.ContractMetadata & cqg.ContractMetadata.$Shape} ContractMetadata
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ContractMetadata.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a ContractMetadata message.
         * @function verify
         * @memberof cqg.ContractMetadata
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ContractMetadata.verify = function verify(message, _depth) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (_depth === undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                return "max depth exceeded";
            if (message.contractId != null && message.hasOwnProperty("contractId"))
                if (!$util.isInteger(message.contractId))
                    return "contractId: integer expected";
            if (message.correctPriceScale != null && message.hasOwnProperty("correctPriceScale"))
                if (typeof message.correctPriceScale !== "number")
                    return "correctPriceScale: number expected";
            if (message.tickSize != null && message.hasOwnProperty("tickSize"))
                if (typeof message.tickSize !== "number")
                    return "tickSize: number expected";
            if (message.tickValue != null && message.hasOwnProperty("tickValue"))
                if (typeof message.tickValue !== "number")
                    return "tickValue: number expected";
            if (message.contractSymbol != null && message.hasOwnProperty("contractSymbol"))
                if (!$util.isString(message.contractSymbol))
                    return "contractSymbol: string expected";
            return null;
        };

        /**
         * Creates a ContractMetadata message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof cqg.ContractMetadata
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {cqg.ContractMetadata} ContractMetadata
         */
        ContractMetadata.fromObject = function fromObject(object, _depth) {
            if (object instanceof $root.cqg.ContractMetadata)
                return object;
            if (!$util.isObject(object))
                throw TypeError(".cqg.ContractMetadata: object expected");
            if (_depth === undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw Error("max depth exceeded");
            let message = new $root.cqg.ContractMetadata();
            if (object.contractId != null)
                if (Number(object.contractId) !== 0)
                    message.contractId = object.contractId >>> 0;
            if (object.correctPriceScale != null)
                if (Number(object.correctPriceScale) !== 0)
                    message.correctPriceScale = Number(object.correctPriceScale);
            if (object.tickSize != null)
                if (Number(object.tickSize) !== 0)
                    message.tickSize = Number(object.tickSize);
            if (object.tickValue != null)
                if (Number(object.tickValue) !== 0)
                    message.tickValue = Number(object.tickValue);
            if (object.contractSymbol != null)
                if (typeof object.contractSymbol !== "string" || object.contractSymbol.length)
                    message.contractSymbol = String(object.contractSymbol);
            return message;
        };

        /**
         * Creates a plain object from a ContractMetadata message. Also converts values to other types if specified.
         * @function toObject
         * @memberof cqg.ContractMetadata
         * @static
         * @param {cqg.ContractMetadata} message ContractMetadata
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ContractMetadata.toObject = function toObject(message, options, _depth) {
            if (!options)
                options = {};
            if (_depth === undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw Error("max depth exceeded");
            let object = {};
            if (options.defaults) {
                object.contractId = 0;
                object.correctPriceScale = 0;
                object.tickSize = 0;
                object.tickValue = 0;
                object.contractSymbol = "";
            }
            if (message.contractId != null && message.hasOwnProperty("contractId"))
                object.contractId = message.contractId;
            if (message.correctPriceScale != null && message.hasOwnProperty("correctPriceScale"))
                object.correctPriceScale = options.json && !isFinite(message.correctPriceScale) ? String(message.correctPriceScale) : message.correctPriceScale;
            if (message.tickSize != null && message.hasOwnProperty("tickSize"))
                object.tickSize = options.json && !isFinite(message.tickSize) ? String(message.tickSize) : message.tickSize;
            if (message.tickValue != null && message.hasOwnProperty("tickValue"))
                object.tickValue = options.json && !isFinite(message.tickValue) ? String(message.tickValue) : message.tickValue;
            if (message.contractSymbol != null && message.hasOwnProperty("contractSymbol"))
                object.contractSymbol = message.contractSymbol;
            return object;
        };

        /**
         * Converts this ContractMetadata to JSON.
         * @function toJSON
         * @memberof cqg.ContractMetadata
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ContractMetadata.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the type url for ContractMetadata
         * @function getTypeUrl
         * @memberof cqg.ContractMetadata
         * @static
         * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
         * @returns {string} The type url
         */
        ContractMetadata.getTypeUrl = function getTypeUrl(prefix) {
            if (prefix === undefined)
                prefix = "type.googleapis.com";
            return prefix + "/cqg.ContractMetadata";
        };

        return ContractMetadata;
    })();

    cqg.RealTimeMarketData = (function() {

        /**
         * Properties of a RealTimeMarketData.
         * @typedef {Object} cqg.RealTimeMarketData.$Properties
         * @property {number|null} [contractId] RealTimeMarketData contractId
         * @property {Array.<cqg.Quote.$Properties>|null} [quotes] RealTimeMarketData quotes
         * @property {number|null} [correctPriceScale] RealTimeMarketData correctPriceScale
         * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding
         */

        /**
         * Properties of a RealTimeMarketData.
         * @memberof cqg
         * @interface IRealTimeMarketData
         * @augments cqg.RealTimeMarketData.$Properties
         * @deprecated Use cqg.RealTimeMarketData.$Properties instead.
         */

        /**
         * Shape of a RealTimeMarketData.
         * @typedef {cqg.RealTimeMarketData.$Properties} cqg.RealTimeMarketData.$Shape
         */

        /**
         * Constructs a new RealTimeMarketData.
         * @memberof cqg
         * @classdesc Represents a RealTimeMarketData.
         * @constructor
         * @param {cqg.RealTimeMarketData.$Properties=} [properties] Properties to set
         * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding
         */
        function RealTimeMarketData(properties) {
            this.quotes = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null && keys[i] !== "__proto__")
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * RealTimeMarketData contractId.
         * @member {number} contractId
         * @memberof cqg.RealTimeMarketData
         * @instance
         */
        RealTimeMarketData.prototype.contractId = 0;

        /**
         * RealTimeMarketData quotes.
         * @member {Array.<cqg.Quote.$Properties>} quotes
         * @memberof cqg.RealTimeMarketData
         * @instance
         */
        RealTimeMarketData.prototype.quotes = $util.emptyArray;

        /**
         * RealTimeMarketData correctPriceScale.
         * @member {number} correctPriceScale
         * @memberof cqg.RealTimeMarketData
         * @instance
         */
        RealTimeMarketData.prototype.correctPriceScale = 0;

        /**
         * Creates a new RealTimeMarketData instance using the specified properties.
         * @function create
         * @memberof cqg.RealTimeMarketData
         * @static
         * @param {cqg.RealTimeMarketData.$Properties=} [properties] Properties to set
         * @returns {cqg.RealTimeMarketData} RealTimeMarketData instance
         * @type {{
         *   (properties: cqg.RealTimeMarketData.$Shape): cqg.RealTimeMarketData & cqg.RealTimeMarketData.$Shape;
         *   (properties?: cqg.RealTimeMarketData.$Properties): cqg.RealTimeMarketData;
         * }}
         */
        RealTimeMarketData.create = function create(properties) {
            return new RealTimeMarketData(properties);
        };

        /**
         * Encodes the specified RealTimeMarketData message. Does not implicitly {@link cqg.RealTimeMarketData.verify|verify} messages.
         * @function encode
         * @memberof cqg.RealTimeMarketData
         * @static
         * @param {cqg.RealTimeMarketData.$Properties} message RealTimeMarketData message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        RealTimeMarketData.encode = function encode(message, writer, _depth) {
            if (!writer)
                writer = $Writer.create();
            if (_depth === undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw Error("max depth exceeded");
            if (message.contractId != null && Object.hasOwnProperty.call(message, "contractId"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.contractId);
            if (message.quotes != null && message.quotes.length)
                for (let i = 0; i < message.quotes.length; ++i)
                    $root.cqg.Quote.encode(message.quotes[i], writer.uint32(/* id 2, wireType 2 =*/18).fork(), _depth + 1).ldelim();
            if (message.correctPriceScale != null && Object.hasOwnProperty.call(message, "correctPriceScale"))
                writer.uint32(/* id 19, wireType 1 =*/153).double(message.correctPriceScale);
            if (message.$unknowns != null && Object.hasOwnProperty.call(message, "$unknowns"))
                for (let i = 0; i < message.$unknowns.length; ++i)
                    writer.raw(message.$unknowns[i]);
            return writer;
        };

        /**
         * Encodes the specified RealTimeMarketData message, length delimited. Does not implicitly {@link cqg.RealTimeMarketData.verify|verify} messages.
         * @function encodeDelimited
         * @memberof cqg.RealTimeMarketData
         * @static
         * @param {cqg.RealTimeMarketData.$Properties} message RealTimeMarketData message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        RealTimeMarketData.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer && writer.len ? writer.fork() : writer).ldelim();
        };

        /**
         * Decodes a RealTimeMarketData message from the specified reader or buffer.
         * @function decode
         * @memberof cqg.RealTimeMarketData
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {cqg.RealTimeMarketData & cqg.RealTimeMarketData.$Shape} RealTimeMarketData
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        RealTimeMarketData.decode = function decode(reader, length, _end, _depth, _target) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            if (_depth === undefined)
                _depth = 0;
            if (_depth > $Reader.recursionLimit)
                throw Error("max depth exceeded");
            let end = length === undefined ? reader.len : reader.pos + length, message = _target || new $root.cqg.RealTimeMarketData(), value;
            while (reader.pos < end) {
                let start = reader.pos;
                let tag = reader.tag();
                if (tag === _end) {
                    _end = undefined;
                    break;
                }
                let wireType = tag & 7;
                switch (tag >>>= 3) {
                case 1: {
                        if (wireType !== 0)
                            break;
                        if (value = reader.uint32())
                            message.contractId = value;
                        else
                            delete message.contractId;
                        continue;
                    }
                case 2: {
                        if (wireType !== 2)
                            break;
                        if (!(message.quotes && message.quotes.length))
                            message.quotes = [];
                        message.quotes.push($root.cqg.Quote.decode(reader, reader.uint32(), undefined, _depth + 1));
                        continue;
                    }
                case 19: {
                        if (wireType !== 1)
                            break;
                        if ((value = reader.double()) !== 0)
                            message.correctPriceScale = value;
                        else
                            delete message.correctPriceScale;
                        continue;
                    }
                }
                reader.skipType(wireType, _depth, tag);
                if (!reader.discardUnknown) {
                    $util.makeProp(message, "$unknowns", false);
                    (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
                }
            }
            if (_end !== undefined)
                throw Error("missing end group");
            return message;
        };

        /**
         * Decodes a RealTimeMarketData message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof cqg.RealTimeMarketData
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {cqg.RealTimeMarketData & cqg.RealTimeMarketData.$Shape} RealTimeMarketData
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        RealTimeMarketData.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a RealTimeMarketData message.
         * @function verify
         * @memberof cqg.RealTimeMarketData
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        RealTimeMarketData.verify = function verify(message, _depth) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (_depth === undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                return "max depth exceeded";
            if (message.contractId != null && message.hasOwnProperty("contractId"))
                if (!$util.isInteger(message.contractId))
                    return "contractId: integer expected";
            if (message.quotes != null && message.hasOwnProperty("quotes")) {
                if (!Array.isArray(message.quotes))
                    return "quotes: array expected";
                for (let i = 0; i < message.quotes.length; ++i) {
                    let error = $root.cqg.Quote.verify(message.quotes[i], _depth + 1);
                    if (error)
                        return "quotes." + error;
                }
            }
            if (message.correctPriceScale != null && message.hasOwnProperty("correctPriceScale"))
                if (typeof message.correctPriceScale !== "number")
                    return "correctPriceScale: number expected";
            return null;
        };

        /**
         * Creates a RealTimeMarketData message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof cqg.RealTimeMarketData
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {cqg.RealTimeMarketData} RealTimeMarketData
         */
        RealTimeMarketData.fromObject = function fromObject(object, _depth) {
            if (object instanceof $root.cqg.RealTimeMarketData)
                return object;
            if (!$util.isObject(object))
                throw TypeError(".cqg.RealTimeMarketData: object expected");
            if (_depth === undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw Error("max depth exceeded");
            let message = new $root.cqg.RealTimeMarketData();
            if (object.contractId != null)
                if (Number(object.contractId) !== 0)
                    message.contractId = object.contractId >>> 0;
            if (object.quotes) {
                if (!Array.isArray(object.quotes))
                    throw TypeError(".cqg.RealTimeMarketData.quotes: array expected");
                message.quotes = Array(object.quotes.length);
                for (let i = 0; i < object.quotes.length; ++i) {
                    if (!$util.isObject(object.quotes[i]))
                        throw TypeError(".cqg.RealTimeMarketData.quotes: object expected");
                    message.quotes[i] = $root.cqg.Quote.fromObject(object.quotes[i], _depth + 1);
                }
            }
            if (object.correctPriceScale != null)
                if (Number(object.correctPriceScale) !== 0)
                    message.correctPriceScale = Number(object.correctPriceScale);
            return message;
        };

        /**
         * Creates a plain object from a RealTimeMarketData message. Also converts values to other types if specified.
         * @function toObject
         * @memberof cqg.RealTimeMarketData
         * @static
         * @param {cqg.RealTimeMarketData} message RealTimeMarketData
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        RealTimeMarketData.toObject = function toObject(message, options, _depth) {
            if (!options)
                options = {};
            if (_depth === undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw Error("max depth exceeded");
            let object = {};
            if (options.arrays || options.defaults)
                object.quotes = [];
            if (options.defaults) {
                object.contractId = 0;
                object.correctPriceScale = 0;
            }
            if (message.contractId != null && message.hasOwnProperty("contractId"))
                object.contractId = message.contractId;
            if (message.quotes && message.quotes.length) {
                object.quotes = Array(message.quotes.length);
                for (let j = 0; j < message.quotes.length; ++j)
                    object.quotes[j] = $root.cqg.Quote.toObject(message.quotes[j], options, _depth + 1);
            }
            if (message.correctPriceScale != null && message.hasOwnProperty("correctPriceScale"))
                object.correctPriceScale = options.json && !isFinite(message.correctPriceScale) ? String(message.correctPriceScale) : message.correctPriceScale;
            return object;
        };

        /**
         * Converts this RealTimeMarketData to JSON.
         * @function toJSON
         * @memberof cqg.RealTimeMarketData
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        RealTimeMarketData.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the type url for RealTimeMarketData
         * @function getTypeUrl
         * @memberof cqg.RealTimeMarketData
         * @static
         * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
         * @returns {string} The type url
         */
        RealTimeMarketData.getTypeUrl = function getTypeUrl(prefix) {
            if (prefix === undefined)
                prefix = "type.googleapis.com";
            return prefix + "/cqg.RealTimeMarketData";
        };

        return RealTimeMarketData;
    })();

    cqg.Quote = (function() {

        /**
         * Properties of a Quote.
         * @typedef {Object} cqg.Quote.$Properties
         * @property {number|null} [type] Quote type
         * @property {number|null} [scaledPrice] Quote scaledPrice
         * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding
         */

        /**
         * Properties of a Quote.
         * @memberof cqg
         * @interface IQuote
         * @augments cqg.Quote.$Properties
         * @deprecated Use cqg.Quote.$Properties instead.
         */

        /**
         * Shape of a Quote.
         * @typedef {cqg.Quote.$Properties} cqg.Quote.$Shape
         */

        /**
         * Constructs a new Quote.
         * @memberof cqg
         * @classdesc Represents a Quote.
         * @constructor
         * @param {cqg.Quote.$Properties=} [properties] Properties to set
         * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding
         */
        function Quote(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null && keys[i] !== "__proto__")
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Quote type.
         * @member {number} type
         * @memberof cqg.Quote
         * @instance
         */
        Quote.prototype.type = 0;

        /**
         * Quote scaledPrice.
         * @member {number} scaledPrice
         * @memberof cqg.Quote
         * @instance
         */
        Quote.prototype.scaledPrice = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * Creates a new Quote instance using the specified properties.
         * @function create
         * @memberof cqg.Quote
         * @static
         * @param {cqg.Quote.$Properties=} [properties] Properties to set
         * @returns {cqg.Quote} Quote instance
         * @type {{
         *   (properties: cqg.Quote.$Shape): cqg.Quote & cqg.Quote.$Shape;
         *   (properties?: cqg.Quote.$Properties): cqg.Quote;
         * }}
         */
        Quote.create = function create(properties) {
            return new Quote(properties);
        };

        /**
         * Encodes the specified Quote message. Does not implicitly {@link cqg.Quote.verify|verify} messages.
         * @function encode
         * @memberof cqg.Quote
         * @static
         * @param {cqg.Quote.$Properties} message Quote message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Quote.encode = function encode(message, writer, _depth) {
            if (!writer)
                writer = $Writer.create();
            if (_depth === undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw Error("max depth exceeded");
            if (message.type != null && Object.hasOwnProperty.call(message, "type"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.type);
            if (message.scaledPrice != null && Object.hasOwnProperty.call(message, "scaledPrice"))
                writer.uint32(/* id 3, wireType 0 =*/24).sint64(message.scaledPrice);
            if (message.$unknowns != null && Object.hasOwnProperty.call(message, "$unknowns"))
                for (let i = 0; i < message.$unknowns.length; ++i)
                    writer.raw(message.$unknowns[i]);
            return writer;
        };

        /**
         * Encodes the specified Quote message, length delimited. Does not implicitly {@link cqg.Quote.verify|verify} messages.
         * @function encodeDelimited
         * @memberof cqg.Quote
         * @static
         * @param {cqg.Quote.$Properties} message Quote message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Quote.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer && writer.len ? writer.fork() : writer).ldelim();
        };

        /**
         * Decodes a Quote message from the specified reader or buffer.
         * @function decode
         * @memberof cqg.Quote
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {cqg.Quote & cqg.Quote.$Shape} Quote
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Quote.decode = function decode(reader, length, _end, _depth, _target) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            if (_depth === undefined)
                _depth = 0;
            if (_depth > $Reader.recursionLimit)
                throw Error("max depth exceeded");
            let end = length === undefined ? reader.len : reader.pos + length, message = _target || new $root.cqg.Quote(), value;
            while (reader.pos < end) {
                let start = reader.pos;
                let tag = reader.tag();
                if (tag === _end) {
                    _end = undefined;
                    break;
                }
                let wireType = tag & 7;
                switch (tag >>>= 3) {
                case 1: {
                        if (wireType !== 0)
                            break;
                        if (value = reader.uint32())
                            message.type = value;
                        else
                            delete message.type;
                        continue;
                    }
                case 3: {
                        if (wireType !== 0)
                            break;
                        if (typeof (value = reader.sint64()) === "object" ? value.low || value.high : value !== 0)
                            message.scaledPrice = value;
                        else
                            delete message.scaledPrice;
                        continue;
                    }
                }
                reader.skipType(wireType, _depth, tag);
                if (!reader.discardUnknown) {
                    $util.makeProp(message, "$unknowns", false);
                    (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
                }
            }
            if (_end !== undefined)
                throw Error("missing end group");
            return message;
        };

        /**
         * Decodes a Quote message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof cqg.Quote
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {cqg.Quote & cqg.Quote.$Shape} Quote
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Quote.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a Quote message.
         * @function verify
         * @memberof cqg.Quote
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        Quote.verify = function verify(message, _depth) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (_depth === undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                return "max depth exceeded";
            if (message.type != null && message.hasOwnProperty("type"))
                if (!$util.isInteger(message.type))
                    return "type: integer expected";
            if (message.scaledPrice != null && message.hasOwnProperty("scaledPrice"))
                if (!$util.isInteger(message.scaledPrice) && !(message.scaledPrice && $util.isInteger(message.scaledPrice.low) && $util.isInteger(message.scaledPrice.high)))
                    return "scaledPrice: integer|Long expected";
            return null;
        };

        /**
         * Creates a Quote message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof cqg.Quote
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {cqg.Quote} Quote
         */
        Quote.fromObject = function fromObject(object, _depth) {
            if (object instanceof $root.cqg.Quote)
                return object;
            if (!$util.isObject(object))
                throw TypeError(".cqg.Quote: object expected");
            if (_depth === undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw Error("max depth exceeded");
            let message = new $root.cqg.Quote();
            if (object.type != null)
                if (Number(object.type) !== 0)
                    message.type = object.type >>> 0;
            if (object.scaledPrice != null)
                if (typeof object.scaledPrice === "object" ? object.scaledPrice.low || object.scaledPrice.high : Number(object.scaledPrice) !== 0)
                    if ($util.Long)
                        message.scaledPrice = $util.Long.fromValue(object.scaledPrice, false);
                    else if (typeof object.scaledPrice === "string")
                        message.scaledPrice = parseInt(object.scaledPrice, 10);
                    else if (typeof object.scaledPrice === "number")
                        message.scaledPrice = object.scaledPrice;
                    else if (typeof object.scaledPrice === "object")
                        message.scaledPrice = new $util.LongBits(object.scaledPrice.low >>> 0, object.scaledPrice.high >>> 0).toNumber();
            return message;
        };

        /**
         * Creates a plain object from a Quote message. Also converts values to other types if specified.
         * @function toObject
         * @memberof cqg.Quote
         * @static
         * @param {cqg.Quote} message Quote
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Quote.toObject = function toObject(message, options, _depth) {
            if (!options)
                options = {};
            if (_depth === undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw Error("max depth exceeded");
            let object = {};
            if (options.defaults) {
                object.type = 0;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, false);
                    object.scaledPrice = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : typeof BigInt !== "undefined" && options.longs === BigInt ? long.toBigInt() : long;
                } else
                    object.scaledPrice = options.longs === String ? "0" : typeof BigInt !== "undefined" && options.longs === BigInt ? BigInt("0") : 0;
            }
            if (message.type != null && message.hasOwnProperty("type"))
                object.type = message.type;
            if (message.scaledPrice != null && message.hasOwnProperty("scaledPrice"))
                if (typeof BigInt !== "undefined" && options.longs === BigInt)
                    object.scaledPrice = typeof message.scaledPrice === "number" ? BigInt(message.scaledPrice) : $util.Long.fromBits(message.scaledPrice.low >>> 0, message.scaledPrice.high >>> 0, false).toBigInt();
                else if (typeof message.scaledPrice === "number")
                    object.scaledPrice = options.longs === String ? String(message.scaledPrice) : message.scaledPrice;
                else
                    object.scaledPrice = options.longs === String ? $util.Long.prototype.toString.call(message.scaledPrice) : options.longs === Number ? new $util.LongBits(message.scaledPrice.low >>> 0, message.scaledPrice.high >>> 0).toNumber() : message.scaledPrice;
            return object;
        };

        /**
         * Converts this Quote to JSON.
         * @function toJSON
         * @memberof cqg.Quote
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Quote.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the type url for Quote
         * @function getTypeUrl
         * @memberof cqg.Quote
         * @static
         * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
         * @returns {string} The type url
         */
        Quote.getTypeUrl = function getTypeUrl(prefix) {
            if (prefix === undefined)
                prefix = "type.googleapis.com";
            return prefix + "/cqg.Quote";
        };

        return Quote;
    })();

    cqg.ClientMsg = (function() {

        /**
         * Properties of a ClientMsg.
         * @typedef {Object} cqg.ClientMsg.$Properties
         * @property {Array.<cqg.InformationRequest.$Properties>|null} [informationRequests] ClientMsg informationRequests
         * @property {Array.<cqg.MarketDataSubscription.$Properties>|null} [marketDataSubscriptions] ClientMsg marketDataSubscriptions
         * @property {cqg.Logon.$Properties|null} [logon] ClientMsg logon
         * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding
         */

        /**
         * Properties of a ClientMsg.
         * @memberof cqg
         * @interface IClientMsg
         * @augments cqg.ClientMsg.$Properties
         * @deprecated Use cqg.ClientMsg.$Properties instead.
         */

        /**
         * Shape of a ClientMsg.
         * @typedef {cqg.ClientMsg.$Properties} cqg.ClientMsg.$Shape
         */

        /**
         * Constructs a new ClientMsg.
         * @memberof cqg
         * @classdesc Represents a ClientMsg.
         * @constructor
         * @param {cqg.ClientMsg.$Properties=} [properties] Properties to set
         * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding
         */
        function ClientMsg(properties) {
            this.informationRequests = [];
            this.marketDataSubscriptions = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null && keys[i] !== "__proto__")
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ClientMsg informationRequests.
         * @member {Array.<cqg.InformationRequest.$Properties>} informationRequests
         * @memberof cqg.ClientMsg
         * @instance
         */
        ClientMsg.prototype.informationRequests = $util.emptyArray;

        /**
         * ClientMsg marketDataSubscriptions.
         * @member {Array.<cqg.MarketDataSubscription.$Properties>} marketDataSubscriptions
         * @memberof cqg.ClientMsg
         * @instance
         */
        ClientMsg.prototype.marketDataSubscriptions = $util.emptyArray;

        /**
         * ClientMsg logon.
         * @member {cqg.Logon.$Properties|null|undefined} logon
         * @memberof cqg.ClientMsg
         * @instance
         */
        ClientMsg.prototype.logon = null;

        /**
         * Creates a new ClientMsg instance using the specified properties.
         * @function create
         * @memberof cqg.ClientMsg
         * @static
         * @param {cqg.ClientMsg.$Properties=} [properties] Properties to set
         * @returns {cqg.ClientMsg} ClientMsg instance
         * @type {{
         *   (properties: cqg.ClientMsg.$Shape): cqg.ClientMsg & cqg.ClientMsg.$Shape;
         *   (properties?: cqg.ClientMsg.$Properties): cqg.ClientMsg;
         * }}
         */
        ClientMsg.create = function create(properties) {
            return new ClientMsg(properties);
        };

        /**
         * Encodes the specified ClientMsg message. Does not implicitly {@link cqg.ClientMsg.verify|verify} messages.
         * @function encode
         * @memberof cqg.ClientMsg
         * @static
         * @param {cqg.ClientMsg.$Properties} message ClientMsg message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ClientMsg.encode = function encode(message, writer, _depth) {
            if (!writer)
                writer = $Writer.create();
            if (_depth === undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw Error("max depth exceeded");
            if (message.informationRequests != null && message.informationRequests.length)
                for (let i = 0; i < message.informationRequests.length; ++i)
                    $root.cqg.InformationRequest.encode(message.informationRequests[i], writer.uint32(/* id 1, wireType 2 =*/10).fork(), _depth + 1).ldelim();
            if (message.marketDataSubscriptions != null && message.marketDataSubscriptions.length)
                for (let i = 0; i < message.marketDataSubscriptions.length; ++i)
                    $root.cqg.MarketDataSubscription.encode(message.marketDataSubscriptions[i], writer.uint32(/* id 4, wireType 2 =*/34).fork(), _depth + 1).ldelim();
            if (message.logon != null && Object.hasOwnProperty.call(message, "logon"))
                $root.cqg.Logon.encode(message.logon, writer.uint32(/* id 100, wireType 2 =*/802).fork(), _depth + 1).ldelim();
            if (message.$unknowns != null && Object.hasOwnProperty.call(message, "$unknowns"))
                for (let i = 0; i < message.$unknowns.length; ++i)
                    writer.raw(message.$unknowns[i]);
            return writer;
        };

        /**
         * Encodes the specified ClientMsg message, length delimited. Does not implicitly {@link cqg.ClientMsg.verify|verify} messages.
         * @function encodeDelimited
         * @memberof cqg.ClientMsg
         * @static
         * @param {cqg.ClientMsg.$Properties} message ClientMsg message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ClientMsg.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer && writer.len ? writer.fork() : writer).ldelim();
        };

        /**
         * Decodes a ClientMsg message from the specified reader or buffer.
         * @function decode
         * @memberof cqg.ClientMsg
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {cqg.ClientMsg & cqg.ClientMsg.$Shape} ClientMsg
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ClientMsg.decode = function decode(reader, length, _end, _depth, _target) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            if (_depth === undefined)
                _depth = 0;
            if (_depth > $Reader.recursionLimit)
                throw Error("max depth exceeded");
            let end = length === undefined ? reader.len : reader.pos + length, message = _target || new $root.cqg.ClientMsg(), value;
            while (reader.pos < end) {
                let start = reader.pos;
                let tag = reader.tag();
                if (tag === _end) {
                    _end = undefined;
                    break;
                }
                let wireType = tag & 7;
                switch (tag >>>= 3) {
                case 1: {
                        if (wireType !== 2)
                            break;
                        if (!(message.informationRequests && message.informationRequests.length))
                            message.informationRequests = [];
                        message.informationRequests.push($root.cqg.InformationRequest.decode(reader, reader.uint32(), undefined, _depth + 1));
                        continue;
                    }
                case 4: {
                        if (wireType !== 2)
                            break;
                        if (!(message.marketDataSubscriptions && message.marketDataSubscriptions.length))
                            message.marketDataSubscriptions = [];
                        message.marketDataSubscriptions.push($root.cqg.MarketDataSubscription.decode(reader, reader.uint32(), undefined, _depth + 1));
                        continue;
                    }
                case 100: {
                        if (wireType !== 2)
                            break;
                        message.logon = $root.cqg.Logon.decode(reader, reader.uint32(), undefined, _depth + 1, message.logon);
                        continue;
                    }
                }
                reader.skipType(wireType, _depth, tag);
                if (!reader.discardUnknown) {
                    $util.makeProp(message, "$unknowns", false);
                    (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
                }
            }
            if (_end !== undefined)
                throw Error("missing end group");
            return message;
        };

        /**
         * Decodes a ClientMsg message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof cqg.ClientMsg
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {cqg.ClientMsg & cqg.ClientMsg.$Shape} ClientMsg
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ClientMsg.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a ClientMsg message.
         * @function verify
         * @memberof cqg.ClientMsg
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ClientMsg.verify = function verify(message, _depth) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (_depth === undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                return "max depth exceeded";
            if (message.informationRequests != null && message.hasOwnProperty("informationRequests")) {
                if (!Array.isArray(message.informationRequests))
                    return "informationRequests: array expected";
                for (let i = 0; i < message.informationRequests.length; ++i) {
                    let error = $root.cqg.InformationRequest.verify(message.informationRequests[i], _depth + 1);
                    if (error)
                        return "informationRequests." + error;
                }
            }
            if (message.marketDataSubscriptions != null && message.hasOwnProperty("marketDataSubscriptions")) {
                if (!Array.isArray(message.marketDataSubscriptions))
                    return "marketDataSubscriptions: array expected";
                for (let i = 0; i < message.marketDataSubscriptions.length; ++i) {
                    let error = $root.cqg.MarketDataSubscription.verify(message.marketDataSubscriptions[i], _depth + 1);
                    if (error)
                        return "marketDataSubscriptions." + error;
                }
            }
            if (message.logon != null && message.hasOwnProperty("logon")) {
                let error = $root.cqg.Logon.verify(message.logon, _depth + 1);
                if (error)
                    return "logon." + error;
            }
            return null;
        };

        /**
         * Creates a ClientMsg message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof cqg.ClientMsg
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {cqg.ClientMsg} ClientMsg
         */
        ClientMsg.fromObject = function fromObject(object, _depth) {
            if (object instanceof $root.cqg.ClientMsg)
                return object;
            if (!$util.isObject(object))
                throw TypeError(".cqg.ClientMsg: object expected");
            if (_depth === undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw Error("max depth exceeded");
            let message = new $root.cqg.ClientMsg();
            if (object.informationRequests) {
                if (!Array.isArray(object.informationRequests))
                    throw TypeError(".cqg.ClientMsg.informationRequests: array expected");
                message.informationRequests = Array(object.informationRequests.length);
                for (let i = 0; i < object.informationRequests.length; ++i) {
                    if (!$util.isObject(object.informationRequests[i]))
                        throw TypeError(".cqg.ClientMsg.informationRequests: object expected");
                    message.informationRequests[i] = $root.cqg.InformationRequest.fromObject(object.informationRequests[i], _depth + 1);
                }
            }
            if (object.marketDataSubscriptions) {
                if (!Array.isArray(object.marketDataSubscriptions))
                    throw TypeError(".cqg.ClientMsg.marketDataSubscriptions: array expected");
                message.marketDataSubscriptions = Array(object.marketDataSubscriptions.length);
                for (let i = 0; i < object.marketDataSubscriptions.length; ++i) {
                    if (!$util.isObject(object.marketDataSubscriptions[i]))
                        throw TypeError(".cqg.ClientMsg.marketDataSubscriptions: object expected");
                    message.marketDataSubscriptions[i] = $root.cqg.MarketDataSubscription.fromObject(object.marketDataSubscriptions[i], _depth + 1);
                }
            }
            if (object.logon != null) {
                if (!$util.isObject(object.logon))
                    throw TypeError(".cqg.ClientMsg.logon: object expected");
                message.logon = $root.cqg.Logon.fromObject(object.logon, _depth + 1);
            }
            return message;
        };

        /**
         * Creates a plain object from a ClientMsg message. Also converts values to other types if specified.
         * @function toObject
         * @memberof cqg.ClientMsg
         * @static
         * @param {cqg.ClientMsg} message ClientMsg
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ClientMsg.toObject = function toObject(message, options, _depth) {
            if (!options)
                options = {};
            if (_depth === undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw Error("max depth exceeded");
            let object = {};
            if (options.arrays || options.defaults) {
                object.informationRequests = [];
                object.marketDataSubscriptions = [];
            }
            if (options.defaults)
                object.logon = null;
            if (message.informationRequests && message.informationRequests.length) {
                object.informationRequests = Array(message.informationRequests.length);
                for (let j = 0; j < message.informationRequests.length; ++j)
                    object.informationRequests[j] = $root.cqg.InformationRequest.toObject(message.informationRequests[j], options, _depth + 1);
            }
            if (message.marketDataSubscriptions && message.marketDataSubscriptions.length) {
                object.marketDataSubscriptions = Array(message.marketDataSubscriptions.length);
                for (let j = 0; j < message.marketDataSubscriptions.length; ++j)
                    object.marketDataSubscriptions[j] = $root.cqg.MarketDataSubscription.toObject(message.marketDataSubscriptions[j], options, _depth + 1);
            }
            if (message.logon != null && message.hasOwnProperty("logon"))
                object.logon = $root.cqg.Logon.toObject(message.logon, options, _depth + 1);
            return object;
        };

        /**
         * Converts this ClientMsg to JSON.
         * @function toJSON
         * @memberof cqg.ClientMsg
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ClientMsg.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the type url for ClientMsg
         * @function getTypeUrl
         * @memberof cqg.ClientMsg
         * @static
         * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
         * @returns {string} The type url
         */
        ClientMsg.getTypeUrl = function getTypeUrl(prefix) {
            if (prefix === undefined)
                prefix = "type.googleapis.com";
            return prefix + "/cqg.ClientMsg";
        };

        return ClientMsg;
    })();

    cqg.Logon = (function() {

        /**
         * Properties of a Logon.
         * @typedef {Object} cqg.Logon.$Properties
         * @property {string|null} [userName] Logon userName
         * @property {string|null} [password] Logon password
         * @property {string|null} [privateLabel] Logon privateLabel
         * @property {string|null} [clientAppId] Logon clientAppId
         * @property {string|null} [clientVersion] Logon clientVersion
         * @property {boolean|null} [dropConcurrentSession] Logon dropConcurrentSession
         * @property {number|null} [protocolVersionMinor] Logon protocolVersionMinor
         * @property {number|null} [protocolVersionMajor] Logon protocolVersionMajor
         * @property {Array.<number>|null} [sessionSettings] Logon sessionSettings
         * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding
         */

        /**
         * Properties of a Logon.
         * @memberof cqg
         * @interface ILogon
         * @augments cqg.Logon.$Properties
         * @deprecated Use cqg.Logon.$Properties instead.
         */

        /**
         * Shape of a Logon.
         * @typedef {cqg.Logon.$Properties} cqg.Logon.$Shape
         */

        /**
         * Constructs a new Logon.
         * @memberof cqg
         * @classdesc Represents a Logon.
         * @constructor
         * @param {cqg.Logon.$Properties=} [properties] Properties to set
         * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding
         */
        function Logon(properties) {
            this.sessionSettings = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null && keys[i] !== "__proto__")
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Logon userName.
         * @member {string} userName
         * @memberof cqg.Logon
         * @instance
         */
        Logon.prototype.userName = "";

        /**
         * Logon password.
         * @member {string} password
         * @memberof cqg.Logon
         * @instance
         */
        Logon.prototype.password = "";

        /**
         * Logon privateLabel.
         * @member {string} privateLabel
         * @memberof cqg.Logon
         * @instance
         */
        Logon.prototype.privateLabel = "";

        /**
         * Logon clientAppId.
         * @member {string} clientAppId
         * @memberof cqg.Logon
         * @instance
         */
        Logon.prototype.clientAppId = "";

        /**
         * Logon clientVersion.
         * @member {string} clientVersion
         * @memberof cqg.Logon
         * @instance
         */
        Logon.prototype.clientVersion = "";

        /**
         * Logon dropConcurrentSession.
         * @member {boolean} dropConcurrentSession
         * @memberof cqg.Logon
         * @instance
         */
        Logon.prototype.dropConcurrentSession = false;

        /**
         * Logon protocolVersionMinor.
         * @member {number} protocolVersionMinor
         * @memberof cqg.Logon
         * @instance
         */
        Logon.prototype.protocolVersionMinor = 0;

        /**
         * Logon protocolVersionMajor.
         * @member {number} protocolVersionMajor
         * @memberof cqg.Logon
         * @instance
         */
        Logon.prototype.protocolVersionMajor = 0;

        /**
         * Logon sessionSettings.
         * @member {Array.<number>} sessionSettings
         * @memberof cqg.Logon
         * @instance
         */
        Logon.prototype.sessionSettings = $util.emptyArray;

        /**
         * Creates a new Logon instance using the specified properties.
         * @function create
         * @memberof cqg.Logon
         * @static
         * @param {cqg.Logon.$Properties=} [properties] Properties to set
         * @returns {cqg.Logon} Logon instance
         * @type {{
         *   (properties: cqg.Logon.$Shape): cqg.Logon & cqg.Logon.$Shape;
         *   (properties?: cqg.Logon.$Properties): cqg.Logon;
         * }}
         */
        Logon.create = function create(properties) {
            return new Logon(properties);
        };

        /**
         * Encodes the specified Logon message. Does not implicitly {@link cqg.Logon.verify|verify} messages.
         * @function encode
         * @memberof cqg.Logon
         * @static
         * @param {cqg.Logon.$Properties} message Logon message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Logon.encode = function encode(message, writer, _depth) {
            if (!writer)
                writer = $Writer.create();
            if (_depth === undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw Error("max depth exceeded");
            if (message.userName != null && Object.hasOwnProperty.call(message, "userName"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.userName);
            if (message.password != null && Object.hasOwnProperty.call(message, "password"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.password);
            if (message.privateLabel != null && Object.hasOwnProperty.call(message, "privateLabel"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.privateLabel);
            if (message.clientAppId != null && Object.hasOwnProperty.call(message, "clientAppId"))
                writer.uint32(/* id 5, wireType 2 =*/42).string(message.clientAppId);
            if (message.clientVersion != null && Object.hasOwnProperty.call(message, "clientVersion"))
                writer.uint32(/* id 6, wireType 2 =*/50).string(message.clientVersion);
            if (message.dropConcurrentSession != null && Object.hasOwnProperty.call(message, "dropConcurrentSession"))
                writer.uint32(/* id 7, wireType 0 =*/56).bool(message.dropConcurrentSession);
            if (message.protocolVersionMinor != null && Object.hasOwnProperty.call(message, "protocolVersionMinor"))
                writer.uint32(/* id 9, wireType 0 =*/72).uint32(message.protocolVersionMinor);
            if (message.protocolVersionMajor != null && Object.hasOwnProperty.call(message, "protocolVersionMajor"))
                writer.uint32(/* id 10, wireType 0 =*/80).uint32(message.protocolVersionMajor);
            if (message.sessionSettings != null && message.sessionSettings.length) {
                writer.uint32(/* id 11, wireType 2 =*/90).fork();
                for (let i = 0; i < message.sessionSettings.length; ++i)
                    writer.uint32(message.sessionSettings[i]);
                writer.ldelim();
            }
            if (message.$unknowns != null && Object.hasOwnProperty.call(message, "$unknowns"))
                for (let i = 0; i < message.$unknowns.length; ++i)
                    writer.raw(message.$unknowns[i]);
            return writer;
        };

        /**
         * Encodes the specified Logon message, length delimited. Does not implicitly {@link cqg.Logon.verify|verify} messages.
         * @function encodeDelimited
         * @memberof cqg.Logon
         * @static
         * @param {cqg.Logon.$Properties} message Logon message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Logon.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer && writer.len ? writer.fork() : writer).ldelim();
        };

        /**
         * Decodes a Logon message from the specified reader or buffer.
         * @function decode
         * @memberof cqg.Logon
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {cqg.Logon & cqg.Logon.$Shape} Logon
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Logon.decode = function decode(reader, length, _end, _depth, _target) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            if (_depth === undefined)
                _depth = 0;
            if (_depth > $Reader.recursionLimit)
                throw Error("max depth exceeded");
            let end = length === undefined ? reader.len : reader.pos + length, message = _target || new $root.cqg.Logon(), value;
            while (reader.pos < end) {
                let start = reader.pos;
                let tag = reader.tag();
                if (tag === _end) {
                    _end = undefined;
                    break;
                }
                let wireType = tag & 7;
                switch (tag >>>= 3) {
                case 1: {
                        if (wireType !== 2)
                            break;
                        if ((value = reader.string()).length)
                            message.userName = value;
                        else
                            delete message.userName;
                        continue;
                    }
                case 2: {
                        if (wireType !== 2)
                            break;
                        if ((value = reader.string()).length)
                            message.password = value;
                        else
                            delete message.password;
                        continue;
                    }
                case 4: {
                        if (wireType !== 2)
                            break;
                        if ((value = reader.string()).length)
                            message.privateLabel = value;
                        else
                            delete message.privateLabel;
                        continue;
                    }
                case 5: {
                        if (wireType !== 2)
                            break;
                        if ((value = reader.string()).length)
                            message.clientAppId = value;
                        else
                            delete message.clientAppId;
                        continue;
                    }
                case 6: {
                        if (wireType !== 2)
                            break;
                        if ((value = reader.string()).length)
                            message.clientVersion = value;
                        else
                            delete message.clientVersion;
                        continue;
                    }
                case 7: {
                        if (wireType !== 0)
                            break;
                        if (value = reader.bool())
                            message.dropConcurrentSession = value;
                        else
                            delete message.dropConcurrentSession;
                        continue;
                    }
                case 9: {
                        if (wireType !== 0)
                            break;
                        if (value = reader.uint32())
                            message.protocolVersionMinor = value;
                        else
                            delete message.protocolVersionMinor;
                        continue;
                    }
                case 10: {
                        if (wireType !== 0)
                            break;
                        if (value = reader.uint32())
                            message.protocolVersionMajor = value;
                        else
                            delete message.protocolVersionMajor;
                        continue;
                    }
                case 11: {
                        if (wireType === 2) {
                            if (!(message.sessionSettings && message.sessionSettings.length))
                                message.sessionSettings = [];
                            let end2 = reader.uint32() + reader.pos;
                            while (reader.pos < end2)
                                message.sessionSettings.push(reader.uint32());
                            continue;
                        }
                        if (wireType !== 0)
                            break;
                        if (!(message.sessionSettings && message.sessionSettings.length))
                            message.sessionSettings = [];
                        message.sessionSettings.push(reader.uint32());
                        continue;
                    }
                }
                reader.skipType(wireType, _depth, tag);
                if (!reader.discardUnknown) {
                    $util.makeProp(message, "$unknowns", false);
                    (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
                }
            }
            if (_end !== undefined)
                throw Error("missing end group");
            return message;
        };

        /**
         * Decodes a Logon message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof cqg.Logon
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {cqg.Logon & cqg.Logon.$Shape} Logon
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Logon.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a Logon message.
         * @function verify
         * @memberof cqg.Logon
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        Logon.verify = function verify(message, _depth) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (_depth === undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                return "max depth exceeded";
            if (message.userName != null && message.hasOwnProperty("userName"))
                if (!$util.isString(message.userName))
                    return "userName: string expected";
            if (message.password != null && message.hasOwnProperty("password"))
                if (!$util.isString(message.password))
                    return "password: string expected";
            if (message.privateLabel != null && message.hasOwnProperty("privateLabel"))
                if (!$util.isString(message.privateLabel))
                    return "privateLabel: string expected";
            if (message.clientAppId != null && message.hasOwnProperty("clientAppId"))
                if (!$util.isString(message.clientAppId))
                    return "clientAppId: string expected";
            if (message.clientVersion != null && message.hasOwnProperty("clientVersion"))
                if (!$util.isString(message.clientVersion))
                    return "clientVersion: string expected";
            if (message.dropConcurrentSession != null && message.hasOwnProperty("dropConcurrentSession"))
                if (typeof message.dropConcurrentSession !== "boolean")
                    return "dropConcurrentSession: boolean expected";
            if (message.protocolVersionMinor != null && message.hasOwnProperty("protocolVersionMinor"))
                if (!$util.isInteger(message.protocolVersionMinor))
                    return "protocolVersionMinor: integer expected";
            if (message.protocolVersionMajor != null && message.hasOwnProperty("protocolVersionMajor"))
                if (!$util.isInteger(message.protocolVersionMajor))
                    return "protocolVersionMajor: integer expected";
            if (message.sessionSettings != null && message.hasOwnProperty("sessionSettings")) {
                if (!Array.isArray(message.sessionSettings))
                    return "sessionSettings: array expected";
                for (let i = 0; i < message.sessionSettings.length; ++i)
                    if (!$util.isInteger(message.sessionSettings[i]))
                        return "sessionSettings: integer[] expected";
            }
            return null;
        };

        /**
         * Creates a Logon message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof cqg.Logon
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {cqg.Logon} Logon
         */
        Logon.fromObject = function fromObject(object, _depth) {
            if (object instanceof $root.cqg.Logon)
                return object;
            if (!$util.isObject(object))
                throw TypeError(".cqg.Logon: object expected");
            if (_depth === undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw Error("max depth exceeded");
            let message = new $root.cqg.Logon();
            if (object.userName != null)
                if (typeof object.userName !== "string" || object.userName.length)
                    message.userName = String(object.userName);
            if (object.password != null)
                if (typeof object.password !== "string" || object.password.length)
                    message.password = String(object.password);
            if (object.privateLabel != null)
                if (typeof object.privateLabel !== "string" || object.privateLabel.length)
                    message.privateLabel = String(object.privateLabel);
            if (object.clientAppId != null)
                if (typeof object.clientAppId !== "string" || object.clientAppId.length)
                    message.clientAppId = String(object.clientAppId);
            if (object.clientVersion != null)
                if (typeof object.clientVersion !== "string" || object.clientVersion.length)
                    message.clientVersion = String(object.clientVersion);
            if (object.dropConcurrentSession != null)
                if (object.dropConcurrentSession)
                    message.dropConcurrentSession = Boolean(object.dropConcurrentSession);
            if (object.protocolVersionMinor != null)
                if (Number(object.protocolVersionMinor) !== 0)
                    message.protocolVersionMinor = object.protocolVersionMinor >>> 0;
            if (object.protocolVersionMajor != null)
                if (Number(object.protocolVersionMajor) !== 0)
                    message.protocolVersionMajor = object.protocolVersionMajor >>> 0;
            if (object.sessionSettings) {
                if (!Array.isArray(object.sessionSettings))
                    throw TypeError(".cqg.Logon.sessionSettings: array expected");
                message.sessionSettings = Array(object.sessionSettings.length);
                for (let i = 0; i < object.sessionSettings.length; ++i)
                    message.sessionSettings[i] = object.sessionSettings[i] >>> 0;
            }
            return message;
        };

        /**
         * Creates a plain object from a Logon message. Also converts values to other types if specified.
         * @function toObject
         * @memberof cqg.Logon
         * @static
         * @param {cqg.Logon} message Logon
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Logon.toObject = function toObject(message, options, _depth) {
            if (!options)
                options = {};
            if (_depth === undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw Error("max depth exceeded");
            let object = {};
            if (options.arrays || options.defaults)
                object.sessionSettings = [];
            if (options.defaults) {
                object.userName = "";
                object.password = "";
                object.privateLabel = "";
                object.clientAppId = "";
                object.clientVersion = "";
                object.dropConcurrentSession = false;
                object.protocolVersionMinor = 0;
                object.protocolVersionMajor = 0;
            }
            if (message.userName != null && message.hasOwnProperty("userName"))
                object.userName = message.userName;
            if (message.password != null && message.hasOwnProperty("password"))
                object.password = message.password;
            if (message.privateLabel != null && message.hasOwnProperty("privateLabel"))
                object.privateLabel = message.privateLabel;
            if (message.clientAppId != null && message.hasOwnProperty("clientAppId"))
                object.clientAppId = message.clientAppId;
            if (message.clientVersion != null && message.hasOwnProperty("clientVersion"))
                object.clientVersion = message.clientVersion;
            if (message.dropConcurrentSession != null && message.hasOwnProperty("dropConcurrentSession"))
                object.dropConcurrentSession = message.dropConcurrentSession;
            if (message.protocolVersionMinor != null && message.hasOwnProperty("protocolVersionMinor"))
                object.protocolVersionMinor = message.protocolVersionMinor;
            if (message.protocolVersionMajor != null && message.hasOwnProperty("protocolVersionMajor"))
                object.protocolVersionMajor = message.protocolVersionMajor;
            if (message.sessionSettings && message.sessionSettings.length) {
                object.sessionSettings = Array(message.sessionSettings.length);
                for (let j = 0; j < message.sessionSettings.length; ++j)
                    object.sessionSettings[j] = message.sessionSettings[j];
            }
            return object;
        };

        /**
         * Converts this Logon to JSON.
         * @function toJSON
         * @memberof cqg.Logon
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Logon.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the type url for Logon
         * @function getTypeUrl
         * @memberof cqg.Logon
         * @static
         * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
         * @returns {string} The type url
         */
        Logon.getTypeUrl = function getTypeUrl(prefix) {
            if (prefix === undefined)
                prefix = "type.googleapis.com";
            return prefix + "/cqg.Logon";
        };

        return Logon;
    })();

    cqg.InformationRequest = (function() {

        /**
         * Properties of an InformationRequest.
         * @typedef {Object} cqg.InformationRequest.$Properties
         * @property {number|null} [id] InformationRequest id
         * @property {cqg.SymbolResolutionRequest.$Properties|null} [symbolResolutionRequest] InformationRequest symbolResolutionRequest
         * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding
         */

        /**
         * Properties of an InformationRequest.
         * @memberof cqg
         * @interface IInformationRequest
         * @augments cqg.InformationRequest.$Properties
         * @deprecated Use cqg.InformationRequest.$Properties instead.
         */

        /**
         * Shape of an InformationRequest.
         * @typedef {cqg.InformationRequest.$Properties} cqg.InformationRequest.$Shape
         */

        /**
         * Constructs a new InformationRequest.
         * @memberof cqg
         * @classdesc Represents an InformationRequest.
         * @constructor
         * @param {cqg.InformationRequest.$Properties=} [properties] Properties to set
         * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding
         */
        function InformationRequest(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null && keys[i] !== "__proto__")
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * InformationRequest id.
         * @member {number} id
         * @memberof cqg.InformationRequest
         * @instance
         */
        InformationRequest.prototype.id = 0;

        /**
         * InformationRequest symbolResolutionRequest.
         * @member {cqg.SymbolResolutionRequest.$Properties|null|undefined} symbolResolutionRequest
         * @memberof cqg.InformationRequest
         * @instance
         */
        InformationRequest.prototype.symbolResolutionRequest = null;

        /**
         * Creates a new InformationRequest instance using the specified properties.
         * @function create
         * @memberof cqg.InformationRequest
         * @static
         * @param {cqg.InformationRequest.$Properties=} [properties] Properties to set
         * @returns {cqg.InformationRequest} InformationRequest instance
         * @type {{
         *   (properties: cqg.InformationRequest.$Shape): cqg.InformationRequest & cqg.InformationRequest.$Shape;
         *   (properties?: cqg.InformationRequest.$Properties): cqg.InformationRequest;
         * }}
         */
        InformationRequest.create = function create(properties) {
            return new InformationRequest(properties);
        };

        /**
         * Encodes the specified InformationRequest message. Does not implicitly {@link cqg.InformationRequest.verify|verify} messages.
         * @function encode
         * @memberof cqg.InformationRequest
         * @static
         * @param {cqg.InformationRequest.$Properties} message InformationRequest message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        InformationRequest.encode = function encode(message, writer, _depth) {
            if (!writer)
                writer = $Writer.create();
            if (_depth === undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw Error("max depth exceeded");
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.id);
            if (message.symbolResolutionRequest != null && Object.hasOwnProperty.call(message, "symbolResolutionRequest"))
                $root.cqg.SymbolResolutionRequest.encode(message.symbolResolutionRequest, writer.uint32(/* id 4, wireType 2 =*/34).fork(), _depth + 1).ldelim();
            if (message.$unknowns != null && Object.hasOwnProperty.call(message, "$unknowns"))
                for (let i = 0; i < message.$unknowns.length; ++i)
                    writer.raw(message.$unknowns[i]);
            return writer;
        };

        /**
         * Encodes the specified InformationRequest message, length delimited. Does not implicitly {@link cqg.InformationRequest.verify|verify} messages.
         * @function encodeDelimited
         * @memberof cqg.InformationRequest
         * @static
         * @param {cqg.InformationRequest.$Properties} message InformationRequest message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        InformationRequest.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer && writer.len ? writer.fork() : writer).ldelim();
        };

        /**
         * Decodes an InformationRequest message from the specified reader or buffer.
         * @function decode
         * @memberof cqg.InformationRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {cqg.InformationRequest & cqg.InformationRequest.$Shape} InformationRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        InformationRequest.decode = function decode(reader, length, _end, _depth, _target) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            if (_depth === undefined)
                _depth = 0;
            if (_depth > $Reader.recursionLimit)
                throw Error("max depth exceeded");
            let end = length === undefined ? reader.len : reader.pos + length, message = _target || new $root.cqg.InformationRequest(), value;
            while (reader.pos < end) {
                let start = reader.pos;
                let tag = reader.tag();
                if (tag === _end) {
                    _end = undefined;
                    break;
                }
                let wireType = tag & 7;
                switch (tag >>>= 3) {
                case 1: {
                        if (wireType !== 0)
                            break;
                        if (value = reader.uint32())
                            message.id = value;
                        else
                            delete message.id;
                        continue;
                    }
                case 4: {
                        if (wireType !== 2)
                            break;
                        message.symbolResolutionRequest = $root.cqg.SymbolResolutionRequest.decode(reader, reader.uint32(), undefined, _depth + 1, message.symbolResolutionRequest);
                        continue;
                    }
                }
                reader.skipType(wireType, _depth, tag);
                if (!reader.discardUnknown) {
                    $util.makeProp(message, "$unknowns", false);
                    (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
                }
            }
            if (_end !== undefined)
                throw Error("missing end group");
            return message;
        };

        /**
         * Decodes an InformationRequest message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof cqg.InformationRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {cqg.InformationRequest & cqg.InformationRequest.$Shape} InformationRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        InformationRequest.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an InformationRequest message.
         * @function verify
         * @memberof cqg.InformationRequest
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        InformationRequest.verify = function verify(message, _depth) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (_depth === undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                return "max depth exceeded";
            if (message.id != null && message.hasOwnProperty("id"))
                if (!$util.isInteger(message.id))
                    return "id: integer expected";
            if (message.symbolResolutionRequest != null && message.hasOwnProperty("symbolResolutionRequest")) {
                let error = $root.cqg.SymbolResolutionRequest.verify(message.symbolResolutionRequest, _depth + 1);
                if (error)
                    return "symbolResolutionRequest." + error;
            }
            return null;
        };

        /**
         * Creates an InformationRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof cqg.InformationRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {cqg.InformationRequest} InformationRequest
         */
        InformationRequest.fromObject = function fromObject(object, _depth) {
            if (object instanceof $root.cqg.InformationRequest)
                return object;
            if (!$util.isObject(object))
                throw TypeError(".cqg.InformationRequest: object expected");
            if (_depth === undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw Error("max depth exceeded");
            let message = new $root.cqg.InformationRequest();
            if (object.id != null)
                if (Number(object.id) !== 0)
                    message.id = object.id >>> 0;
            if (object.symbolResolutionRequest != null) {
                if (!$util.isObject(object.symbolResolutionRequest))
                    throw TypeError(".cqg.InformationRequest.symbolResolutionRequest: object expected");
                message.symbolResolutionRequest = $root.cqg.SymbolResolutionRequest.fromObject(object.symbolResolutionRequest, _depth + 1);
            }
            return message;
        };

        /**
         * Creates a plain object from an InformationRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof cqg.InformationRequest
         * @static
         * @param {cqg.InformationRequest} message InformationRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        InformationRequest.toObject = function toObject(message, options, _depth) {
            if (!options)
                options = {};
            if (_depth === undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw Error("max depth exceeded");
            let object = {};
            if (options.defaults) {
                object.id = 0;
                object.symbolResolutionRequest = null;
            }
            if (message.id != null && message.hasOwnProperty("id"))
                object.id = message.id;
            if (message.symbolResolutionRequest != null && message.hasOwnProperty("symbolResolutionRequest"))
                object.symbolResolutionRequest = $root.cqg.SymbolResolutionRequest.toObject(message.symbolResolutionRequest, options, _depth + 1);
            return object;
        };

        /**
         * Converts this InformationRequest to JSON.
         * @function toJSON
         * @memberof cqg.InformationRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        InformationRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the type url for InformationRequest
         * @function getTypeUrl
         * @memberof cqg.InformationRequest
         * @static
         * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
         * @returns {string} The type url
         */
        InformationRequest.getTypeUrl = function getTypeUrl(prefix) {
            if (prefix === undefined)
                prefix = "type.googleapis.com";
            return prefix + "/cqg.InformationRequest";
        };

        return InformationRequest;
    })();

    cqg.SymbolResolutionRequest = (function() {

        /**
         * Properties of a SymbolResolutionRequest.
         * @typedef {Object} cqg.SymbolResolutionRequest.$Properties
         * @property {string|null} [symbol] SymbolResolutionRequest symbol
         * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding
         */

        /**
         * Properties of a SymbolResolutionRequest.
         * @memberof cqg
         * @interface ISymbolResolutionRequest
         * @augments cqg.SymbolResolutionRequest.$Properties
         * @deprecated Use cqg.SymbolResolutionRequest.$Properties instead.
         */

        /**
         * Shape of a SymbolResolutionRequest.
         * @typedef {cqg.SymbolResolutionRequest.$Properties} cqg.SymbolResolutionRequest.$Shape
         */

        /**
         * Constructs a new SymbolResolutionRequest.
         * @memberof cqg
         * @classdesc Represents a SymbolResolutionRequest.
         * @constructor
         * @param {cqg.SymbolResolutionRequest.$Properties=} [properties] Properties to set
         * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding
         */
        function SymbolResolutionRequest(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null && keys[i] !== "__proto__")
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * SymbolResolutionRequest symbol.
         * @member {string} symbol
         * @memberof cqg.SymbolResolutionRequest
         * @instance
         */
        SymbolResolutionRequest.prototype.symbol = "";

        /**
         * Creates a new SymbolResolutionRequest instance using the specified properties.
         * @function create
         * @memberof cqg.SymbolResolutionRequest
         * @static
         * @param {cqg.SymbolResolutionRequest.$Properties=} [properties] Properties to set
         * @returns {cqg.SymbolResolutionRequest} SymbolResolutionRequest instance
         * @type {{
         *   (properties: cqg.SymbolResolutionRequest.$Shape): cqg.SymbolResolutionRequest & cqg.SymbolResolutionRequest.$Shape;
         *   (properties?: cqg.SymbolResolutionRequest.$Properties): cqg.SymbolResolutionRequest;
         * }}
         */
        SymbolResolutionRequest.create = function create(properties) {
            return new SymbolResolutionRequest(properties);
        };

        /**
         * Encodes the specified SymbolResolutionRequest message. Does not implicitly {@link cqg.SymbolResolutionRequest.verify|verify} messages.
         * @function encode
         * @memberof cqg.SymbolResolutionRequest
         * @static
         * @param {cqg.SymbolResolutionRequest.$Properties} message SymbolResolutionRequest message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SymbolResolutionRequest.encode = function encode(message, writer, _depth) {
            if (!writer)
                writer = $Writer.create();
            if (_depth === undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw Error("max depth exceeded");
            if (message.symbol != null && Object.hasOwnProperty.call(message, "symbol"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.symbol);
            if (message.$unknowns != null && Object.hasOwnProperty.call(message, "$unknowns"))
                for (let i = 0; i < message.$unknowns.length; ++i)
                    writer.raw(message.$unknowns[i]);
            return writer;
        };

        /**
         * Encodes the specified SymbolResolutionRequest message, length delimited. Does not implicitly {@link cqg.SymbolResolutionRequest.verify|verify} messages.
         * @function encodeDelimited
         * @memberof cqg.SymbolResolutionRequest
         * @static
         * @param {cqg.SymbolResolutionRequest.$Properties} message SymbolResolutionRequest message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SymbolResolutionRequest.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer && writer.len ? writer.fork() : writer).ldelim();
        };

        /**
         * Decodes a SymbolResolutionRequest message from the specified reader or buffer.
         * @function decode
         * @memberof cqg.SymbolResolutionRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {cqg.SymbolResolutionRequest & cqg.SymbolResolutionRequest.$Shape} SymbolResolutionRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SymbolResolutionRequest.decode = function decode(reader, length, _end, _depth, _target) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            if (_depth === undefined)
                _depth = 0;
            if (_depth > $Reader.recursionLimit)
                throw Error("max depth exceeded");
            let end = length === undefined ? reader.len : reader.pos + length, message = _target || new $root.cqg.SymbolResolutionRequest(), value;
            while (reader.pos < end) {
                let start = reader.pos;
                let tag = reader.tag();
                if (tag === _end) {
                    _end = undefined;
                    break;
                }
                let wireType = tag & 7;
                switch (tag >>>= 3) {
                case 1: {
                        if (wireType !== 2)
                            break;
                        if ((value = reader.string()).length)
                            message.symbol = value;
                        else
                            delete message.symbol;
                        continue;
                    }
                }
                reader.skipType(wireType, _depth, tag);
                if (!reader.discardUnknown) {
                    $util.makeProp(message, "$unknowns", false);
                    (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
                }
            }
            if (_end !== undefined)
                throw Error("missing end group");
            return message;
        };

        /**
         * Decodes a SymbolResolutionRequest message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof cqg.SymbolResolutionRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {cqg.SymbolResolutionRequest & cqg.SymbolResolutionRequest.$Shape} SymbolResolutionRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SymbolResolutionRequest.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a SymbolResolutionRequest message.
         * @function verify
         * @memberof cqg.SymbolResolutionRequest
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        SymbolResolutionRequest.verify = function verify(message, _depth) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (_depth === undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                return "max depth exceeded";
            if (message.symbol != null && message.hasOwnProperty("symbol"))
                if (!$util.isString(message.symbol))
                    return "symbol: string expected";
            return null;
        };

        /**
         * Creates a SymbolResolutionRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof cqg.SymbolResolutionRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {cqg.SymbolResolutionRequest} SymbolResolutionRequest
         */
        SymbolResolutionRequest.fromObject = function fromObject(object, _depth) {
            if (object instanceof $root.cqg.SymbolResolutionRequest)
                return object;
            if (!$util.isObject(object))
                throw TypeError(".cqg.SymbolResolutionRequest: object expected");
            if (_depth === undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw Error("max depth exceeded");
            let message = new $root.cqg.SymbolResolutionRequest();
            if (object.symbol != null)
                if (typeof object.symbol !== "string" || object.symbol.length)
                    message.symbol = String(object.symbol);
            return message;
        };

        /**
         * Creates a plain object from a SymbolResolutionRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof cqg.SymbolResolutionRequest
         * @static
         * @param {cqg.SymbolResolutionRequest} message SymbolResolutionRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        SymbolResolutionRequest.toObject = function toObject(message, options, _depth) {
            if (!options)
                options = {};
            if (_depth === undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw Error("max depth exceeded");
            let object = {};
            if (options.defaults)
                object.symbol = "";
            if (message.symbol != null && message.hasOwnProperty("symbol"))
                object.symbol = message.symbol;
            return object;
        };

        /**
         * Converts this SymbolResolutionRequest to JSON.
         * @function toJSON
         * @memberof cqg.SymbolResolutionRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        SymbolResolutionRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the type url for SymbolResolutionRequest
         * @function getTypeUrl
         * @memberof cqg.SymbolResolutionRequest
         * @static
         * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
         * @returns {string} The type url
         */
        SymbolResolutionRequest.getTypeUrl = function getTypeUrl(prefix) {
            if (prefix === undefined)
                prefix = "type.googleapis.com";
            return prefix + "/cqg.SymbolResolutionRequest";
        };

        return SymbolResolutionRequest;
    })();

    cqg.MarketDataSubscription = (function() {

        /**
         * Properties of a MarketDataSubscription.
         * @typedef {Object} cqg.MarketDataSubscription.$Properties
         * @property {number|null} [contractId] MarketDataSubscription contractId
         * @property {number|null} [level] MarketDataSubscription level
         * @property {boolean|null} [includePastQuotes] MarketDataSubscription includePastQuotes
         * @property {number|null} [requestId] MarketDataSubscription requestId
         * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding
         */

        /**
         * Properties of a MarketDataSubscription.
         * @memberof cqg
         * @interface IMarketDataSubscription
         * @augments cqg.MarketDataSubscription.$Properties
         * @deprecated Use cqg.MarketDataSubscription.$Properties instead.
         */

        /**
         * Shape of a MarketDataSubscription.
         * @typedef {cqg.MarketDataSubscription.$Properties} cqg.MarketDataSubscription.$Shape
         */

        /**
         * Constructs a new MarketDataSubscription.
         * @memberof cqg
         * @classdesc Represents a MarketDataSubscription.
         * @constructor
         * @param {cqg.MarketDataSubscription.$Properties=} [properties] Properties to set
         * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding
         */
        function MarketDataSubscription(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null && keys[i] !== "__proto__")
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * MarketDataSubscription contractId.
         * @member {number} contractId
         * @memberof cqg.MarketDataSubscription
         * @instance
         */
        MarketDataSubscription.prototype.contractId = 0;

        /**
         * MarketDataSubscription level.
         * @member {number} level
         * @memberof cqg.MarketDataSubscription
         * @instance
         */
        MarketDataSubscription.prototype.level = 0;

        /**
         * MarketDataSubscription includePastQuotes.
         * @member {boolean} includePastQuotes
         * @memberof cqg.MarketDataSubscription
         * @instance
         */
        MarketDataSubscription.prototype.includePastQuotes = false;

        /**
         * MarketDataSubscription requestId.
         * @member {number} requestId
         * @memberof cqg.MarketDataSubscription
         * @instance
         */
        MarketDataSubscription.prototype.requestId = 0;

        /**
         * Creates a new MarketDataSubscription instance using the specified properties.
         * @function create
         * @memberof cqg.MarketDataSubscription
         * @static
         * @param {cqg.MarketDataSubscription.$Properties=} [properties] Properties to set
         * @returns {cqg.MarketDataSubscription} MarketDataSubscription instance
         * @type {{
         *   (properties: cqg.MarketDataSubscription.$Shape): cqg.MarketDataSubscription & cqg.MarketDataSubscription.$Shape;
         *   (properties?: cqg.MarketDataSubscription.$Properties): cqg.MarketDataSubscription;
         * }}
         */
        MarketDataSubscription.create = function create(properties) {
            return new MarketDataSubscription(properties);
        };

        /**
         * Encodes the specified MarketDataSubscription message. Does not implicitly {@link cqg.MarketDataSubscription.verify|verify} messages.
         * @function encode
         * @memberof cqg.MarketDataSubscription
         * @static
         * @param {cqg.MarketDataSubscription.$Properties} message MarketDataSubscription message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        MarketDataSubscription.encode = function encode(message, writer, _depth) {
            if (!writer)
                writer = $Writer.create();
            if (_depth === undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw Error("max depth exceeded");
            if (message.contractId != null && Object.hasOwnProperty.call(message, "contractId"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.contractId);
            if (message.level != null && Object.hasOwnProperty.call(message, "level"))
                writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.level);
            if (message.includePastQuotes != null && Object.hasOwnProperty.call(message, "includePastQuotes"))
                writer.uint32(/* id 5, wireType 0 =*/40).bool(message.includePastQuotes);
            if (message.requestId != null && Object.hasOwnProperty.call(message, "requestId"))
                writer.uint32(/* id 14, wireType 0 =*/112).uint32(message.requestId);
            if (message.$unknowns != null && Object.hasOwnProperty.call(message, "$unknowns"))
                for (let i = 0; i < message.$unknowns.length; ++i)
                    writer.raw(message.$unknowns[i]);
            return writer;
        };

        /**
         * Encodes the specified MarketDataSubscription message, length delimited. Does not implicitly {@link cqg.MarketDataSubscription.verify|verify} messages.
         * @function encodeDelimited
         * @memberof cqg.MarketDataSubscription
         * @static
         * @param {cqg.MarketDataSubscription.$Properties} message MarketDataSubscription message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        MarketDataSubscription.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer && writer.len ? writer.fork() : writer).ldelim();
        };

        /**
         * Decodes a MarketDataSubscription message from the specified reader or buffer.
         * @function decode
         * @memberof cqg.MarketDataSubscription
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {cqg.MarketDataSubscription & cqg.MarketDataSubscription.$Shape} MarketDataSubscription
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        MarketDataSubscription.decode = function decode(reader, length, _end, _depth, _target) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            if (_depth === undefined)
                _depth = 0;
            if (_depth > $Reader.recursionLimit)
                throw Error("max depth exceeded");
            let end = length === undefined ? reader.len : reader.pos + length, message = _target || new $root.cqg.MarketDataSubscription(), value;
            while (reader.pos < end) {
                let start = reader.pos;
                let tag = reader.tag();
                if (tag === _end) {
                    _end = undefined;
                    break;
                }
                let wireType = tag & 7;
                switch (tag >>>= 3) {
                case 1: {
                        if (wireType !== 0)
                            break;
                        if (value = reader.uint32())
                            message.contractId = value;
                        else
                            delete message.contractId;
                        continue;
                    }
                case 2: {
                        if (wireType !== 0)
                            break;
                        if (value = reader.uint32())
                            message.level = value;
                        else
                            delete message.level;
                        continue;
                    }
                case 5: {
                        if (wireType !== 0)
                            break;
                        if (value = reader.bool())
                            message.includePastQuotes = value;
                        else
                            delete message.includePastQuotes;
                        continue;
                    }
                case 14: {
                        if (wireType !== 0)
                            break;
                        if (value = reader.uint32())
                            message.requestId = value;
                        else
                            delete message.requestId;
                        continue;
                    }
                }
                reader.skipType(wireType, _depth, tag);
                if (!reader.discardUnknown) {
                    $util.makeProp(message, "$unknowns", false);
                    (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
                }
            }
            if (_end !== undefined)
                throw Error("missing end group");
            return message;
        };

        /**
         * Decodes a MarketDataSubscription message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof cqg.MarketDataSubscription
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {cqg.MarketDataSubscription & cqg.MarketDataSubscription.$Shape} MarketDataSubscription
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        MarketDataSubscription.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a MarketDataSubscription message.
         * @function verify
         * @memberof cqg.MarketDataSubscription
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        MarketDataSubscription.verify = function verify(message, _depth) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (_depth === undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                return "max depth exceeded";
            if (message.contractId != null && message.hasOwnProperty("contractId"))
                if (!$util.isInteger(message.contractId))
                    return "contractId: integer expected";
            if (message.level != null && message.hasOwnProperty("level"))
                if (!$util.isInteger(message.level))
                    return "level: integer expected";
            if (message.includePastQuotes != null && message.hasOwnProperty("includePastQuotes"))
                if (typeof message.includePastQuotes !== "boolean")
                    return "includePastQuotes: boolean expected";
            if (message.requestId != null && message.hasOwnProperty("requestId"))
                if (!$util.isInteger(message.requestId))
                    return "requestId: integer expected";
            return null;
        };

        /**
         * Creates a MarketDataSubscription message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof cqg.MarketDataSubscription
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {cqg.MarketDataSubscription} MarketDataSubscription
         */
        MarketDataSubscription.fromObject = function fromObject(object, _depth) {
            if (object instanceof $root.cqg.MarketDataSubscription)
                return object;
            if (!$util.isObject(object))
                throw TypeError(".cqg.MarketDataSubscription: object expected");
            if (_depth === undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw Error("max depth exceeded");
            let message = new $root.cqg.MarketDataSubscription();
            if (object.contractId != null)
                if (Number(object.contractId) !== 0)
                    message.contractId = object.contractId >>> 0;
            if (object.level != null)
                if (Number(object.level) !== 0)
                    message.level = object.level >>> 0;
            if (object.includePastQuotes != null)
                if (object.includePastQuotes)
                    message.includePastQuotes = Boolean(object.includePastQuotes);
            if (object.requestId != null)
                if (Number(object.requestId) !== 0)
                    message.requestId = object.requestId >>> 0;
            return message;
        };

        /**
         * Creates a plain object from a MarketDataSubscription message. Also converts values to other types if specified.
         * @function toObject
         * @memberof cqg.MarketDataSubscription
         * @static
         * @param {cqg.MarketDataSubscription} message MarketDataSubscription
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        MarketDataSubscription.toObject = function toObject(message, options, _depth) {
            if (!options)
                options = {};
            if (_depth === undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw Error("max depth exceeded");
            let object = {};
            if (options.defaults) {
                object.contractId = 0;
                object.level = 0;
                object.includePastQuotes = false;
                object.requestId = 0;
            }
            if (message.contractId != null && message.hasOwnProperty("contractId"))
                object.contractId = message.contractId;
            if (message.level != null && message.hasOwnProperty("level"))
                object.level = message.level;
            if (message.includePastQuotes != null && message.hasOwnProperty("includePastQuotes"))
                object.includePastQuotes = message.includePastQuotes;
            if (message.requestId != null && message.hasOwnProperty("requestId"))
                object.requestId = message.requestId;
            return object;
        };

        /**
         * Converts this MarketDataSubscription to JSON.
         * @function toJSON
         * @memberof cqg.MarketDataSubscription
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        MarketDataSubscription.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the type url for MarketDataSubscription
         * @function getTypeUrl
         * @memberof cqg.MarketDataSubscription
         * @static
         * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
         * @returns {string} The type url
         */
        MarketDataSubscription.getTypeUrl = function getTypeUrl(prefix) {
            if (prefix === undefined)
                prefix = "type.googleapis.com";
            return prefix + "/cqg.MarketDataSubscription";
        };

        return MarketDataSubscription;
    })();

    return cqg;
})();

export {
  $root as default
};
